const resources = {
  translation: {
    DASHBOARD: {
      LOCATION_CARD: {
        HEADER: {
          SUBTITLE: {
            NO_DATA: '0',
            ALARM: '{{count}} Alarm',
            ALARM_plural: '{{count}} alarmer',
            ALARM_noData: '0 Alarmer',
            NORMAL: 'Normal',
},
          INFO: {
            SEPARATOR : ' ,',
            DEVICE: '{{count}} enhet',
            DEVICE_plural: '{{count}} enheter',
            SITE: '{{count}} nettsted',
            SITE_plural                    : '{{count}} nettsteder',
            DEVICE_noData: '0 enheter',
            SITE_noData  : '0 nettsteder',
},
},
        BODY: {
          ALARMS: '{{count}} Alarm',
          ALARMS_plural: '{{count}} alarmer',
          EVENTS: '{{count}} hendelse',
          EVENTS_plural: '{{count}} hendelser',
          ALARMS_noData: '0 Alarmer',
          EVENTS_noData: '0 hendelser',
},
        FOOTER: {
          VIEW_LOCATION: 'Se plassering',
},
},
      SITE_CARD: {
        HEADER: {
          SUBTITLE: {
            NO_DATA: '--',
},
          INFO: {
            DEVICE: '{{count}} enhet',
            DEVICE_plural: '{{count}} enheter',
            DEVICE_noData: '0 enheter',
},
},
        BODY: {
          ONLINE_noData: '--\'',
          ALARMS: '{{count}} Alarm',
          ALARMS_plural: '{{count}} alarmer',
          EVENTS: '{{count}} hendelse',
          EVENTS_plural: '{{count}} hendelser',
          ALARMS_noData: '0 Alarmer',
          EVENTS_noData: '0 hendelser',
          OFFLINE: 'Frakoblet',
          ONLINE: 'Online',
},
        FOOTER: {
          VIEW_LOCATION: 'Vis nettstedet',
},
},
      TIMELINE_DETAILS: {
        ACKNOWLEDGED: 'ANVENDT',
        OPEN: 'AKTIV',
        CLOSED: 'LUKKET',
        EARLIER: 'tidligere',
        FUTURE: 'Framtid',
        INACTIVE: 'INAKTIV',
        LAST_WEEK: 'Forrige uke',
        THIS_WEEK: 'Denne brukeren kan ikke overvåke systemene før de godtar en invitasjon på den oppgitte e-posten.',
        TIMELINE: 'Tidslinje',
        TODAY: 'I dag',
        UNACKNOWLEDGED: 'IKKE ANVENDT',
        YESTERDAY: 'I går',
},
      ADD_BUILDING: ' Legg bygning til',
      AUTO_REDIRECT_BANNER: {
        ADD_LOCATION_BUTTON: 'Legg til plassering',
        DISMISS: 'Avskjedige',
        MESSAGE: 'Du er automatisk omdirigert til {{location}} siden du ikke har noen andre toppnivåplasseringer.',
},
      USERS_ADMIN: 'Admin',
      USERS_ADMIN_S: 'Administratorer',
      ADMINS_TITLE: 'Administratorer',
      SITE_DETAILS: {
        READING_CARDS: {
          ALARM: 'Alarm',
          BATTERY: 'Batteri',
          FULL: 'Full',
          OFFLINE: 'Frakoblet',
          ONLINE: 'Online',
          PENDING: 'I påvente av',
          UNKNOWN: 'Ukjent',
          VIEW_ALL: 'Vis alle',
},
        ALL_DETAILS: 'Alle detaljer',
        ALL_DEVICES: 'Alle enheter',
        TRENDS_CARD: {
          CHANNELS: 'Kanaler',
          DAY: 'Dag',
          DAYS: 'Dager',
          TITLE: 'Trender',
          TRENDVIEWER: 'Trendviewer',
          VIEW_ALL: 'Se hele Trendviewer',
},
        DEVICES_CARD: {
          TITLE: 'Enheter',
          VIEW_ALL: 'Vis alle enheter',
},
        TIMELINE_CARD: {
          TITLE: 'Tidslinje',
          VIEW_ALL_EVENTS: 'Se alle hendelser',
},
},
      ALL_BUILDINGS_COUNT: 'Alle bygninger ({{count}})',
      ALL_LOCATIONS: 'Alle steder',
      ALL_ORGANIZATION: 'Alle organisasjoner',
      ALL_DEVICES_COUNT: 'Alle systemer ({{count}})',
      ADMINS_AND: 'og',
      DASHBOARD_ASSETS_TITLE: 'Eiendeler',
      STATUS_BLOCKED: 'Blokkert',
      STATUS_COUNT_BLOCKED: 'Blokkert ({{count}})',
      BUILDING_CONTACT: 'Byggekontakt',
      BUILDING_CONTACT_DETAILS_LABEL: 'Bygningskontaktdetaljer',
      CHOOSE_LOCATION: 'Velg Sted',
      CONTACT_MANAGER: ' Kontakt din kontoadministrator eller',
      ADD_ORGANIZATION: 'Opprett organisasjon',
      OVERVIEW_TITLE: 'Dashbord',
      DASHBOARD_TITLE: 'Dashbord',
      DEVICES_TITLE: 'Enheter',
      EARLIER: 'tidligere',
      EDIT_CONTACT_BUTTON: 'Rediger kontaktdetaljer',
      BUILDING_DETAIL_EMAIL: 'E-post',
      STATUS_EMPTY: 'Tømme',
      STATUS_COUNT_EMPTY: 'Tom ({{count}})',
      ERROR_LOADING_CHANNELS: 'Feil ved lasting av kanaler',
      ERROR_LOADING_DATA: 'Feil ved lasting av data',
      ERROR_LOADING_DEVICES: 'Feil ved lasting av enheter',
      ERROR_LOADING_EVENT: 'Feil ved innlasting av hendelse',
      ERROR_LOADING_EVENTS: 'Feil ved innlasting av hendelser',
      ERROR_LOADING_LOCATION: 'Feil ved innlasting av plassering',
      ERROR_LOADING_LOCATIONS: 'Feil ved innlasting av plasseringer',
      ERROR_LOADING_ORGANIZATION: 'Feil ved innlasting av organisasjon',
      ERROR_LOADING_SITE: 'Feil ved innlasting av nettsted',
      ERROR_LOADING_SITES: 'Feil ved innlasting av nettsteder',
      ERROR_LOADING_TRENDS: 'Feil ved innlasting av trender',
      EVENT_NOT_FOUND: 'Hendelse ikke funnet',
      STATUS_ANOMALY: 'I Anomali',
      STATUS_COUNT_ANOMALY: 'I anomali ({{count}})',
      LAST_90_DAYS: 'Siste 90 dager',
      LATEST_LOGS: 'Siste logger',
      LOCATION_NOT_FOUND: 'Sted ikke funnet',
      LOCATIONS_TITLE: 'Steder',
      LOCATION: 'steder',
      DASHBOARD_LOGBOOK_TITLE: 'Loggbok',
      MAIN_CONTACT_LABEL: 'Hovedbygningskontakt',
      ADMINS_MORE: 'flere',
      DASHBOARD_MANAGE_ORGANIZATION_TITLE: 'Mine organisasjoner',
      NO_FOUND: 'Ingen {{entity}} funnet',
      NO_EVENTS: 'Ingen alarmer',
      NO_CHANNELS: 'Ingen kanaler',
      NO_CHANNELS_ENABLED: 'Ingen kanaler aktivert',
      NO_DATA: 'Ingen data',
      NO_DATA_POINTS: 'Ingen data for datoperiode spesifisert',
      NO_DEVICES: 'Ingen enheter',
      NO_LOCATION_SELECTED: 'Ingen plassering er valgt',
      NO_LOCATIONS: 'Ingen plasseringer',
      NO_ORGANIZATION_SELECTED: 'Ingen organisasjon valgt',
      NO_SITES: 'Ingen nettsteder',
      NO_TRENDS: 'Ingen trender',
      NO_USER_DATA: 'Ingen brukerdata',
      STATUS_COUNT_OFFLINE: 'OFFLINE ({{count}})',
      ORGANIZATION_TITLE: 'ORGANISASJON',
      ORGANIZATION_NOT_FOUND: 'Organisasjon ikke funnet',
      ORGANIZATION: 'organisasjoner',
      BUILDING_DETAIL_PHONE: 'Telefon',
      PLATFORM_USER_DASHBOARD_WARNING: 'Gå til nettapplikasjonen for å utforske alle funksjonene',
      PROJECT: 'PROSJEKT',
      STATUS_READY: 'Ferdig',
      STATUS_COUNT_READY: 'Klar ({{count}})',
      DASHBOARD_REPORTS_TITLE: 'Rapporter',
      SAVE_USER_DETAILS: 'Lagre brukerdetaljer',
      SECONDARY_CONTACT_LABEL: 'Sekundær bygningskontakt',
      SITE_NOT_FOUND: 'Nettstedet ble ikke funnet',
      SITE: 'nettsteder',
      TIMELINE_TITLE: 'Tidslinje',
      NEW_SITE: 'for å bli med eller opprette ny {{entity}}.',
      UNKNOWN_DEVICE_TYPE: 'Ukjent',
      EDIT_USER_DETAILS: 'Brukerdetaljer',
      USERS_TITLE: 'Brukere',
      VIEW_LOGBOOK: 'Se loggbok',
      USERS_VIEWER: 'Seer',
      USERS_VIEWER_S: 'Seer',
      NOT_ACCESS: 'Du har ikke tilgang til noen {{entity}} ennå.',
      STARRED_ORGANIZATIONS: 'Vis kun stjernemerkede organisasjoner',
},
    EVENT_DETAILS: {
      UNKNOWN: '--',
      ACKNOWLEDGE: 'Bekrefte',
      ACKNOWLEDGED: 'Erkjent',
      ACKNOWLEDGE_BY: ' Godkjent av {{user}} kl',
      ACKNOWLWEGED_ERROR: ' Bekreftelsen kunne ikke kommunisere til sluttenheten {{errorDate}}. Hvis dette problemet vedvarer, kan du ringe brukerstøtteteamet vårt på {{phoneno}} eller sende e-post',
      DEVICE_MODEL: 'Enhetsmodell',
      DEVICE_SERIAL: 'Enhetsserie',
      ERROR_LOADING_DEVICE_DETAILS: 'Feil ved innlasting av enhetsdetaljer',
      ERROR_LOADING_EVENT_DETAILS: 'Feil ved innlasting av hendelsesdetaljer',
      TITLE: 'Begivenhetsdetaljer',
      ALARM_STATUS: 'Innledende alarmstatus',
      LAST_DATA_RECEIVED: 'Siste alarmoppdatering mottatt',
      NO_DEVICE_DETAILS: 'Ingen enhetsdetaljer',
      NO_EVENT_DETAILS: 'Ingen hendelsesdetaljer',
      PLEASE_RETRY: ' Vennligst prøv på nytt:',
      SENDING: 'Sender …',
      SET_POINT: 'Settpunkt (terskel)',
      THRESHOLD: 'Terskel',
      TIME_ALARM_SENT: 'Tid for første alarm sendt',
},
    DEVICE_DETAILS: {
      EMPTY_VALUE: '--\'',
      USERS_ADMINS: 'admin',
      USERS_VIEWER: 'seer',
      FIRMWARE_AVAILABLE_GUIDE_LINK: '(Guide)',
      USERS_COUNTS: '{{adminCount}} administrator, {{viewerCount}} seer',
      FIRMWARE_AVAILABLE_GUIDE: '{{availableVersion}} Tilgjengelig',
      LUMINARY_ATSD: 'ATSD #',
      CONNECTION_TYPE_BLE: 'BLE',
      BLOCK: 'Blokkert',
      BUILDING: 'Bygning',
      CONNECTION_TYPE_CELLULAR: 'Cellular',
      LUMINARY_CIRCUIT: 'Krets',
      LUMINARY_CIRCUIT_HASH: 'Krets #',
      CITY: 'By',
      CONNECTED: 'Tilkoblet',
      CONNECTION_TYPE: 'Tilkoblingstype',
      DATE_COMMISSIONED: 'Dato idriftsatt',
      DEVICE_MODEL: 'Enhetsmodell',
      DEVICE_SERIAL: 'Enhetsserie',
      DURATION_TEST: ' Varighet Test',
      DURATION_TEST_DURATION: 'Varighet Test Varighet',
      ERROR: 'Feil',
      CHANNEL_DATA_ERROR: 'Feil ved innlasting av kanaldata',
      DEVICE_CONNECTION_ERROR: 'Feil ved innlasting av tilkoblingsdata',
      DEVICE_DETAILS_ERROR: 'Feil ved innlasting av enhetsdetaljer',
      CONNECTION_TYPE_ETHERNET: 'Ethernet',
      EVENT: 'Hendelse',
      FIRMWARE_VERSION: 'Fastvareversjon',
      FUNCTIONAL_TEST: 'Funksjonstest',
      DELAY_FUNCTIONAL_TEST: 'Funksjonell testforsinkelse',
      GATEWAY_ADDRESS: 'Gateway-adresse',
      GATEWAY_NAME: 'Gateway navn',
      GATEWAY_COUNT: 'Gateway til systemet {{systemCount}}',
      GATEWAY_COUNT_SYSTEMS: 'Gateway til {{systemCount}} systemer',
      GATEWAYS: 'Porter',
      HOSTNAME: 'Vertsnavn',
      LUMINARY_DETAIL_INFO: 'Info',
      IPADDRESS: 'IP-adresse',
      LAST_DATA: 'Siste data',
      LUMINAIRE: 'Armatur',
      LUMINARY_ADDRESS: 'Armaturadresse',
      LUMINAIRES: 'Armaturer',
      LUMINARIES_COUNTS: 'Armaturer',
      MAC_ADDRESS: 'Mac-adresse',
      CONNECTION_TYPE_MODBUS: 'Modbus',
      LUMINARY_MODEL: 'Modell',
      CONNECTION_TYPE_MQTT: 'MQTT',
      LUMINARY_NAME: 'Navn',
      NAME: 'Navn',
      NETWORK_DETAILS: 'Nettverksdetaljer',
      NEXT: 'Neste',
      LUMINARY_DISCRIPTION: 'Neste varighetstest starter',
      NEXT_DURATION_TEST: 'Neste varighetstest starter',
      NEXT_FUNCTIONAL_TEST: 'Neste funksjonstest starter',
      NO_CHANNEL_DATA: 'Ingen kanaldata',
      NO_DEVICE_CONNECTION: 'Ingen enhetstilkoblingsdata',
      NO_DEVICE_DETAILS: 'Ingen enhetsdetaljer',
      OFFLINE: 'Frakoblet',
      ONLINE: 'Online',
      ORGANIZATION: 'Organisasjon',
      PART_NUMBER: 'Delenummer',
      PREVIOUS: 'Forrige',
      PREVIOUS_DURATION_TEST: 'Forrige varighet Test startet',
      PREVIOUS_FUNCTIONAL_TEST: 'Tidligere funksjonstest startet',
      READY: 'Ferdig',
      CONNECTION_TYPE_RS485: 'RS485',
      SERIAL_NUMBER: 'Serienummer',
      GATEWAY_SHOW_ALL: 'Vis alle',
      STATUS: 'Status',
      LUMINARY_STATUS: 'Status',
      SUBNET_MASK: 'Subnettmaske',
      SYSTEM: 'SYSTEM',
      SYSTEMS: 'Systemer',
      LUMINARY_DETAIL_TEST: 'Tester',
      TYPE: 'Type',
      LUMINARY_TYPE: 'Type',
      UPDATE_REQUIRED: 'OPPDATERING KREVES',
      USERS: 'Brukere',
      WARNING: 'Advarsel',
      CONNECTION_TYPE_WIFI: 'WiFi',
      CONNECTION_TYPE_WIREPASS: 'Wirepas',
      UNASSIGNED: 'Ikke tilordnet',
},
    FORMS: {
      OPTIONAL: '(Valgfri)',
      BUILDING_COMPANY_ADDRESS: 'Adresselinje 1',
      BUILDING_COMPANY_ADDRESS2: 'Adresselinje 2 (valgfritt)',
      BUILDING_DETAILS: 'Bygningsdetaljer',
      CITY: 'By',
      USER_ADDRESS_1: 'Firmaadresselinje 1',
      USER_ADDRESS_2: 'Firmaadresselinje 2',
      COMPANY_NAME: 'Firmanavn',
      CONFIRM_PASSWORD: 'Bekreft passord',
      COUNTRY: 'Land *',
      HELPING_TEXT: 'Felter med en stjerne (*) er obligatoriske',
      FIRST_NAME: 'Fornavn',
      LAST_NAME: 'Etternavn',
      LOCAL_PRIMARY_EMAIL: 'Lokal primær kontakt e-postadresse',
      LOCAL_PRIMARY_CONTACT_INFO: ' Lokal primær kontaktinformasjon',
      LOCAL_SECONDARY_EMAIL: 'Lokal sekundær kontakt e-postadresse',
      LOCAL_SECONDARY_CONTACT_INFO: ' Lokal sekundær kontaktinformasjon',
      ORGANIZATION_ADDRESS_HEADER: 'Organisasjonsadresse',
      COMPANY_ADDRESS: 'Organisasjonsadresselinje 1',
      ADDRESS_LINE_2: 'Organisasjonsadresselinje 2',
      ORGANIZATION_DETAILS_HEADER: 'Organisasjonsdetaljer',
      PASSWORD: 'Passord',
      PASS_MATCH_ERROR: 'Passord stemmer ikke',
      PHONE_NUMBER: 'Telefonnummer',
      INVALID_CUSTOMER_NUMBER: 'Vennligst oppgi gyldig kundenummer',
      INVALID_EMAIL_ERROR: 'Vennligst oppgi gyldig e-postadresse',
      INVALID_DETAILS: 'Oppgi gyldige inndataparametere',
      INVALID_PHONE_NUMBER: 'Vennligst oppgi et gyldig telefonnummer',
      INVALID_POSTAL_CODE: 'Vennligst oppgi gyldig postnummer',
      INVALID_SLA_NUMBER: 'Oppgi et gyldig SLA-nummer på minst 8 tegn',
      POSTAL_CODE: 'Postnummer',
      PRIMARY_CONTACT_INFORMATION: 'Primær kontaktinformasjon',
      RESET_PASSWORD: 'Tilbakestill passord',
      TOGGLE_PASSWORD_VISIBILITY: 'Slå passordsynlighet',
      VERIFICATION_CODE: 'Verifikasjonskode',
},
    DUALSMART: {
      DS_LUMINARIES_FOUND: 'armaturer funnet',
      DS_CIRCUIT_READY: 'Kretsklar',
      DS_COMMUNICATION_FAILURE: 'Kommunikasjonssvikt',
      DS_DIMM_ERROR: 'Dim feil',
      DS_OVERCURRENT: 'Overstrøm',
      DS_SAVE_UPDATE_BUTTON: ' Lagre oppdatering',
      DS_SYNC_DATE_AND_TIME: 'Synkroniseringstestplan',
      DS_CONNECTED_POWER_INFO: '10W / 15VA',
      DS_SYSTEM_COMPONENTS_COUNT: '7 komponenter',
      DS_LUMINARIES_FOUND_TITLE: 'Det ble funnet armaturer på dette systemet.',
      DS_AE_ERROR: 'Ae feil',
      DS_ALL_STATUSES: 'Alle statuser',
      DS_ALL_TESTS_PASSED: 'Alle tester besto',
      DS_ESTIMED_GUIDELINE_ONE: 'Omtrent 10 år ved 20 °C',
      DS_ESTIMED_GUIDELINE_THREE: 'Omtrent 5 år ved 30 °C',
      DS_ESTIMED_GUIDELINE_TWO: 'Omtrent 7 år ved 25 °C',
      DS_BATTERY_CHARGER: 'Batteri / Lader',
      DS_BATTERY_CHARGE: 'Batterilading',
      DS_BATTERY_OPERATION: 'Batteridrift',
      DS_BLOCK_DEVICE: 'Blokker enhet',
      DS_BLOCK_DEVICE_INFO: 'Block Device Blokkerer nødfunksjonen og slår av kretsen',
      DS_BLOCK_SUCCESS: 'Blokkeringen ble utført',
      DS_BULB_ERROR_AC: 'Pærefeil AC',
      DS_BULB_ERROR_DC: 'Pærefeil DC',
      DS_CAPACITY: 'Kapasitet',
      DS_CHARGER_LEVEL: 'Ladenivå:',
      DS_CHARGING_ERROR: 'Ladefeil',
      DS_FUNCTIONAL_GUIDELINE: 'Velg en tid mellom 20 - 800 sekunder for at systemet skal kommunisere når det bytter til batteridrift for en test.',
      DS_CIRCUIT: 'Krets',
      DS_CIRCUIT_FAILURE: 'Kretsfeil',
      DS_CIRCUITS_INFO_HEADER: 'Kretsinformasjon:',
      DS_CIRCUITS_NO: 'Krets nr.',
      DS_CIRCUITS: 'Kretser',
      DS_COMPONENTS_DETAIL: 'Komponentdetaljer',
      DS_CONNECTED_POWER: 'Tilkoblet strøm:',
      DS_CRYSTALWAY: 'CrystalWay 20m',
      DS_DAYS_BETWEEN_THE_TEST: 'Dager mellom testene',
      DS_DC1: 'DC1',
      DS_DC2: 'DC2',
      DS_KEEP_DEEP_DISCHARGE: 'Dyputladningsbeskyttelse aktiv',
      DS_DELAY_ON_MAINS_RETURN: 'Forsinkelse på returnettet',
      DS_ESTIMED_GUIDELINE: 'Avhengig av omgivelsestemperaturen og forholdene på stedet:',
      DS_DESCRIPTION: 'Beskrivelse',
      DS_END_DURATION_TEST_POPUP: 'Vil du stoppe varighetstesten?',
      DS_DOUBLE_ADDRESS: 'Dobbel adresse',
      DS_DT_FORERUN: 'DT Pre-Run',
      DS_DEVICE_COMMISSIONING: 'Dobbel smart idriftsettelse',
      DS_PASSWORD: 'Dobbelt smart passord',
      DS_DURATION: 'Varighet',
      DS_DURATION_TEST: 'Varighet Test',
      DS_DURATION_TEST_SCHEDULE: 'Varighet Testplan',
      DS_EDIT_BATTERY_DETAILS: 'Rediger batteridetaljer',
      DS_DASH_EMPTY: 'Tømme',
      DS_ESTIMED_LIFESPAN: 'Estimert levetid',
      DS_EXIT_SIGN: 'Avslutt-skilt',
      DS_FAN_OPERATING_HOURS: 'Driftstimer for vifte',
      DS_FOUND: 'Funnet',
      DS_FT_FORERUN: 'FT Pre-Run',
      DS_FUNCTIONAL: 'Funksjonell',
      DS_FUNCTIONAL_LEAD_AND_TIME: 'Funksjonell ledetid',
      DS_FUNCTION_TEST: 'Funksjonstest',
      DS_FUNCTIONAL_TEST_SCHEDULE: 'Funksjonell testplan',
      DS_SYNC_DATE_AND_TIME_SUBTITLE: 'G-Nord» hovedkontor',
      DS_CIRCUITS_DESCRIPTION: 'Hjelp meg med beskrivelsen',
      DS_SEARCH_LUM_INFO_TEXT: ' Hvis du bare trenger å legge til armaturer Vennligst bruk alternativet Søk etter nye armaturer',
      DS_SEARCH_LUMS_POPUP_SUB_TITLE: 'Hvis du bare trenger å legge til nye armaturer, vennligst bruk alternativet Søk etter nye armaturer.',
      DS_INSTALLATION_DATE: 'Installasjonsdato',
      DS_INTERVAL: 'Intervall',
      DS_CIRCUITS_INFO: 'Nøkkel nødvendig. Begrenset område! Registrering nødvendig.',
      DS_LAST_DURATION_TEST_TIME: 'Testtid for siste varighet',
      DS_LIGHTANDBUILDING: 'Lys og bygg 2024',
      DS_LUMINAIRE_FAILURE: 'Feil på armatur',
      DS_LUMINAIRE_NAME: 'Armaturens navn',
      DS_LUMINARIES: 'armaturer',
      DS_MAINS_OPERATION: 'Nettdrift',
      DS_NEXT_TEST_DATE: 'Neste testdato',
      DS_NO_OPERATION_POSSIBLE: 'Ingen operasjon mulig',
      DS_NORMAL_OPERATION: 'Normal drift',
      DS_OPERATION_FAILED: 'Operasjonen mislyktes',
      DS_OVERTEMPERATURE: 'Overtemperatur',
      DS_OVERVOLTAGE: 'Overspenning',
      DS_PREV: 'Forrige',
      DS_READY_ON: 'Klar på',
      DS_RELEASE_DEVICE: 'Slipp enheten',
      DS_RELEASE_DEVICE_INFO: 'Release Device Bytter tilbake til drift.',
      DS_RELASE_SUCCESS: 'Utgivelsen ble utført',
      DS_SEARCH_LUM_WARNING_TEXT: 'Henter data. Vent noen sekunder og prøv å klippe eller kopiere på nytt.',
      DS_CIRCUIT_LUMINARIES_DESC: 'Henter data. Vent noen sekunder og prøv å klippe eller kopiere på nytt.',
      DS_SEARCH_COMPLETE: 'Søket er fullført',
      DS_SEARCH_GUIDLINE_ONE_TEXT: 'Søk etter alle installerte og adresserte armaturer',
      DS_SEARCH_ALL_LUMINARIES: 'Søk etter alle armaturer',
      DS_SEARCH_LUM_TEXT: 'Søk etter alle armaturer vil opprette en ny konfigurasjon ved å gjøre følgende:',
      DS_SEARCH_LUMS_POPUP_TITLE: 'Hvis du starter søket, slettes alle aktiverte armaturer med en defekt fra konfigurasjonen din.',
      DS_SEARCH_GUIDLINE_TWO_TEXT: 'Å starte søket vil slette alle aktiverte. defekte armaturer fra konfigurasjonen din',
      DS_STARTS: 'Starter',
      DS_SUMMARY_FT: 'Sammendrag av funksjonstest',
      DS_SYSTEM_COMPONENTS: 'Systemkomponenter',
      DS_SYNC_DATE_AND_TIME_TITLE: 'Testdatoer og tider',
      DS_TEST_INTERVAL: 'Testintervall',
      DS_TEST_LENGTH: 'Testlengde',
      DS_VIEW_CIRCUITS: 'Vis etter krets',
      DS_W: 'W:',
      DS_SEARCH_FOR_NEW_LUMINARIES: 'Søk etter nye armaturer',
      DS_SEARCH_LUM_NEW_TEXT: 'Søk etter nye armaturer for å legge til lyskonfigurasjonen din:',
      DS_SEARCH_NEW_LUM_GUIDLINE_ONE_TEXT: 'Dette vil automatisk tildele adresser til nye eller erstattede armaturer til lyskonfigurasjonen din.',
      DS_SEARCH_NEW_LUM_INFO_TEXT: 'Hvis du bare trenger å legge til armaturer Vennligst bruk alternativet Søk etter nye armaturer',
      DS_NEW: 'Ny',
      DS_MODULE_TYPE: 'Modultype',
      DS_SEARCH_IO_MODULES: 'Søk i I-Bus-moduler',
      DS_SEARCH_FOR_IO_MODULES: 'Søk etter IO-moduler',
      DS_SEARCH_IO_MODULES_TEXT: 'Søk etter IO-moduler opprett en ny konfigurasjon ved å gjøre følgende:',
      DS_SEARCH_GUIDELINE_IO_MODULES_TEXT: 'Søk etter alle installerte moduler på bussen for å konfigurere og programmere dem.',
      DS_SEARCH_IO_MODULES_BTN_TEXT: 'Søk etter IO-moduler',
      DS_SEARCH_IO_MODULES_POPUP_TITLE: 'Hvis modulene ikke er riktig tilkoblet, vil det permanent endre den brukte konfigurasjonen.',
      DS_SEARCH_IO_MODULES_POPUP_SUB_TITLE: 'Sørg for at alle tilkoblinger er riktige før du starter søket.',
      DS_PHYSICAL_MODULES: 'Fysiske moduler',
      DS_SUBSCRIBED_MODULES: 'Abonner',
      DS_MODULES_FOUND: 'Moduler funnet',
      DS_MODULE_NUMBER: 'Modul nr.',
      DS_SEARCHING: 'Søker...',
      DS_TIMER: 'Timer',
      DS_SET_TIMER: 'Still inn timer',
      DS_SUBMIT_CHANGES: 'Send inn endringer',
      DS_TIMER_1: 'Timer 1',
      DS_TIMER_2: 'Timer 2',
      DS_TIME_TITLE: 'Timertittel (valgfritt)',
      DS_DAYS: 'Ukedager og tid',
      DS_ACTIVE_DAYS: 'Velg ukedager du vil at ___ skal være aktiv.',
      DS_START_TIME: 'Starttid',
      DS_END_TIME: 'Slutttid',
      DS_SET_RELAY_BUZZER: 'Still inn relésummer',
      DS_RESET_TO_DEFAULT_VALUES: 'Tilbakestill til standardverdier',
      DS_RESET_TO_DEFAULT_VALUES_INFO: 'Velg utgangen for å tilordne funksjonene. Trykk på "Lagre" når du er ferdig.',
      DS_SEARCH_NEW_LUMINARIES_INFO: 'Bruk disse resultatene til å lage og dele en ny lyskonfigurasjon ved å bruke "Eksporter".',
      DS_RELAY_NO: 'Relé nr.',
      DS_RESET_RELAY_BUZZER_POPUP_TITLE: 'Vennligst bekreft',
      DS_RESET_RELAY_ONE_TO_DEFAULT: 'Tilbakestill relé 1 til standard',
      DS_RESET_RELAY_BUZZER_TO_DEFAULT: 'Tilbakestill releer og summer til standard',
      DS_UNSAVED_CHANGES_POPUP_TITLE: 'Det er ulagrede endringer',
      DS_UNSAVED_CHANGES_POPUP_SUB_TITLE: 'Du lagret ikke endringene i Relay 1. Vil du lagre?',
      DS_DISCARED_CHANGES: 'Forkast endringer',
      DS_CIRCUIT_TITLE: 'Armaturer som er slått på/av i dette vinduet vil gå tilbake til konfigurert tilstand etter at systemet fullfører sin neste bytteoperasjon.',
      DS_EMPTY: 'Tom / Feil',
      LUM_TITLE: 'Trykk på armaturer for å slå dem av og på',
      ALL_OFF: 'Alt av',
      DS_RESET_TITLE: 'Tilbakestill til standard',
      DS_CONTROL_LUM: 'Kontroller armaturer',
      DS_LUM_BUTTON: 'Slå armaturer på/av',
      DS_APPLY: 'Søke',
      DS_SET_IO_BUS_MODULES_TITLE: 'Sett I-Bus-moduler',
      DS_NEXT_MODULE: 'Lagre og flytt til neste modul',
      DS_MODULE_DETAILS: 'Moduldetaljer',
      DS_MODULE_NAME: 'Modulnavn',
      DS_LOCAL_ONLY: 'Kun lokalt',
      DS_PUBLISH: 'Utgi',
      DS_SUBSCRIBE: 'Abonner',
      DS_ACU_BUS_ID: 'ACU buss-ID',
      DS_BUS_MODULE: 'Bussmodul',
      DS_INPUTS: 'Innganger',
      DS_CONFIGURED_MODULE_TITLE: 'Ingen faseovervåkingsinnganger er for øyeblikket konfigurert på denne modulen.',
      DS_CONFIGURE_INPUTS: 'Konfigurer innganger',
      DS_BLOCK: 'Blokkere',
      DS_RELEASE: 'Utgivelse',
      DS_BLOCK_GUIDLINE: 'Dette blokkerer nødfunksjonen og slår av kretsene.',
      DS_RUN_TESTS: 'Kjør tester',
      DS_LUMINARIE_CONTROLS: 'Armaturkontroller',
      DS_LUMINARIE_CONTROLS_GUIDELINE: 'Disse funksjonene lar deg overstyre armaturens konfigurerte programmering til de slås av.',
      DS_ALL_LUMINARIES_ON: 'Alle armaturer på',
      DS_INACTIVE: 'Inaktiv',
      DS_MAINTAINED_LUMINARIES_OFF: 'Vedlikeholdes armaturer av',
      DS_NON_MAINTAINED_LUMINARIES_OFF: 'Ikke-vedlikeholdte armaturer på',
      DS_RESET_SYSTEM_STATE: 'Tilbakestill systemtilstand',
      DS_MANUAL_RESET: 'Manuell tilbakestilling',
      DS_RESET_ISO_FAILURE: 'Tilbakestill ISO-feil',
      DS_RECHARGE_DEEP_DISCHARGE_PROTECTION: 'Tilbakestill beskyttelsen mot dyp utladning',
      DS_SIMULATE_MAINS_FAILURE: 'Simuler strømbrudd',
      DS_SEARCH_ISO_FAILURE: 'Søk ISO feil',
      DS_SET_I_BUS_MODULES: 'Sett I-Bus-moduler',
      DS_COMMISSIONING: 'Igangkjøring',
      DS_DATE_AND_TIME: 'Dato og tid',
      DS_RESET_SERVICE_CENTER: 'Tilbakestill serviceteller',
      DS_ALERT_LEVEL: 'Varslingsnivå',
      DS_DRY_CONTACT: 'Tørr kontakt',
      DS_BUILDING_MANAGMENT_SYSTEM: 'Building Management System (BMS)',
      DS_MODBUS: 'Modbus',
      MANAGE_INTERNET_CONNECTION: 'Administrer Internett-tilkobling',
      INTERNET_CONNECTION: 'Internett-tilkobling',
      SUB_LOCATION: 'Underplassering',
      TIME_PERIOD_NINTY_DAYS: 'Hver 90. dag',
      DS_SEARCH_ISO_FAILURE_TITLE: 'Søk etter isolasjonsfeil?',
      DS_SEARCH_ISO_FAILURE_BODY: 'Vennligst trykk "Søk" for å finne berørte kretser hvis du mottar en ISO-feilmelding.',
      DS_SEARCH: 'Søk',
      DS_MAIN_FAILURE_MSG: 'Dette vil simulere DC-drift og vare i ca. 5 sekunder før det går tilbake til normal drift.',
      DS_START: 'Start',
      DS_DEEP_DISCHARGE: 'Beskyttelse mot dyp utladning',
      DS_DEEP_DISCHARGE_MSG: 'Ved å velge "Acknowledge" bekrefter du at du har sett at systemets batterier går inn i en tilstand av dyp utlading',
      DS_ACKNOWLEDGE: 'Bekrefte',
      DS_RESET_ISO: 'Tilbakestille isolasjonsfeil?',
      DS_RESET_ISO_MSG: 'Dette vil tilbakestille meldingen om isolasjonsfeil.\n\nHvis ISO-feilen gjentar seg og ingen årsak kan identifiseres etter å ha kontrollert de siste kretsene, vennligst kontakt serviceavdelingen',
      DS_RESET: 'Tilbakestill',
      DS_MANUAL_RESET_TITLE: 'Utføre manuell tilbakestilling?',
      DS_MANUAL_RESET_MSG: 'Alle sikkerhetsarmaturer vil gå tilbake til normal drift basert på deres programmering',
      DS_BLOCK_TITLE: 'Blokkere systemet og avslutte varighetstesten?',
      DS_CONFIRM_BLOCK: 'Bekreft og blokker',
      DS_BLOCK_TEXT: 'Batteriet må lades opp i minst 24 timer før det utføres en ny varighetstest.',
      TRIGGERS: 'Utløsere',
      DEFAULT_TRIGGERS

   : 'Standardutløsere',
      OPTIONAL_TRIGGERS: 'Valgfrie utløsere',
      ADD_TRIGGER: 'Legg til trigger',
      SELECT_TRIGGERS: 'Velg Utløsere',
      ASSIGN_TRIGGERS: 'Tilordne utløsere',
      SELECTED: 'Valgt',
      INSTALLED: 'Installert',
      SCENARIO: 'Scenario',
      LUMINARIES_COUNT: '10 av 10 armaturer',
      DS_INPUT_OF_PHASE_MONITOR: 'Inngang av en fasemonitor',
      DS_CIRCUIT_TRIGGERS_SUCCESSFULLY_LINE: 'Krets nr. 1-utløsere ble konfigurert.',
      DS_SET_OTHER_CIRCUIT_TRIGGERS: 'Still inn andre kretstriggere',
      DS_ASSIGN_DEFAULT_TRIGGERS_GUIDELINE: 'Trykk eller dra over armaturer for å tilordne dem til denne utløseren.',
      DS_ASSIGN_TRIGGERS_GUIDELINE_TWO: 'Vennligst bekreft hver trigger for krets 1.',
      DS_NON_MAINTAINED_LIGHT: 'Ikke-vedlikeholdt lys',
      DS_MAINTAINED_LIGHT: 'Opprettholdt lys',
      DS_INSTALLED_LUMINARIES: 'Installerte armaturer',
      DS_TIMER_SCHEDULE: 'Ukedagsplan',
      DS_DEEP_DISCHARGE_TITLE: 'Dyp utladning',
      DS_STIMULATE_MAIN_FAILURE: 'Stimulere hovedsvikt',
      DS_START_FUNCTIONAL_TEST: 'Start funksjonstest',
      DS_SHORT_LEAD_TIME: 'Bruk kort leveringstid',
      DS_ASSIGNED_PHASE_MONITORING_INPUT: 'Tilordnede faseovervåkingsinnganger',
      DS_INPUT_CONFIGURATION_TITLE: 'Inngangskonfigurasjon',
      DS_ASSIGNED_FUNCTION: 'Tildelt funksjon',
      DS_PHASE_MONITORING_INPUT: 'Faseovervåkingsinnganger L1/L2/L3',
      DS_RESET_OPTION: 'Tilbakestill alternativ',
      DS_LENGTH_OF_TIME: 'Lengde på tid (minutter)',
      DS_PHASE_MONITOR: ': Fasemonitor',
      NO_FUNCTION: 'Ingen funksjon',
      ALL_LUM_ON: 'Alle armaturer på',
      MANNUAL_RESET: 'Manuell tilbakestilling',
      INVERSE_SWWITCH: 'invers bryter',
      SWITCH_OFF_MAINTAINED_LIGHT: 'slå av vedlikeholdt lys',
      ALL_LUMINARIES_ON: 'alle armaturer PÅ',
      VENTILATION_MONITORING: 'ventilasjonsovervåking',
      EXT_MONITOR: 'Ext. Følge',
      SWITCH: 'bryter',
      DELAY_ON_MAINS_RETURN: 'Forsinkelse på returnettet',
      VIA_THE_APP: 'Via appen',
      DURATION_TEST_COMPLETE: 'Varighetstest fullført',
      FUNCTIONAL_TEST_COMPLETE: 'Funksjonstest fullført',
      MODBUS: {
        MANUAL_RESET: 'Manuell tilbakestilling',
        RESET_DEEP_DISCHRGE_PROTECTION: 'Tilbakestill beskyttelsen mot dyp utladning',
},
      DS_FINISH: 'Fullfør',
      DS_EXT_MONITOR: 'Ext. Følge',
      NORMAL_OPERATION: 'Normal drift',
      CIRCUIT_FAILURE: 'Kretsfeil',
      DEEP_DISCHARGE: 'Dyp utladning',
      DS_BATTERY: 'Batteri',
      DS_SERIAL_NUMBER: 'Serienummer',
      DS_SET_INPUT_CONFIG: {
        ASSIGNED_FUNCTION: {
          NO_FUNCTION: 'Ingen funksjon',
          ALL_LUM_ON: 'Alle armaturer på',
          MANNUAL_RESET: 'Manuell tilbakestilling',
          INVERSE_SWWITCH: 'invers bryter',
          SWITCH_OFF_MAINTAINED_LIGHT: 'slå av vedlikeholdt lys',
          VENTILATION_MONITORING: 'ventilasjonsovervåking',
          EXT_MONITOR: 'Ext. Følge',
          SWITCH: 'bryter',
},
        RESET_OPTION: {
          MANNUAL_RESET: 'Manuell tilbakestilling',
          DELAY_ON_MAINS_RETURN: 'Forsinkelse på returnettet',
},
        LENGTH_OF_TIME: {
          VIA_THE_APP: 'Via appen',
},
},
      BUZZER: {
        NORMAL_OPERATION: 'Normal drift',
        CIRCUIT_FAILURE: 'Kretsfeil',
        DEEP_DISCHARGE: 'Dyp utladning',
},
      DS_SYSTEM_MODULE_TYPE: 'Type',
      EMPTY: 'Tømme',
      DS_BLOCKED: 'Blokkert',
      DS_NAME: 'Navn',
},
    LOGBOOK_DETAILS: {
      LABEL_EVENT_AGO: 'siden',
      PART_NUMBER: ' PN:',
      SERIAL_NUMBER: ' SN:',
      ADD_COMMENTS: '+ Legg til kommentarer...',
      REQUIRES_FIRMWARE_UPDATE: '1 KREVER FIRMWARE-OPPDATERING',
      ACKNOWLEDGE: 'Bekrefte',
      ACKNOWLEDGED: 'Erkjent',
      ACKNOWLEDGED_BY: 'Godkjent av',
      PREVIOUS_ACKNOWLEDGED_BY: ' Godkjent av:',
      ACTIVE: 'Aktiv',
      ACTIVE_ACKNOWLEDGED: 'Aktiv . Erkjent',
      AT: 'på',
      LABEL_CLOSED: 'lukket',
      CLOSED: 'Lukket',
      COMMENTS: 'Kommentarer',
      DESCRIPTION: 'Beskrivelse',
      DEVICE: 'Enhet',
      EDIT: 'Redigere',
      EVENT: 'Hendelse',
      LABEL_EVENT_BEGAN : ' Begivenheten startet:',
      LABEL_EVENT_CLOSE: ' Arrangement stengt:',
      LOGBOOKDETAIL: 'LoggbokDetalj',
      NO_PREVIOUS_LOG_TITLE: 'Ingen tidligere loggelement på dette systemet',
      PARTNO: ' PN:',
      PREVIOUS_LOG_ITEM: 'Forrige loggelement på dette systemet',
      PREVIOUS_LOG_TITLE: 'Forrige loggelement på dette systemet',
      SERIALNO: ' SN:',
      STATUS: 'Status',
      SYSTEM: 'System',
      TIMESTAMP: 'Tidsstempel',
      SYSTEM_TYPE : ' Type:',
},
    ORGANIZATION_MANAGE: {
      BUILDING_COUNT: 'Bygning',
      BUILDING_COUNT_S: 'Bygninger',
      ORGANIZATION_MANAGE: 'Bygninger',
      ADMIN_COUNT: ' Organisasjonsadmin',
      ADMIN_COUNT_S: 'Organisasjonsadministratorer',
      VIEWER_COUNT: 'Organisasjonsvisning',
      VIEWER_COUNT_S: 'Organisasjonsseere',
      SYSTEM_COUNT: 'System',
      SYSTEM_COUNT_S: 'Systemer',
      ADD_NEW_BUILDING: '+ Legg til ny bygning',
      CREATE_ORGANIZATION: '+ Opprett organisasjon',
      ERROR_ADD_NEW_SYSTEM_ACTION: 'Legg til nye systemer',
      ALL: 'Alle',
      SORT_TYPE_NAME: 'Alfabet',
      SORT_TYPE_CITY: 'By',
      COMMENTS_HELPER: 'Kommentarer for å hjelpe teknikere med å komme på stedet.',
      ORGANIZATION_NAME_HELPER: 'Kun bokstaver, tall, understreker og bindestreker',
      MARK_AS_FAV_API_FAILURE_MESSAGE: 'Merk som mislykket',
      ERROR_NO_BUILDING_FOUND: 'Ingen bygning funnet',
      ERROR_NO_GATEWAY_FOUND: 'Ingen gateway funnet',
      ERROR_NO_LOGS_TITLE: 'Ingen logger i denne perioden',
      ERROR_NO_LUMINARY_FOUND: 'Ingen armaturer funnet',
      ERROR_NO_ORG_FOUND: 'Ingen organisasjon funnet',
      ERROR_NO_REPORT_FOUND: 'Ingen rapporter funnet',
      ERROR_NO_SYSTEM_FOUND: 'Finner ikke noe system',
      ERROR_NO_USER_FOUND: 'Ingen bruker funnet',
      SORT_TYPE_NUMBER_OF_SYSTEMS: 'Antall systemer',
      QUIT_EDIT_USER_DETAILS: 'Slutt å redigere',
      QUIT_TITLE: 'Vil du slutte å redigere «{{orgName}}»?',
      ERROR_READ_INSTALLATION_MANUALS_ACTION: 'Les installasjonsmanualer',
      SEARCH: 'Søk',
      SEARCH_BUILDINGS: 'Søk',
      SEARCH_BUILDINGS_DASHBOARD: 'Søk i bygninger',
      SEARCH_SYSTEM_DASHBOARD: 'Søkesystemer',
      SORT_BY_HEADER: 'SORTERT ETTER',
      STARRED_ORGANIZATIONS: 'Stjernemerkede organisasjoner',
      VIEW_ORGANIZATION: 'Se organisasjon',
      ERROR_NO_DEVICE_TITLE: 'Du har ingen ressurser i denne organisasjonen ennå.',
      ERROR_NO_DEVICE_DESCRIPTION: 'Du vil se statusinformasjon om nødlysene dine når du begynner å legge til eiendeler (systemer) til denne organisasjonen.',
      QUIT_MESSAGE: 'De ulagrede endringene dine ville gå tapt.',
},
    ADD_BUILDING: {
      BLDG_ORG_CONTACT: 'Kontakter',
      INVERTED_COMMAS_S: '\'s',
      BLDG_ORG_CONTACTS: 'sine kontakter',
      BLDG_ADDITIONAL_DESC: 'Legg til valgfrie tilleggskommentarer for å hjelpe serviceteamet ditt',
      BLDG_ADD_DESCRIPTION: 'Ytterligere beskrivelser',
      BLDG_ADDRESS: 'adresse',
      BLDG_CREATTION: 'Bygning opprettet',
      BUILD_CREATE_SUCESS: 'Bygningen ble opprettet',
      BLDG_HEADER: ' Lag et nytt bygg for',
      BLDG_LOCATION_MESSAGE: 'Dra kartet for å plassere nålen i nærheten av der bygningen befinner seg. Dette hjelper feltingeniører med å komme raskt på stedet i fremtiden.',
      BLDG_EDIT_BTN: 'Rediger kontaktdetaljer',
      BLDG_NAMELENGTH: ' Eks., Hovedkontor, Lager',
      BLDG_INITILIZING_NETWORK: 'Initialiserer nettverk...',
      BLDG_INSIDE: 'inni',
      BLDG_LOCAL_CONTACT: 'Lokal byggekontakt',
      BLDG_CONTACT_TITLE: 'Kontaktdetaljer for lokal bygning',
      BLDG_LOCATE_ON_MAP: 'Finn på et kart i stedet',
      BLDG_LOCATION: 'Sted',
      BLDG_ADDTIONAL_DETAILS: 'La oss nå legge til noen ekstra detaljer for å fullføre oppsettet for',
      ORG_CREATE_SUCESS: 'Organisasjonen ble opprettet',
      BLDG_ADDITION_ERROR: 'Vennligst skriv inn gyldig adresse.',
      BLDG_PRIMARYCONTACT: 'Primær kontakt',
      BLDG_PRIMARY_LOCAL_CONTACT: 'Primær lokal kontakt',
      BLDG_SECONDARYCONTACT: 'Sekundær kontakt (valgfritt)',
      BLDG_SECONDARY_LOCAL_CONTACT: 'Sekundær lokal kontakt',
      BLDG_NO_POSTAL_ADDRESS: 'Velg dette alternativet hvis en postadresse ikke er tilgjengelig',
      BLDG_CREATED_MESSAGE: 'Vellykket opprettet',
      BLDG_ORGANIZATION_FOR: ' Bruk organisering',
      BLDG_ADD_CONTACT: 'Hvem skal elektrikere kontakte om "Hovedkontor"',
      SAVE_CHANGES_MSG: 'Endringene dine er lagret',
},
    USER_SETTINGS: {
       AUTOMATIC_LOGOUT_SUBTITLE: 'Deaktiver automatisk utløp av økten etter 15 minutter',
      ALARMS: '.',
      PHONE_NO_TEXT: 'Et mobilnummer kreves for å motta sms-varsler',
      ACCOUNT: 'Konto',
      ACCOUNT_CREATED_DATE: 'Konto opprettet',
      ADDRESS: 'Adresse',
      ALARMS_TITLE: 'Alarmer',
      APPLICATION_THEME_COLOR: 'Søknadstemafarge',
      AUTOMATIC_LOGOUT: 'Automatisk utlogging',
      UNITS_DESCRIPTION: 'Britiske keiserlige enheter',
      BUILDING_NAME: 'Bygningens navn',
      TIMEZONE_DESCRIPTION: 'Sentraleuropeisk tid (GMT-1:00)',
      CHANGE_PASSWORD: 'Endre passord',
      COMPANY_ADDRESS: 'Firmaadresse',
      COMPANY_NAME: 'Firmanavn',
      COMPANY_PHONE_NUMBER: 'Selskapets telefonnummer',
      DATE_FORMAT: 'Datoformat',
      DATEFORMAT_DESCRIPTION: 'DD/MM/ÅÅÅÅ',
      DELETE_ACCOUNT: 'Slett konto',
      STATUS_UPDATES: 'Enheten er i blokkeringsmodus, nødmodus, vedlikehold forespurt',
      AUTOMATIC_LOGOUT_TITLE: 'Deaktiver automatisk utlogging',
      EMAIL: 'E-postadresse',
      EMAIL_NOTIFICATION: 'E-postvarsler',
      TEXT_NOTIFICATION_TITLE: 'Aktiver tekstvarsler (SMS)',
      ENABLED: 'Aktivert',
      TEXT_NOTIFICATION_BODY: 'Aktivering av SMS-varsler kan medføre ekstra tekstmeldingsgebyrer hos mobiloperatøren din. Disse avgiftene er ikke inkludert i Eatons serviceavtale.',
      LANGUAGE_DESCRIPTION: 'Engelsk - Storbritannia',
      HEALTH_REPORT_TITLE: 'Helserapport',
      LANGUAGE: 'Språk',
      HEALTH_REPORT: 'Månedlig rapportering',
      PRODUCT_UPDATES: 'Nye utgivelser, fastvareoppdatering tilgjengelig',
      NOTIFICATIONS_HEADER: 'Varsler',
      APP_THEME_DESCRIPTION: 'Operativsystemtema',
      ORGANIZATION: 'Organisasjon',
      ORGANIZATION_NAME: 'Organisasjonsnavn',
      PASSWORD: 'Passord',
      PHONE_NUMBER: 'Telefonnummer',
      PREFERENCES_HEADER: 'Preferanser',
      PRODUCT_UPDATES_TITLE: 'Produktoppdateringer',
      STATUS_UPDATES_TITLE: 'Statusoppdateringer',
      TEXT_NOTIFICATION: 'Tekstvarsler (SMS)',
      AUTOMATIC_LOGOUT_BODY: 'Denne nettapplikasjonen er inkompatibel med din nåværende nettleser. Denne uken Dette vil overstyre en standard sikkerhetsfunksjon inkludert i applikasjonen for å forhindre tilgang til en forlatt økt. Vær oppmerksom på at brukeren vil være ansvarlig for å beskytte uautorisert tilgang til dette systemet og bør aldri la denne applikasjonen være åpen når den er uten tilsyn.',
      TIME_ZONE: 'Tidssone',
      UNITS: 'Enheter',
      ORG_ADDRESS: 'Bruk organisasjonens adresse',
      ORG_CONTACT_DETAILS: 'Bruk organisasjonens kontaktdetaljer',
      EDIT_USER_DETAILS: 'Brukerdetaljer',
      NAME: 'Brukernavn',
      USER_NAME: 'Brukernavn',
      WARNING: 'ADVARSEL',
},
    EDITUSER: {
       PROMOTE_CONFIRMATION: 'Hvis dette var ment, vennligst send inn endringen.',
      DEMOTE_CONFIRMATION: 'Hvis dette var ment, vennligst gjør endringer nedenfor i Rolle/Plassering-delen av dette skjemaet.',
      DEMOTE: 'Du har endret denne organisasjonsadministratorens rolle. Hvis du ikke mente å gjøre dette - velg avbryt.',
      PROMOTE: 'Du har forfremmet denne brukeren til en organisasjonsadministrator. Hvis du ikke mente å gjøre dette - velg avbryt.',
},
    ADDUSER: {
      INVITEUSER: 'Inviter bruker',
      TITLE: 'Legg til bruker',
      ASTERIKSINFO: 'Felt merket med stjerne(*) er obligatoriske felt som er nødvendige for å invitere en bruker.',
      INVITESUCCESS: 'Vellykket invitasjon!',
      SELECTROLE: 'Velg en rolle for plassering(er)',
      ACCOUNTCREATED: 'Invitasjonen til å opprette en konto har blitt initiert.',
      EMAILRECEIVE: 'Brukeren vil motta en e-postinvitasjon til å opprette kontoen sin i løpet av 5-10 minutter. Du vil ikke kunne se statusen deres før de har godtatt invitasjonen.',
      ADDUSERINFORMATION: 'Brukerkontoprofilinformasjon',
},
    GATEWAY: {
      MANAGE_CELLULAR_CONNECTION: 'Administrer mobiltilkobling',
      TRANSFER_SYSTEM: {
        TRANSFER_SYSTEM_SELECTION_PAGE_TITLE: '{{gatewayName}} Gateway-systemer ({{systemCount}})',
        TRANSFER_SYSTEM_USERCONFIRMATION_TITLE: '{{gatewayName}}-systemer vil overføres til følgende brukere:',
        ADD_ANOTHER_USER: 'Legg til en annen bruker',
        ADMIN_RIGHT_REQUIRED: 'Administratorrettigheter kreves for å invitere bruker',
        REGISTER_USER_REQUIRED: 'Minst én registrert bruker kreves for overføring',
        EMAIL_ID_DUPLICATE: 'EmailId er duplikat eller ugyldig inndata',
        ADMIN_RIGHT_REQUIRED_FOR_SYSTEM_TRANSFER: 'Administratorrettigheter kreves for å overføre brukerenheter',
        DUPLICATE_ENTITY_ID: 'EntityId er duplikat eller ugyldig inndata',
        TRANSFER_SYSTEM_EXISTING_USER: 'Eksisterende brukere',
        INVALID_ENTITY_TYPE: 'Ugyldig enhetstype. Oppgi gyldig enhetstype',
        TRANSFER_SYSTEM_LOGED_IN_USER_MSG: 'Ugyldig bruker. Legg til en annen bruker.',
        INVITE_AS_COLLEAGUE: 'Inviter som kollega',
        TRANSFER_SYSTEM_NEW_USER: 'Nye brukere',
        TRANSFER_SYSTEM_ADD_EXISTING_USER: 'Legg til minst én eksisterende bruker for å overføre enheter.',
        INVALID_EMAIL_ADDRESS: 'Vennligst oppgi gyldig e-postadresse',
        INVALID_GATEWAY_ID: 'Vennligst oppgi gyldig gateway-ID',
        TRANSFER_SYSTEM_INFO: 'Velg en eksisterende bruker eller legg til en ny.',
        TRANSFER_SYSTEM_SYSTEM_SELECTION_HEADER: 'Vennligst velg systemet(e) du ønsker å overføre.',
        NO_DATA_FOUND: 'Forespurte data ble ikke funnet',
        TRANSFER_SYSTEM_SYSTEM_TRANSFER: 'Systemoverføring',
        TRANSFER_SYSTEM_CONFIRMATION_NEW_USER: ' Bruk funksjonen "Søk etter registrerte armaturer" i idriftsettelsesvinduet for å finne armaturene som ikke er inkludert i konfigurasjonen din.',
        TRANSFER_SYSTEM_PRIVILEGES: 'Overfør systemprivilegier',
        TRANSFER_TO: 'Overfør til',
        TRANSFER_USER_ALREADY_ADDED: 'Bruker Allerede lagt til',
        TRANSFER_SYSTEM_ALREADY_ADDED_USER: 'Brukeren er allerede lagt til i listen. Vennligst legg til en annen bruker.',
        TRANSFER_SYSTEM_USER_SELECTION_HEADER: 'Hvem vil du overføre disse systemene til?',
        ADD_USERS: 'Legg til brukere',
},
      ENTRY_PASSWORD_TITLE: 'Tilgang for',
      ADD_GATEWAYS: 'Legg til enhet',
      ADDING_GATEWAY_TITLE: 'Legger til «{{gatewayName}}» i {{orgName}}',
      CONNECT_TO_ELSYSTEM_FAILED_UREACHABLE_MSG: 'Gateway prøver å koble til systemet og kan ta mer tid, se statusen på System-fanen',
      RESET_GATEWAY_PASSWORD_SUCCESS: 'Gateway-passordet ble tilbakestilt.',
      BLE: {
        ERROR: {
          INVALID_IP_AADRESS: 'Ugyldig IP-adresse',
          CHANGE_FAILURE_MESSAGE: 'Det oppstod en feil under endring av parametere',
          NOT_FETCHING_SYSTEM_DETAILS: 'Kan ikke hente systemdetaljer',
          BUILDING_ALREADY_EXISTS: 'Bygningsnavnet finnes allerede',
          RESET_PASSWORD_FAILED: 'Forespørsel om tilbakestilling av passord mislyktes. Vennligst prøv igjen',
          INVALID_CONNECTION_STRING: 'Ugyldig tilkoblingsstreng',
          INVALID_UUID: 'Ugyldig UUID',
          ORGANIZATION_ALREADY_EXISTS: 'Organisasjonsnavnet finnes allerede',
          REQUEST_FAILED_TITLE: 'Forespørsel mislyktes',
          REQUEST_FAILED_GATEWAY_ADD: 'Forespørsel Kunne ikke legge til gateway.',
          REQUEST_FAILED_MESSAGE: 'Operasjonen kunne ikke fullføres. Vent noen minutter og prøv igjen.',
          UNAUTHORIZED_ACCESS: 'Uautorisert tilgang Logg på igjen',
          INVALID_DEVICE: 'Ugyldig enhet',
          GATEWAY_UNRECHABLE: 'Systemet er ikke tilgjengelig',
          MAX_LIMIT_SYSTEM_REACHED_TITLE: 'Maksgrensen for systemet er nådd',
          REQUEST_FAILED_WIRELESS_GATEWAY_ADD: 'Forespørsel mislyktes legg til trådløs gateway.',
          REQUEST_FAILED_LP_SMART_ADD: 'Forespørselen mislyktes om å legge til Dualsmart.',
          REQUEST_SUCCESS_BLE_DEVICE_ADD: 'Forespørsel mislyktes om å legge til enhet',
          DUPLICATE_SYSTEM_TITLE: 'Duplikatsystem',
},
        DEVICE_STATUS: {
          ALARM: 'Alarm',
          BLOCKED: 'Blokkert',
          NOT_PROVISIONED: 'Ikke tilrettelagt',
          OFFLINE: 'Frakoblet',
          ONLINE: 'Online',
          PROVISIONED: 'Forsynt',
          READY: 'Ferdig',
          READY_FOR_COMMISSION: 'Klar for igangkjøring',
          WARNING: 'Advarsel',
},
        DEVICE_TYPE: {
          ATPLUS_CONTROLLER: 'AT+-kontroller',
          COMMON_GATEWAY: 'Felles gateway',
          DGS: 'DGS',
          LPSMART: 'LPSmart',
          WIRELESS_GATEWAY: 'Trådløs gateway',
},
        SET_PASSWORD_STATUS: {
          INVALID_LENGTH: 'Ugyldig lengde',
          INVALID_PASSWORD: 'Ugyldig passord',
          PASSWORD_CHANGE_FAILURE: 'Feil ved endring av passord',
          PASSWORD_CHANGE_SUCCESS: 'Passordendring vellykket',
          PASSWORD_COMPARISON_FAIL: 'Passordsammenligning mislyktes',
},
        DEFAULT_LOGIN_STATUS: {
          LOGIN_DEFAULT_SUCCESS: 'Innloggingsstandard suksess',
          LOGIN_FAILURE: 'Påloggingsfeil',
          LOGIN_MAX_ATTEMPTS_EXCEEDED: 'Maks antall påloggingsforsøk er overskredet',
          LOGIN_SUCCESS_ADMIN: 'Pålogging suksess admin',
          LOGIN_SUCCESS_SERVICE: 'Påloggingssuksesstjeneste',
          LOGIN_SUCCESS_USER: 'Pålogging suksess bruker',
          LOGOUT: 'Logg ut',
},
        NULL_VALUE: 'Ingen respons',
        TURN_ON_BLE_MSG: 'Slå på Bluetooth for å gi "Building Safety Manager" tilgang til lokale systemer.',
        DISCONNECT_ALERT_SUBTITILE: 'Du er ikke lenger koblet til "{{gatewayName}}" Bluetooth. Sørg for at du er innenfor rekkevidde av Bluetooth for å fortsette.,',
        SUCCESS: {
          REQUEST_SUCCESS_GATEWAY_ADD: 'Gateway ble lagt til',
          REQUEST_SUCCESS_WIRELESS_GATEWAY_ADD: 'Trådløs gateway ble lagt til',
          REQUEST_SUCCESS_LP_SMART_ADD: 'Dualsmart ble lagt til',
          REQUEST_SUCCESS_BLE_DEVICE_ADD: 'Enheten ble lagt til',
},
        LOST_BLE_CONNECTION: 'Mistet Bluetooth-tilkobling',
},
      INVALID_SYSTEM_NUMBER: 'Ugyldig systemnummer',
      INVALID_USER_ACCESS_SYSTEM_UNLINK: 'Ugyldig bruker. Du har ikke tilgang til å koble fra systemet.',
      GATEWAY_DISCONNECT_ALERT: 'Er du sikker på at du vil koble fra?',
      DISCARD_CHANGES_ALERT: 'Er du sikker på at du vil forkaste endringer?',
      UNLINKEXISTING_SYSTEM_ALERT: 'Er du sikker på at du vil koble fra eksisterende system?',
      GATEWAY_UNREGISTER_ALERT: 'Er du sikker på at du vil avregistrere gateway?',
      AUTOMATICALLY_CONFIG_IP: 'Konfigurer IP-adresse automatisk',
      BACKUP_CONNECTION: 'Backup-tilkobling',
      TIMELINE_VIEW: {
        BUILDING: 'Bygning',
        OPTINAL: 'Valgfri',
        ORGANIZATION: 'Organisasjon',
        SELECT_BUILDING: 'Vennligst velg en bygning',
        SELECT_ORGANIZATION: 'Velg en organisasjon',
        SUB_LOCATION: 'Underplassering',
        SET_BACKUP_INTERNET_TITLE: 'Sett sikkerhetskopi av Internett-tilgang',
        SET_PRIMARY_INTERNET_TITLE: 'Angi Primær Internett-tilgang',
        INTERNET_CONNECTION_LABLE: 'Vennligst velg...',
        SET_INTERNET_CONNECTION_MSG: 'Koble til Internett først',
        SUB_LOCATION_LABLE: 'Sub stedsnavn...',
        DESCRIPTION_LABLE: 'Skriv notater for teamet ditt...',
        SEARCH_ALL_LUMINAIRES_TITLE: 'Søk etter alle armaturer',
},
      BLUETOOTH_SCAN_ERROR: ' Finner du ikke gatewayen din? Sjekke',
      CARRIER_NAME: 'Transportørnavn',
      CELLULAR: 'Cellular',
      CELLULAR_PROCESS_FAILED_MSG: 'Mobilkonfigurasjonsprosessen mislyktes. Vennligst prøv igjen.',
      CELLULAR_PROCESS_SUCCESS_MSG: 'Mobil konfigurert vellykket.',
      CELLULAR_CONNECTION: 'Mobiltilkobling',
      NO_BLUETOOTH_SUPPORT: 'Bluetooth støttes ikke på denne enheten',
      CHANGE_CONNECTION_METHOD: 'Endre tilkoblingsmetode',
      CHECK_FOR_UPDATES: 'Se etter oppdateringer',
      CONFIGURE_WI_FI_CONNECTION: 'Konfigurer Ethernet-innstillinger',
      CONFIGURE_CELLEULAR_CONNECTION: 'Konfigurer denne mobilforbindelsen',
      COMMISSION_NEW_GATEWAY: 'Koble til en Eaton Emergency  Belysningsenhet.',
      CONNECT_TO_ELSYSTEM_FAILED_MSG: 'Koble til EL-systemprosessen mislyktes. Vennligst prøv igjen.',
      CONNECTED: 'TILKOBLET',
      CONNECTED_TO: 'koblet til',
      CONNECTION_METHOD: 'Tilkoblingsmetode',
      GATEWAY_CONNECTION_PRIORITY: 'Tilkoblingsprioritet',
      CONNECTIONS: 'Tilkoblinger',
      GATEWAY_ADD_BUILDING_VALUE: 'Opprett et nytt bygg',
      GATEWAY_ADD_ORGANIZATION_VALUE: 'Opprett en ny organisasjon',
      SET_DATE_TIME_SUCCESS: 'Dato og klokkeslett er angitt',
      DEFAULT_PASSWORD_ADMIN_CHANGED: 'DEFAULT_PASSWORD_ADMIN_CHANGED',
      DEFAULT_PASSWORD_USER_CHANGED: 'DEFAULT_PASSWORD_USER_CHANGED',
      DISCONNECTED: 'Enheten er frakoblet eller kan ikke koble til. Prøv på nytt',
      DISCONNECTED_SUCCESS: 'Enheten er frakoblet',
      GATEWAY_UNREGISTER_SUCCESS: 'Informasjon om enhetsregistrering ble slettet',
      GATEWAY_UNREGISTER_FAILURE: 'Informasjon om enhetsregistrering ble slettet',
      DGS_NOT_COMMUNICATING: 'DGS kommuniserer ikke',
      DGS_UNREACHABLE: 'DGS utilgjengelig',
      DHCP: 'DHCP',
      DISABLE_WIFI_RATIO_STATUS: 'Deaktiverer wifi for Gateway',
      DNS: 'DNS',
      CONNECT_TO_ELSYSTEM_SUCCESS_MSG: 'EL-system koblet til.',
      ENABLE_LOCATION_FOR_MAP: 'Aktiver for å finne din nåværende posisjon, aktiver den for å laste kartvisning',
      ENABLE_WIFI_RATIO_STATUS: 'Aktiverer wifi for Gateway',
      WIFI_CREDENTIALS_MESSAGE: 'Skriv inn riktig passord',
      ENTER_WIFI_CREDENTIALS: 'Skriv inn Wi-Fi-legitimasjon',
      RESET_GATEWAY_PASSWORD: 'Er du sikker på at du vil tilbakestille gateway-passord?',
      INVALID_EPAS_SERIAL_NUMBER: 'EPAS-serienummeret er ugyldig',
      ETHERNET: 'Ethernet',
      ETHERNET_CONFIGURATION: 'Ethernet-konfigurasjon',
      ETHERNET_PROCESS_FAILED_MSG: 'Ethernet-konfigurasjonsprosessen mislyktes. Vennligst prøv igjen.',
      ETHERNET_CONNECTION: 'Ethernet-tilkobling',
      FAIL_LINK_SYSTEM: 'Kan ikke koble systemet fra gatewayen',
      FAIL_UNLINK_SYSTEM: 'Kan ikke koble systemet fra gatewayen',
      FAIL_UNREGISTER_GATEWAY: 'Kunne ikke avregistrere gateway',
      FINISH: 'Fullfør',
      CHANGE_PASSWORD_INFO: 'Av sikkerhetsgrunner, vennligst endre standard passord.',
      GATEWAY_ACTIVATED: 'Gateway aktivert',
      GATEWAY_ADDED: 'Gateway lagt til',
      GATEWAY_COMMISSIONING: 'Gateway igangkjøring',
      GATEWAY_CONNECTED: 'Gateway tilkoblet',
      GATEWAY_DETAILS: 'Gateway detaljer',
      GATEWAY_NAME: 'Gateway navn *',
      GATEWAY_PASSWORD: 'Gateway-passord',
      GATEWAY_PASSWORD_INCORRECT: 'Gateway-passordet er feil',
      GATEWAY_NAME_DESCRIPTION: 'Gi denne gatewayen et bedre navn og beskrivelse.',
      SUCCESSFULLY_ADDED: 'har blitt lagt til.',
      INCOMPLETE_SETUP: 'Ufullstendig oppsett',
      INTERNET_SETTINGS: 'Internett-innstillinger',
      INVALID_GUID: 'Ugyldig enhets-ID. Angi gyldig GUID',
      FACTORY_RESET: 'Fabrikkinnstilling',
      FACTORY_RESET_SUCCESS: 'Fabrikkinnstillingskommandoen ble utført',
      FACTORY_RESET_FAILURE: 'Fabrikkinnstillingskommandoen mislyktes. Vennligst prøv igjen',
      GATEWAY_FACTORY_RESET_ALERT: 'Er du sikker på at du vil utføre Factory Reset for Gateway?',
      LAST_CONNECTED: 'Sist koblet til: 12. mai 2024 kl. 12.34.56',
      CELLULAR_CONNECTION_TYPE_LTE: 'LTE',
      CELLULAR_CONNECTION_TYPE_NON_LTE: 'IKKE-LTE',
      INVALID_LATITUDE: 'Ugyldig breddegrad. Vennligst oppgi gyldig breddegrad',
      INVALID_LONGITUDE: 'Ugyldig lengdegrad. Vennligst oppgi gyldig lengdegrad',
      INVALID_USER: 'Ugyldig bruker',
      SUBLOCATION_NAME_LENGTH: 'Kun bokstaver, bindestreker, tall',
      LINK_NEW_DEVICE: 'Koble til en ny enhet',
      LINK_NEW_SYSTEM: 'Koble til et nytt system',
      LINK_SYSTEM: 'KNYTT ET SYSTEM',
      LINK_ANOTHER_SYSTEM: 'Koble til et annet system',
      LINK_MORE_SYSTEM: 'Koble til flere systemer',
      LINK_SYSTEM_MSG: 'Koble systemet til \'{{gatewayName}}\' pågår',
      LINK_SYSTEMS: 'Koble systemer',
      LOCATION: 'Sted',
      DENIED_LOCATION_PERMISSION: 'Plasseringstillatelse nektet. Aktiver den for å få Bluetooth-skanning for enheter i nærheten',
      DENIED_LOCATION_PERMISSION_FOR_MAP: 'Plasseringstillatelse nektet, aktiver den for å laste kartvisning',
      CONNECTION_TYPE_VALUE: 'LTE/WCDMA/GSM',
      MANAGE_ETHERNET_CONNECTION: 'Administrer Ethernet-tilkobling',
      MANAGE_WIFI_CONNECTION: 'Administrer Wifi-tilkobling',
      MANUALLY_CONFIG_IP: 'Angi IP-adresse manuelt',
      SET_NAME_DESCRIPTION_SUCCESS: 'Navn og beskrivelse er angitt',
      NO_DEVICE_FOUND: 'Ingen enheter funnet',
      UNLINK_SYSTEM_ERROR: 'Ingen gateway for å avregistrere',
      NO_GATEWAY_NAME_FOUND: 'Ingen navn funnet',
      NO_SYSTEM_YET: 'Ingen systemer ennå',
      WIFI_NETWORK_NOT_AVAILABLE: 'Ingen wifi-nettverk tilgjengelig',
      DHCP_OFF: 'Av',
      DHCP_ON: 'På',
      NO_SYSTEM_YET_DESCRIPTION: 'Når du kobler systemene dine til denne gatewayen, vil du se en liste over systemet her. Omformulere meg.',
      ONLINE_TEXT: 'på nett.',
      ORGANIZATION_TREE: 'Organisasjonstre',
      OTHER_NETWORK: 'Annet nettverk..',
      BLUETOOTH_INSTRUCTIONS: ' våre instruksjoner',
      CHOOSE_GATEWAY_CONNECTION_METHOD: 'Velg gateway-tilkoblingsmetode',
      CONFIRM_SELECTION: 'Vennligst bekreft valget',
      ENTER_ADMIN_CHANGE_PASSWORD: 'Vennligst skriv inn admin endret passord',
      ENTRY_GATEWAY_CHANGED_PASSORD: 'Vennligst skriv inn gatewayen endret passord for',
      ENTRY_GATEWAY_DEFAULT_PASSORD: 'Vennligst skriv inn gatewayens standardpassord for',
      ENTRY_PASSWORD: 'Vennligst skriv inn gateway-passordet for',
      PLEASE_ENTER_NEW_PASSWORD_AGAIN_RECONNECT: 'Vennligst skriv inn det nye passordet på nytt for å koble til gatewayen igjen.',
      MOVE_CAMERA_OVER_QR_CODE: 'Flytt kameraet ditt\n over QR-koden',
      INVALID_BUILDING_ID: 'Vennligst oppgi gyldig bygnings-ID',
      INVALID_DEVICE_ID: 'Oppgi gyldig enhets-ID',
      INVALID_DEVICE_NAME: 'Oppgi et gyldig enhetsnavn',
      INVALID_DEVICE_STATUS: 'Oppgi gyldig enhetsstatus',
      INVALID_DEVICE_TYPE: 'Oppgi gyldig enhetstype',
      INVALID_PROJECT_ID: 'Vennligst oppgi gyldig prosjekt-ID',
      INVALID_SYSTEM_ID: 'Vennligst oppgi gyldig system-ID',
      PLEASE_WAIT: 'Vennligst vent',
      PRIMARY_CONNECTION: 'Primær tilkobling',
      GATEWAY_PRIORITY: 'Prioritet',
      PROXY: 'Fullmakt (valgfritt)',
      PULL_REFRESH_TEXT: 'Trekk ned for å oppdatere',
      QUATERNARY_CONNECTION: 'Kvartær forbindelse',
      REMOVE_CONNECTION: 'Fjern tilkoblingen',
      REMOVE_PRIMARY_CONNECTION: 'Fjern primærtilkobling',
      REQUIRE_GATEWAY_CONNECTED_TO_INTERNET: 'Krever gateway koblet til internett',
      SAVE_TO_CLOUD: 'Lagre til skyen',
      SAVE_WI_FI_CREDENTIALS: 'Lagre Wi-Fi-legitimasjon for ytterligere  enheter',
      SCAN_QR_CODE: 'Skann QR-koden',
      QR_CODE_SCAN: 'Skann QR-kode',
      SCANNING_FOR_NEAR_BY_BLE: 'Skanner etter Ble-enheter i nærheten..',
      SCANNING_FOR_NEAR_BY_WIFI: 'Skanner etter WIFI i nærheten..',
      SEARCH_ALL_LUMINARIES: 'Søk etter alle armaturer',
      SEARCH_VIA_BLUETOOTH: 'Søk via Bluetooth',
      SEARCHING_FOR_NEARBY_WIFI: 'Søker etter Wi-Fi i nærheten...',
      SEARCH_VIA_BLUETOOTH_EllIPSE: 'Søker via Bluetooth...',
      SECONDARY_CONNECTION: 'Sekundær tilkobling',
      SELECT_PRIMARY_CONNECTION: 'Velg en primær tilkoblingsmetode',
      SERIAL_NUMBER_NULL_OR_EMPTY: 'Serienummeret kan ikke være null eller tomt',
      SET_DATE_TIME_CONFIG: 'Angi dato og klokkeslett Feil konfig',
      SET_DATE_TIME_FAILURE: 'Angi dato og klokkeslett er konfigurasjonsfeil',
      SET_NAME_DESCRIPTION_INCORRECT_CONFIG: 'Angi navn og beskrivelse Feil konfig',
      SET_NAME_DESCRIPTION_FAILURE: 'Sett navn og beskrivelse er konfigurasjonsfeil',
      SET_EL_SYSTEM_PORT: 'Still inn EL-systemporten',
      SET_GATEWAY_PORT: 'Still inn gateway-porten',
      STATIC: 'Statisk',
      STATUS: 'Status',
      STEP_THREE_OF_THREE: 'Trinn 3 av 3',
      SYNC_DATE_TIME: 'Synkroniser dato og klokkeslett',
      SYSTEM_UNLINK_SUCCESS: 'Systemet ble koblet fra',
      SYSTEM_UNLINKED: 'System frakoblet',
      SYSTEMS: 'Systemer',
      UNLINK_SYSTEM_SUCCESS: 'Systemer ble avregistrert.',
      TERTIARY_CONNECTION: 'Tertiær forbindelse',
      GATEWAY_NOT_EXISTS: 'Porten eksisterer ikke',
      ADDING_GATEWAY_SUBTITITLE: 'Denne prosessen kan ta opptil 2 minutter.',
      UNLINK_ANOTHER_SYSTEM: 'Koble fra et annet system',
      UNLINK_EXISTING_SYSTEM: 'Koble fra eksisterende system',
      UNLINK_EXIST_SYSTEM: 'Avregistrer gateway',
      USE_WI_FI_PASSWORD: 'Bruk Wi-Fi-passord',
      USE_WPA2_KEY: 'Bruk WPA2-nøkkel',
      SCANNING_FAILED_TRY_AGAIN: 'Bekrefter enheten …',
      CARRIER_NAME_VALUE: 'Vodafone NL 3G',
      WI_FI: 'Wi-Fi',
      WIFI_PROCESS_FAILED_MSG: 'Wifi-konfigurasjonsprosessen mislyktes. Vennligst prøv igjen.',
      GATEWAY_WIFI_CONFIG: 'Wifi-konfigurasjoner',
      WI_FI_NETWORK: 'Wi-Fi-nettverk',
      WI_FI_NETWORK_NAME: 'Wi-Fi-nettverksnavn',
      WI_FI_PASSWORD: 'Wi-Fi-passord',
      GATEWY_INTERNET_SETTING_OPTIONAL_FIELD_MSG: 'Du kan hoppe over alle disse trinnene, men de må fullføres senere for å fullføre oppsettet.',
      VERIFYING_DEVICE: 'Bekrefter enheten …',
      GATEWAY_OF: 'Gateway Of',
      SYSTEM_LOCATION: 'Systemplassering',
      LOCATION_PERMISSION_TITLE: 'Stedstillatelse',
      LOCATION_REQUIRED_MESSAGE: 'Denne appen trenger tilgang til posisjonen din',
      PERMISSION_DENIED_TITLE: 'Tillatelse nektet',
      PERMISSION_DENIED_MULTIPLE_MSG: 'Du har nektet plasseringstillatelsen flere ganger. Appen fungerer kanskje ikke riktig uten den.',
      MAINTAINED_MODE: 'Opprettholdt modus',
      NON_MAINTAINED_MODE: 'Ikke-vedlikeholdt modus',
      UNREGISTER_GATEWAY: 'Avregistrer gateway',
      CHOOSE_CONNECTION_TYPE: 'Hva slags tilkoblingstype vil du bruke for \n DGS-systemet?',
      REACHED_MAXIMUM_SUPPORTED_SYSTEM_ERROR_MSG: 'Kan ikke legge til flere systemer. Grensen er nådd for maksimalt antall systemer som støttes på Gateway',
      DUALSMART_NAME: 'Dualsmart navn *',
      WIRELESS_GATEWAY_NAME: 'Navn på trådløs gateway *',
      DUPLICATE_SYSTEM_ERROR_MSG: 'System med denne IP-adressen er allerede koblet til Gateway.',
      DIRECT_CONNECT_OPTION_SELECT_MSG: 'Kontroller at IP-adressen til systemet er satt til IP-adresse og at DHCP er deaktivert',
      DESCRIPTION: 'Beskrivelse',
},
    ERROR_MESSAGES: {
      GENERIC_ERROR_CONTACT_DETAILS: ' eller ring på',
      GENERIC_ERROR: ' Det har oppstått en uspesifisert feil. Hvis dette problemet vedvarer, vennligst kontakt Eaton Support på',
      9003: 'Den forespurte operasjonen kan ikke utføres. Kontakt administratoren din',
      2002: 'Brukerregistreringslenken er utløpt eller allerede innløst.',
      2018: 'Vi kan ikke fullføre registreringen din. Organisasjonen din har overskredet antallet tildelte brukere for abonnementet ditt. Hvis organisasjonen din trenger flere brukere, vennligst kontakt CST Support via e-post på',
},
    FORGOT_PASSWORD: {
      INSTRUCTIONS: 'Vennligst skriv inn e-postadressen for kontoen som er knyttet til kontoen. <br/><br/>\' +\n"Hvis denne e-posten har en konto hos Safety Management System, vil du motta et svar innen <3>én virkedag</3>.<br/><br/>" +\n\'For presserende kontoproblemer, vennligst ring\'',
      ERROR: 'Kunne ikke tilbakestille passordet ditt nå.',
      RESET_CODE_ERROR: ' Det oppsto en feil med tilbakestillingskoden.',
},
    ACCOUNT_SETTING: {
      UPDATES_AVAILABLE: 'OPPDATERINGER TILGJENGELIGE',
      ACCOUNT_CREATED: 'Konto opprettet',
      ACCOUNT_PREFERENCES: 'Kontoinnstillinger',
      ADDRESS_LINE2: 'Adresselinje 2 (valgfritt)',
      ALARAM: 'Alarmer',
      ALL_BUILDINGS: 'Alle bygninger',
      ALL_SYSTEM_FIRMWARE: 'All systemfastvare',
      ALL_SYSTEMS: 'Alle systemer',
      APPLICATION_THEME_COLOR: 'Søknadstemafarge',
      AUTOMATIC_LOG_OUT: 'Automatisk utlogging',
      AUTOMATIC_UPDATES: 'Automatiske oppdateringer',
      AUTOMATIC_UPDATES_INFO: 'Last ned den nyeste versjonen av fastvaren automatisk til enheten din.',
      CHANGE_PASSWORD: 'Endre passord',
      STORAGE_FIRMWAREFILE_INFO: 'Velg hvordan du vil lagre fastvarefiler på enheten din',
      CITY: 'By',
      COMPANY_ADDRESS: 'Firmaadresse',
      COMP_ADDRESS: 'Firmaadresse*',
      COMPANY_DETAILS: 'Firmadetaljer',
      COMPANY_NAME: 'Firmanavn',
      COMP_NAME: 'Firmanavn',
      COMPANY_PHONE_NUMBER: 'Selskapets telefonnummer',
      CODE: 'Landskode',
      DATE_FORMAT: 'Datoformat',
      DELETE_ACCOUNT: 'Slett konto',
      DELETE_CUSTOMER: 'Slett kunde',
      DEVICE_BLOCKING: 'Enheten er i blokkeringsmodus, nødmodus, vedlikehold forespurt',
      EDIT_CUSTOMER_INFO: 'Rediger kundeinformasjon',
      EMAIL: 'E-post',
      EMAIL_ADDRESS: 'E-postadresse',
      REQUIRED_FIELD: 'Felt med en stjerne (*) kreves for å fortsette.',
      FIRMWARE_FILE: 'Fastvarefiler',
      FIRMWARE_UPDATES: 'Fastvareoppdateringer',
      FIRST_NAME: 'Fornavn',
      FT_DT_FAIL: 'FT mislyktes, DT mislyktes, frakoblet, batterifeil, lampefeil, ATSD-feil',
      HEALTH_REPORT: 'Helserapport',
      LANGUAGE: 'Språk',
      LAST_NAME: 'Etternavn',
      MONTHLY_REPORTING: 'Månedlig rapportering',
      NEW_RELEASE_FIRMWARE_UPDATE: 'Nye utgivelser, fastvareoppdatering tilgjengelig',
      NOTIFICATIONS: 'Varsler',
      ORGAN_UPDATED_SUCCESSFULLY: 'Organisasjonen ble oppdatert',
      PASSWORD: 'Passord',
      PERSONAL_DETAILS: 'Personlige detaljer',
      PHONE_NUMBER: 'Telefonnummer',
      VALID_FIRSTNAME_ERROR: 'Vennligst skriv inn fornavn',
      POSTAL_CODE: 'Postnummer',
      PREFERENCES: 'Preferanser',
      PRIMARY_CONTACT: 'Primær kontakt',
      PRIMARY_CONTACT_EMAIL_ADDRESS: 'E-postadresse for primær kontakt',
      PRIMARY_CONTACT_PHONE_NUMBER: 'Primært kontakttelefonnummer',
      PRIMARY_EMAIL_ADDRESS: 'Primær e-postadresse',
      PRIMARY_PHONE_NUMBER: 'Primært telefonnummer',
      PRODUCT_UPDATE: 'Produktoppdateringer',
      SAVE_CHANGES: 'Lagre endringer',
      SECONDARY_CONTACT: 'Sekundær kontakt',
      SECONDARY_CONTACT_EMAIL_ADDRESS: 'Sekundær kontakt-e-postadresse',
      SECONDARY_CONTACT_PHONE_NUMBER: 'Sekundært telefonnummer',
      SECONDARY_EMAIL_ADDRESS: 'Sekundær e-postadresse',
      SECONDARY_PHONE_NUMBER: 'Sekundært telefonnummer',
      SLA_DETAILS: 'SLA-detaljer',
      STATUS_UPDATE: 'Statusoppdateringer',
      STORAGE: 'Lagring',
      TIME_ZONE: 'Tidssone',
      UNITS: 'Enheter',
      USER_NAME: 'Brukernavn',
      USER_UPDATED_SUCCESSFULLY: 'Brukeren er oppdatert',
      VERSION: 'Versjon',
      EST: 'EST',
      DD_MM_YYYY: 'DD',
      OFFLINE_MODE_ENABLED: 'Aktivert',
      OPERATING_SYSTEM_THEME: 'Operativsystemtema',
},
    CHANGE_PASSWORD: {
      EMAIL_CONFIRM_MESSAGE: 'Vi har sendt en bekreftelses-e-post til {{email}}',
      PROBLEM_OCCURRED: 'Det oppsto et problem:',
      PASSWORD: 'Endre passord',
      OLD_PASSWORD: 'Gammelt passord',
      PASSWORD_CHANGED: 'Passord endret',
      PASSWORD_INFO: 'Passordet må være minst 8 tegn langt, inneholde minst ett stort tegn, ett lite tegn, ett tall og ett spesialtegn.',
      ERROR_MESSAGR: 'Informasjonen din stemte ikke overens med registrene våre. Vennligst skriv inn informasjonen din på nytt for å prøve på nytt.',
      SUCCESS_MESSAGE: 'Passordet ditt ble oppdatert! For å sikre sikkerheten til kontoen din, må du logge på applikasjonen med den oppdaterte legitimasjonen din.',
},
    SYSTEM_DETAIL: {
      GUIDE: '(Guide)',
      USERS_DATA: '5 administratorer, 1 seer',
      ACTIVATE_CONNECTIONS: 'Aktiver tilkoblinger i skyen',
      ADD_ANOTHER_CELLULAR: 'Legg til Backup Cellular-tilkobling',
      ADD_SLA: 'Legg til SLA',
       SYSTEM_DETAILS_TITLE: 'Systemdetaljer',
      ALL_CONTACTS: 'Alle kontakter',
      ALL_PEOPLE_IN_THIS_BUILDING: 'Alle mennesker i denne bygningen',
      ALL_SYSTEMS_IN_THIS_BUILDING: 'Alle systemer i denne bygningen',
      BOTH_PORTS_CANNOT_BE_ON_SAME_SUBNET: 'Begge portene kan ikke være på samme subnett',
      BUILDING: 'Bygning',
      BUILDING_INFO: 'Bygningsinformasjon',
      BUILDING_TYPE: 'Bygningstype',
      BUYER: 'Kjøper',
      CONNECTION_TYPE: 'Tilkoblingstype',
      CONTACT_PERSON_Onsite: 'Kontaktperson på stedet',
      CONTACT_TYPE: 'Kontakttype',
      CUSTOMER_DETAILS: 'Kundedetaljer',
      CUSTOMER_INFO: 'Kundeinfo',
      CUSTOMER_NUMBER: 'Kundenummer',
      DATE_COMMISSIONED: 'Dato idriftsatt',
      DISABLE: 'Deaktiver',
      DURATION_TEST: 'Varighet Test',
      DURATION_TEST_FAILED: 'Varighetstest mislyktes',
      DURATION_TEST_PASSED: 'Varighet Test bestått',
      ENABLED: 'Aktivert',
      ENTER_VALID_GATEWAY_ADDRESS: 'Angi en gyldig gateway-adresse',
      ENTER_VALID_IP_ADDRESS: 'Skriv inn en gyldig IP-adresse',
      ENTER_VALID_SUBNET_MASK: 'Angi en gyldig nettverksmaske',
      ETHERNET_PORT_ONE: 'Ethernet-port A',
      ETHERNET_PORT_TWO: 'Ethernet-port B',
      EXPIRY_DATE: 'Utløpsdato',
      FIRMWARE_VERSION: 'Fastvareversjon',
      FOR_BUILDINGS: 'For bygninger',
      FOR_SYSTEMS: 'For systemer',
      FUNCTIONAL_TEST: 'Funksjonstest',
      FUNCTIONAL_TEST_FAILED: 'Funksjonstest mislyktes',
      FUNCTIONAL_TEST_PASSED: 'Funksjonstest bestått',
      GATEWAY: 'Inngangsport',
      GATEWAY_ADDRESS: 'Gateway-adresse',
      GATEWAY_ADDRESS_REQUIRED: 'Gateway-adresse*',
      GATEWAY_NAME: 'Gateway navn',
      SYSTEM_UNLINKED_GATEWAY: 'har vært  koblet fra',
      SYSTEM_LINKED_GATEWAY: 'har blitt koblet til',
      HOST_NAME: 'Vertsnavn',
      INTIALIZE_CONNECTION: 'Initialiser tilkoblingen',
      INTIALIZE_NETWORK: 'Initialiserer nettverk...',
      IP_ADDRESS: 'IP-adresse',
      IP_ADDRESS_REQUIRED: 'IP-adresse*',
      IP_GATEWAY_NOT_IN_SAME_SUBNET: 'Ip og gateway er ikke i samme nettverksmaske',
      ETHERNET_CONNECTED: 'er nå  koblet til internett',
      SYSTEM_LINKING_TITLE: 'Er dette systemet du er  lenke?',
      SYSTEM_UNLINKING_TITLE: 'Er dette systemet du er  fjerne koblingen?',
      SYSTEM_LINK_TITLE: ' Koble et system til',
      LUMINAIRES: 'Armaturer',
      LUMINARIES_LIST: 'Liste over armaturer',
      MAC_ADDRESS: 'Mac-adresse',
      MAIN_CONTACT: 'Hovedkontakt',
      NETWORK_INFORMATION: 'Nettverksinformasjon',
      NO_SYSTEM_FOUND: 'Ingen system tilgjengelig',
      OFFICE: 'Kontor',
      ORGANIZATION: 'Organisasjon',
      OTHER_STEPS: 'Andre trinn, om nødvendig',
      OTHER_SYSTEMS: 'Andre systemer',
      PART_NUMBER: 'Delenummer',
      SETPORT_SYSTEM_DETAILS_DESCRIPTION: 'Fullfør Ethernet-konfigurasjonen  detaljer.',
      SYSTEM_DETAILS_DESCRIPTION: 'Vennligst finn disse detaljene på HMI-skjermen til  systemskapet ditt.',
      PORT_NUMBER: 'Portnummer',
      PREV: 'Forrige',
      PROJECT_LEAD: 'Prosjektleder',
      REGISTER_ACTIVATE_GATEWAY: 'Registrer og aktiver gatewayen',
      SERIALNO_VALUE: 'S3ri4l-Num63r',
      SERIAL_NUMBER: 'Serienummer',
      SETPORT_SYSTEM_LINK_TITLE: ' Sett porten for å koble et system til',
      SLA_NUMBER_TITLE: 'SLA#',
      SLAVE_NUMBER: 'Slavenummer',
      SUBNET_MASK: 'Subnettmaske',
      SUBNET_MASK_REQUIRED: 'Subnettmaske',
      SYN_DATE_TIME: 'Synkroniser dato og klokkeslett',
      SYSTEM: 'System',
      SYSTEM_NAME: 'Systemnavn',
      SYSTEM_TYPE: 'Systemtype',
      TECHNICAL_PERSON: 'Teknisk person',
      STATUS_DESCRIPTION: 'Dette er en lang beskrivelse. Det kan beskrive enhetens plassering og hvem du skal snakke med.',
      TOTAL_SLA: 'Totale SLA-er',
      TRANSFER_ORGANIZATION: 'Overfør denne organisasjonen og dens eiendeler \n til en annen bruker (valgfritt)',
      SYSTEM_UNLINK_TITLE: 'Koble fra system fra',
      UPDATE_REQUIRED: 'oppdatering kreves',
      UPLOAD_DETAILS: 'Last opp detaljer via bluetooth',
      FIRMWARE_VERSION_VALUE: 'v12.34-56',
      VERSION_AVAILABLE: 'v123.457 Tilgjengelig',
      VIEW_ALL: 'Vis alle',
      VIEW_ALL_LUMINARIES: 'Se alle armaturer',
      PARTNO_VALUE: 'xx xx xx xx',
      ETHERNET_SUBTITLE: 'Du kan nå få tilgang til gatewayen din gjennom  web. Omformulere meg.',
      LINK_TO_CUSTOMER_BUTTON: 'Link til kunde',
},
    USER_INVITATION_MANAGEMENT: {
      YOU: '(Du)',
      INVITATION_MESSAGE_UPDATE_COUNT: '{{updatedInvitationCount}} invitasjoner ble {{inviteStatus}} vellykket, {{rejectedInvitationCount}} invitasjoner var ikke {{inviteStatus}}.',
      SUCCESS_COUNT: '{{updatedInvitationCount}} invitasjoner ble {{inviteStatus}} vellykket.',
      INVITE_ACCEPT: 'Akseptere',
      INVITE_ACCEPT_INVITATION: 'Godta invitasjonen',
      INVITE_ACCEPTED: 'akseptert',
      INVITE_ACCEPTED_BUTTON: 'Godtatt',
      INVITE_ACCEPT_INVITATION_DESCRIPTION_1: 'Hvis du godtar denne invitasjonen, legges følgende element til profilen din:',
      ADMIN_APPROVE: 'Godkjenn forespørsel',
      COMPANY: 'Bedrift',
      DECLINE_INVITATION: 'Avslå invitasjon',
      TABLE_HEADER_DENIED_TITLE: 'Avvist av meg ({{count}})',
      INVITE_DENIED: 'nektet',
      INVITE_DENY: 'Benekte',
      ADMIN_DECLINE_INVITATION: 'Avslå forespørsel',
      TABLE_HEADER_EXPIRED_AT: 'Utløp',
      TABLE_HEADER_EXPIRED_TITLE: 'Utløpte invitasjoner ({{count}})',
      INVITE_HISTORY: 'Invitasjonshistorikk',
      INVITATION_SUCCESS_MESSAGE: 'Invitasjon vellykket {{inviteStatus}}.',
      JOIN: 'Bli med',
      JOINALL: 'Bli med alle',
      LEAVE_ORGANIZATION: 'Gå ut av organisasjonen',
      TABLE_HEADER_NAME: 'Navn',
      INVITE_PENDING: 'I påvente av',
      INVITE_REQUEST_ACCESS_DESCRIPTION_2: 'Vennligst be om tilgang fra administratoren for å legge til dette elementet i profilen din',
      TABLE_HEADER_INVITE_DATE: 'Mottatt',
      REMOVE_USER: 'Fjern bruker',
      INVITE_REQUEST: 'Forespørsel',
      INVITE_REQUEST_ACCESS: 'Be om tilgang',
      REQUESTEDBY: 'Forespurt av',
      INSTRUCTIONS: 'Velg enten å legge til elementer på profilen din eller å avslå invitasjonen om å legge den til profilen din.',
      ADMIN_INSTRUCTIONS: 'Velg å enten godkjenne eller avslå forespørselen om tilgang:',
      SENTBY: 'Sendt av',
      TABLE_HEADER_INVITE_BY: 'Sendt av',
      TABLE_HEADER_TOTAL_ACCEPTED_NO_DATA_FOUND: 'Det er ingen aksepterte invitasjoner for øyeblikket.',
      TABLE_HEADER_DENIED_NO_DATA_FOUND: 'Det er ingen avslåtte invitasjoner for øyeblikket.',
      TABLE_HEADER_EXPIRED_NO_DATA_FOUND: 'Det er ingen utløpte invitasjoner for øyeblikket.',
      INVITATION_TEXT: 'De trenger en invitasjon for å bli med igjen.',
      INVITE_REQUEST_ACCESS_DESCRIPTION_1: 'Denne invitasjonen er utløpt og kan ikke lenger legges til profilen din.',
      TABLE_HEADER_TOTAL_COUNT: 'Totalt antall aksepterte invitasjoner ({{count}})',
      TABLE_HEADER_TOTAL_ACCEPTED_COUNT: 'Totalt antall aksepterte invitasjoner ({{count}})',
      SUCCESS_MESSAGE: 'Brukerinvitasjon vellykket {{count}}',
      ERROR_MESSAGE: 'Brukerforespørsel om å oppdatere invitasjonen mislyktes',
      VIEW_ALL_ACCESS_RIGHTS: 'Se alle tilgangsrettigheter',
      TITLE: 'Velkommen, {{brukernavn}}',
      SUBTITLE: 'Du har blitt invitert til følgende prosjekter:',
      ADMIN_SUBTITLE: 'Du har forespørsler om å få tilgang til utløpte invitasjoner:',
},
    INACTIVITY: {
      LOGOUT: ', vil du bli logget ut.',
      INACTIVE_LOGOUT: 'Logget ut på grunn av inaktivitet',
      TITLE: 'Tidsavbrudd for økten',
      WARNING : ' Dette vinduet har vært inaktivt i 15 minutter. Hvis det ikke gjøres noe',
},
    ATPLUS: {
      ATPLUS_FAILURE_COUNT: '{{count}} feil',
      ATPLUS_DATETIME_TWENTYFOUR_HOUR: '24-timers tid',
      ATPLUS_TWO_MINUTE_AGO: '2 mn siden',
      ATPLUS_ACTIVATION: 'Aktivering',
      ADMIN: 'Admin',
      ADMINVIEWER: 'Administrator og visningsprogram',
      ATPLUS_ADMIN_ACCESS: 'Administratortilgang',
      ATPLUS_ALERT_LEVEL: 'Varslingsnivå',
      ATPLUS_ALERTSETTING_HEADER: 'Innstillinger for varselnivå',
      ATPLUS_SEARCHLUMINAIRE_WARNING: 'Alle armaturer vil bli tildelt en ny adresse og opprette en ny konfigurasjon.',
      ATPLUS_LOGIN_FAILURE: 'Det oppstod en feil under endring av parametere',
      ATPLUS_DATETIME_AUTO_DATE_TIME_HEADER: 'Automatisk dato og klokkeslett',
      ATPLUS_AUTOMATIC_RESET: 'Automatisk hvilemodus',
      ATPLUS_AUTOMATIC_REST_MODE_MSG: 'Automatisk hvilemodus vil sende armaturene i hvile dersom den lokale hovedledningen er slått av.',
      ATPLUS_BATTERYFAILURE: 'Batterifeil',
      ATPLUS_CHANGE_ADMIN_PASSWORD: 'Endre administratorpassord',
      ATPLUS_CHANGE_PASSWORD_FAILURE: 'Feil ved endring av passord',
      ATPLUS_CHANGE_PASSWORD_SUCCESS: 'Endre passord Vellykket',
      ATPLUS_CHANGE_SERVICE_PARTNER_PASSWORD: 'Endre passord for tjenestepartner',
      ATPLUS_CHANGE_PASSWORD: 'Endre systempassord',
      SYSTEMPASSWORD: 'Endre systempassord',
      ATPLUS_CHANGE_VIEWER_PASSWORD: 'Endre visningspassord',
      ATPLUS_SYNC_TEST_SCHEDULE_INFO: 'Klikk "Synkroniser testplan" for å sette funksjonstestene til nøyaktig 7 dager fra nå og varighetstester 10 uker fra nå.',
      ATPLUS_INFO_TAG_CLOSED: 'LUKKET',
      ATPLUS_COMISSIONING: 'Igangkjøring',
      ATPLUS_COMMANDS: 'Kommandoer',
      ATPLUS_COMMSFAILURE: 'Kommunikasjonsfeil',
      ATPLUS_CONFIGRATION_CREATED: 'Konfigurasjon opprettet',
      ATPLUS_CONFIGRATION_DETAIL: 'Konfigurasjonsdetaljer',
      ATPLUS_CONFIGRATION_NAME: 'Konfigurasjonsnavn',
      ATPLUS_CREATE_CONFIGRATION: 'Opprett konfigurasjon',
      ATPLUS_DATETIME_CURRENT_TIME: 'Gjeldende dato og klokkeslett',
      ATPLUS_DEVICE_DATETIME_CURRENT_TIME: 'Gjeldende mobilenhetsdato og -klokkeslett',
      ATPLUS_CURRENT_TEST_SCHEDULE: 'Gjeldende testplan',
      ATPLUS_REFRESH_LUMINAIRES: 'Henter for tiden siste status for alle armaturer i {{atplus}}-bygningen.',
      ATPLUS_DATETIME: 'Dato og tid',
      ATPLUS_DRYCONTACT_DEFAULT_SETTINGS: 'Standardinnstillinger',
      ATPLUS_DETAILS: 'Detaljer',
      ATPLUS_DRY_CONTACT: 'Tørr kontakt',
      ATPLUS_DRYCONTACT_INPUT: 'Tørr kontaktinngang',
      ATPLUS_ALERTSETTING_DRY_CONTACT_INPUT: 'Tørr kontaktinngang aktivert',
      ATPLUS_DRYCONTACT_OUTPUT: 'Tørr kontaktutgang',
      ATPLUS_ALERTSETTING_DRY_CONTACT_OUTPUT: 'Tørr kontaktutgang aktivert',
      ATPLUS_DRYCONTACT_HEADER: 'Innstillinger for tørr kontakt',
      ATPLUS_DRYCONTACT_STATUS: 'Tørr kontaktstatus',
      ATPLUS_DURATION_TEST_TITLE: 'Varighet \n Test',
      ATPLUS_DTSUCCESS: 'Varighetstest fullført',
      ATPLUS_DTFAILEDTITLE: 'Varighetstest mislyktes',
      ATPLUS_DTINPROGRESS: 'Varighetstest pågår...',
      SERVICE: 'Eaton Service',
      ATPLUS_ELSYSTEM_SYSTEM_TIME: 'EL System lokal tid',
      ATPLUS_EMC_HEADER: 'EMC-test',
      ATPLUS_EMERGENCY: 'Nødsituasjon',
      ATPLUS_FW_UPDATE_EROOR: 'Feil under oppgradering av fastvaren, prøv igjen',
      ATPLUS_EXPORT_CONFIG: 'Eksporter konfigurasjon',
      ATPLUS_EXPORT_CONFIGRATION_FAIL: 'Eksporter konfigurasjonsprosessen mislyktes',
      ATPLUS_FAILED_LUMINAIRE: 'Mislykkede armaturer',
      ATPLUS_DRYCONTACT_FAILURE_THRESHOLD: 'Feilterskel overskredet',
      ATPLUS_FAILURETYPE: 'Typer av feil',
      ATPLUS_FILE_ALREADY_EXIST_TITLE: 'Filen eksisterer allerede',
      ATPLUS_FILE_ALREADY_EXIST_MSG: 'Fil med samme navn eksisterer allerede. Endre filnavnet',
      ATPLUS_FIRMWARE_FILE_FOR: 'Firmware-fil for versjon',
      ATPLUS_FIRMWARE_UPDATE: 'Fastvareoppdatering',
      ATPLUS_FW_UPDATE_COMPLETE: 'Firmwareoppdatering fullført',
      ATPLUS_FW_UPDATE_INPROGRESS: 'Fastvareoppdatering pågår',
      ATPLUS_FUNCTIONAL_TEST_TITLE: 'Funksjonell \n test',
      ATPLUS_FTSUCCESS: 'Funksjonstest fullført',
      ATPLUS_FTINPROGRESS: 'Funksjonstest pågår...',
      CHANGEPASSWORDFOR: 'Jeg må endre passordet for',
      ATPLUS_IMPORT_CONFIG: 'Importer konfigurasjon',
      ATPLUS_INEMERGENCYMODE: 'I nødmodus',
      ATPLUS_INFAILURE: 'I fiasko',
      ATPLUS_INRESTMODE: 'I hvilemodus',
      ATPLUS_INTESTMODE: 'I testmodus',
      ATPLUS_REFRESH_INCOMPLETE: 'Ufullstendige data',
      ATPLUS_CHANGE_PASSWORD_INCORRECT_PASSWORD: 'Feil gjeldende passord',
      ATPLUS_DRYCONTACT_STATUS_INPUT: 'Inndata',
      ATPLUS_EXPORT_CONFIGRATION_INVALID_NAME: 'Ugyldig konfigurasjonsnavn',
      GWCDATPLUSHEADER: 'Er dette EL-enheten du setter i drift?',
      ATPLUS_LAMPFAILURE: 'Lampefeil',
      ATPLUS_CONFIGRATION_FILE_TITLE_INFO: 'Kun bokstaver, tall, understrek og bindestreker',
      ATPLUS_ALERTSETTING_LOCAL_MAIN_FAILURE: 'Lokal hovedfeil',
      ATPLUS_LOAST_CONNECTION: 'Mistet tilkobling – prøv igjen',
      ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS: 'Armaturvarsler',
      ATPLUS_DTFAILEDDESCRIPTION: 'Feil på armatur',
      ATPLUS_LUMINAIRE: 'Armaturer',
      ATPLUS_FOUNDLUMINAIRE: 'Fant armaturer...',
      ATPLUS_FOUNDWERELUMINAIRE: 'Det ble funnet armaturer.',
      ATPLUS_MAIN_OFFICE: 'Hovedkontor',
      ATPLUS_DRYCONTACT_SUBHEADER: 'Hovedkontor',
      ATPLUS_MANAGE_CONFIG: 'Administrer konfigurasjoner',
      ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED: 'Maksimalt antall forsøk er nådd',
      ATPLUS_MINIMIZE: 'Minimer',
      ATPLUS_MULTIPLE_FAILURES: 'Flere feil',
      ATPLUS_FOUNDNEWLUMINAIRE: 'nye armaturer ble funnet.',
      ATPLUS_NEW_TEST_SCHEDULE: 'Ny testplan',
      ATPLUS_DATETIME_SELECTED_TZ_PLACEHOLDER: 'New York',
      ATPLUS_NEXT_SCHEDULES_DTTEST: 'Neste planlagte varighetstest',
      ATPLUS_NEXT_SCHEDULES_FTTEST: 'Neste planlagte funksjonstest',
      ATPLUS_NO_FW_FILES: 'Ingen fastvarefil til stede for versjonen',
      ATPLUS_NO_LUMINAIRES_INSTALLED: 'Ingen armaturer installert',
      ATPLUS_NO_LUMINAIRES_YET: 'Ingen armaturer ennå',
      ATPLUS_DRYCONTACT_RADIO_CLOSED: 'Normalt stengt',
      ATPLUS_DRYCONTACT_RADIO_OPEN: 'Normalt åpen',
      ATPLUS_NEWLUMINAIRES_HEADLINE: 'Søk kun etter nylig lagt til eller erstattet armaturer i "Hovedkontoret" for å automatisk tildele adresser til dem.',
      ATPLUS_OPENSNACK: 'Åpne',
      ATPLUS_OPERATIONS: 'Drift',
      ATPLUS_ALERTSETTING_OTHER_ALERTS: 'Andre varsler',
      ATPLUS_DRYCONTACT_STATUS_OUTPUT: 'Produksjon',
      ATPLUS_DRYCONTACT_OUTPUT_DEFAULT_SETTINGS: 'Utgangsstandardinnstillinger',
      ATPLUS_ALERTSETTING_CHOOSE_NUMBER: 'Velg mellom 1-10 armaturer',
      ATPLUS_ADDITIONALPASSWORDINSTRUCTION: 'Opprett nye passord for brukere med tjeneste-, admin- og seernivåtilgang til denne telekommandoen.',
      ATPLUS_DONT_MOVE: 'Vennligst ikke flytt bort',
      ATPLUS_DOWNLOAD_FW_FILES: 'Last ned filen igjen og prøv...',
      ATPLUS_BLE_DISCONNECT_SUBTITILE: 'Sørg for at du er innenfor rekkevidde av Bluetooth og prøv igjen.',
      ATPLUS_RELOGINPASSWORDINSTRUCTION: 'Vennligst skriv inn det nye passordet på nytt for å koble til på nytt',
      ATPLUS_RELOGIN_MESSAGE: 'Vennligst skriv inn det nye passordet på nytt for å koble til på nytt.',
      ATPLUS_ENTRY_MESSAGE: 'Vennligst skriv inn legitimasjonen din for å endre følgende passord.',
      ATPLUS_EXPORT_CONFIGRATION_INFO: 'Navngi filen for å lagre og eksportere den sist opprettede konfigurasjonen.',
      ATPLUS_STAY_WHERE: 'Vennligst bli der du er',
      ATPLUS_ALERTSETTING_NOTIFY: 'Bruk følgende innstillinger for å tilpasse varselpreferansene dine.',
      ATPLUS_REFRESH_COMPLETE: 'Oppdater fullført',
      ATPLUS_REFRESHLUMINAIRE_TEST: 'Oppdater armaturer',
      ATPLUS_REFRESH_LUMINAIRES_PAGETITLE: 'Oppdater armaturer',
      ATPLUS_REFRESH_LUMINAIRES_PROGRESS: 'Oppdater armaturer pågår...',
      ATPLUS_USE_RELIGHT: 'Relight er kun tilgjengelig for armaturer som for øyeblikket er i hvilemodus.',
      ATPLUS_DRYCONTACT_INPUT_RELIGHT: 'Relight JOUR',
      ATPLUS_RELIGHT_SUCCESS: 'Relight Mode har blitt aktivert.',
      ATPLUS_RESTMODE: 'Hvile',
      ATPLUS_REST_SUCCESS: 'Hvilemodus er aktivert.',
      ATPLUS_DURATION_TEST: 'Kjør varighetstest',
      ATPLUS_FUNCTIONAL_TEST: 'Kjør funksjonstest',
      ATPLUS_SEARCHALL_LUMINAIRE: 'Søk etter alle armaturer',
      ATPLUS_SEARCH_ALL_LUMINAIRES: 'Søk etter alle armaturer',
      ATPLUS_SEARCH_NEWLUMINAIRES: 'Søk etter nye armaturer',
      ATPLUS_SEARCHNEW_LUMINAIRE: 'Søk etter nye armaturer',
      ATPLUS_SERVICE_ACCESS: 'Tjenestetilgang',
      ATPLUS_SERVICEPARTNERPASSWORD: 'Servicepartner',
      ATPLUS_CHANGEPASSWORD_INSTRUCTION: 'Angi et passord for brukere med',
      ATPLUS_ADDITIONALPASSWORD: 'Angi flere passord',
      ATPLUS_DATE_TIME: 'Still inn dato og klokkeslett',
      ATPLUS_DATETIME_HEADER: 'Still inn dato og klokkeslett',
      ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS_INFO: 'Still inn antall feilende armaturer et system må nå for at et varsel skal aktiveres.',
      ATPLUS_SHOW_CONNECTED_LUMINAIRE: 'Vis tilkoblede armaturer',
      ATPLUS_SHOW_REGISTERED_LUMINAIRE: 'Vis registrerte armaturer',
      SIGN_IN: 'Logg på',
      SIGN_IN_AS: 'Logg på som...',
      ATPLUS_RELIGHT: 'Start Relight Mode',
      ATPLUS_REST: 'Start hvilemodus',
      ATPLUS_STARTSEARCH: 'Start søk',
      ATPLUS_START_TEST: 'Start test',
      ATPLUS_VISIBILITY_TEST: 'Start Visibility Plus',
      ATPLUS_DRYCONTACT_INPUT_VISIBILITY: 'Start Synlighet+',
      ATPLUS_STARTDT: 'Starter varighetstest...',
      ATPLUS_STARTFT: 'Starter funksjonstest...',
      ATPLUS_STARTDTSNACK: 'Stopp test',
      ATPLUS_EMC: 'Bytt til EMC-test',
      ATPLUS_SYNCH_TEST: 'Synkroniseringstestplan',
      ATPLUS_SYNC_TEST_SCHEDULE: 'Synkroniseringstestplan',
      ATPLUS_SYNC_TEST_SCHEDULED_INFO: 'Synkroniser testplanen for funksjons- og varighetstesten for alle armaturene i bygningen',
      TELECOMMANDPASSWORD: 'Telekommando passord',
      ATPLUS_TEST: 'Test',
      ATPLUS_SYNC_TEST_TIME: 'Testtid:',
      ATPLUS_DRYCONTACT_INPUT_READONLY: 'Dry Contact-inngangen er skrivebeskyttet, men kan konfigureres manuelt på dip-bryteren.',
      ATPLUS_DRYCONTACT_STATUS_READONLY: 'Statusen er skrivebeskyttet, men kan konfigureres manuelt på dip-bryteren.',
      ATPLUS_LUMINAIRE_INSTALL: 'Denne handlingen vil blinke alle armaturene i en installasjon.',
      ATPLUS_SHOW_CONNECTED_LUMINAIRE_INFO: 'Denne handlingen vil blinke enhver armatur som er riktig kablet og koblet til kontrolleren.',
      ATPLUS_SEARCHLUMINAIRE_HEADLINE: 'Denne handlingen vil opprette en ny konfigurasjon ved bruk av alle tilkoblede armaturer.',
      ATPLUS_SHOW_REGISTERED_LUMINAIRE_INFO: 'Denne handlingen vil bare blinke armaturer som er inkludert i lyskonfigurasjonen.',
      ATPLUSSYNC_TEST_SCHEDULED_TIME_INFO: 'Denne handlingen vil synkronisere neste funksjonstest til nøyaktig 1 uke og varighetstester etter 10 uker.',
      ATPLUS_AUTOMATIC_REST_MODE_INFO: 'Denne informasjonen er skrivebeskyttet, men kan konfigureres manuelt på dip-bryteren.',
      ATPLUS_LOAST_CONNECTION_INFO: 'Denne mobile enheten må forbli innenfor Bluetooth-rekkevidde og koblet til AT+-systemet under funksjonstesten.',
      ATPLUS_DEVICE_RANGE: 'Denne mobile enheten må forbli innenfor Bluetooth-rekkevidden til G-North TLAT+ for denne operasjonen. \n Denne prosessen kan ta flere minutter.',
      ATPLUS_TOMANYLUMINAIREHEADER: 'Dette systemet kan kun støtte opptil 64 armaturer. Bare de første 64 enhetene som oppdages vil være en del av konfigurasjonen din.',
      ATPLUS_CURRENT_LUMINAIRES_CONFIGURATION: 'Dette vil erstatte din nåværende armaturkonfigurasjon',
      ATPLUS_TIMEREMAINS: 'Tidsestimat,',
      ATPLUS_TIMEREMAINING: ' Gjenstående tid,',
      ATPLUS_DATETIME_TIMEZONE: 'Tidssone',
      ATPLUS_TIMEZONE_HEADER: 'Tidssone',
      TLU_ATPLUS_PASSWORD_INCORRECT: 'TLU AT+ passord er feil',
      ATPLUS_TOMANYLUMINAIRE: 'Det ble funnet for mange armaturer',
      ATPLUS_FIRMWARE_UPDATING: 'Oppdaterer fastvare...',
      ATPLUS_USE_REST: ' Bruk Rest for armaturer som ikke lenger er koblet til strømnettet.',
      ATPLUS_FINISHSEARCH: 'Bruk disse resultatene til å opprette og dele en ny konfigurasjon ved å bruke «Eksporter».',
      ATPLUS_DATETIME_AUTO_DATE_TIME_SUBTEXT: 'Bruk mobilenhetens dato, klokkeslett og tidssone for å automatisk synkronisere med TLAT+-systemet. Slå av denne funksjonen for å stille inn dato, klokkeslett og tidssone manuelt.',
      ATPLUS_VIEWLOGBOOK: 'Se loggbok',
      VIEWER: 'Seer',
      ATPLUS_VIEWER_ACCESS: 'Seertilgang',
      ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED_BODY: 'Du kan prøve å logge på dette',
      ATPLUS_DT_DIALOG: 'Du kan miste data hvis du beveger deg for langt unna AT+-systemet under varighetstesten.\n\nBeregnet tid som gjenstår, 01:00:00',
      ATPLUS_FT_DIALOG: 'Du kan miste data hvis du beveger deg for langt unna AT+-systemet under funksjonstesten.\n\nBeregnet tid som gjenstår, 00:02:00',
      ATPLUS_NO_LUMINAIRES_YET_DESCRIPTION: 'Du må bruke funksjonen "Søk alle armaturer" og aktivere TLAT+ for å se armaturene dine her.',
      ATPLUS_CONFIGRATION_CREATED_MESSAGE: 'Konfigurasjonen din er opprettet.',
      ATPLUS_RELOGIN_SUCCESS_MESSAGE: 'De nye passordene dine ble lagret.',
      ATPLUS_DEVICE_UNREGISTERED: 'Denne enheten er uregistrert',
      ATPLUS_DEVICE_NEEDCOMMISSIONIG: 'Denne enheten er uregistrert fra Cloud og må settes i drift på nytt',
      SAVE_TO_CLOUD: 'Lagre til skyen',
      EXPORT: 'Eksport',
      ATPLUS_IMPORT_CONFIG_SETTING_DEVICE_NAME: 'Stille inn enhetsnavnet',
      TPLUS_IMPORT_CONFIG_LOADING_LUM_CONFIGRATION: 'Laster inn armaturkonfigurasjonen...',
      ATPLUS_IMPORT_CONFIG_SETTING_DRY_CONTACT_CONFIGURATION: 'Innstilling av tørr kontaktkonfigurasjon',
      ATPLUS_IMPORT_CONFIG_PROGRESS_ALERT_TITLE: 'Avslutte og miste fremgang?',
      TPLUS_IMPORT_CONFIG_PROGRESS_ALERT_SUBTITLE: 'Hvis du går ut av denne skjermen, avbrytes importprosessen og du må starte prosessen på nytt.',
      ATPLUS_START_VISIBILITY_PLUS: 'Start Visibility Plus',
      ATPLUS_VISIBILITY_PLUS: 'Synlighet Plus',
      ATPLUS_VISIBILITY_PLUS_FAILED: 'Visibility Plus mislyktes',
      DS_SEARCH_FOR_IO_MODULES: 'Søk i I-Bus-moduler',
      ATplUS_ACTIVATION_PENDING: 'I påvente av',
      ATPLUS_ALERTSETTING_ZONE_ALERTS_INFO: 'Still inn antall feilende armaturer et system må nå for at et varsel skal aktiveres.',
      ATPLUS_ALERTSETTING_LINE_ALERTS_INFO: 'Still inn antall feilende armaturer et system må nå for at et varsel skal aktiveres.',
      ATPLUS_IDENTIFICATION_CONNECTED_LUMINAIRE_INFO: 'Denne handlingen vil blinke enhver armatur som er riktig kablet og koblet til kontrolleren.',
      ATPLUS_IDENTIFICATION_REGISTERED_LUMINAIRE_INFO: 'Denne handlingen vil bare blinke armaturer som er inkludert i lyskonfigurasjonen.',
      ATPLUS_SPEC_DATE_COMMISSIONED: 'Dato idriftsatt',
      ATPLUS_SPEC_TOTAL_LUMINAIRES: 'Totalt armaturer',
      ATPLUS_SPEC_LUMINAIRE: 'Armaturer',
},
    USERLIST: {
      DELETECONFIRMATION: '{{email}} Kontoen og alle dens data vil bli permanent fjernet. Sletting av denne kontoen vil ikke påvirke organisasjonen, enhetene eller relaterte historiske data.',
      ACCOUNT_DELETE: 'Konto slettet',
      ALL_LOCATION: 'Alle steder',
      DELETEACCOUNT: 'Vil du slette denne kontoen?',
      COL_EMAIL: 'E-post',
      COL_LOCATION: 'Sted',
      COL_ROLE: 'Rolle',
      COL_STATUS: 'Status',
      DELETE_SUCCESS: 'Brukerkontoen for {{email}} er slettet.',
      COL_USERNAME: 'Brukernavn',
},
    REPORTS: {
      ISSUES: '{{issueCount}} problemer',
      MONTHLY_REPORT: 'Månedsrapport',
      NO_ISSUES: 'Ingen problemer i denne perioden',
      REPORT_DOWNLOAD_FAILED: 'Rapportfilnedlasting mislyktes',
      REPORT_DOWNLOAD_SUCCESSFULLY: 'Rapportfilen ble lastet ned',
},
    MAP: {
      MAP_COORDINATES: '{{breddegrad}} N, {{lengdegrad}} E',
      BLOCKED: 'BLOKKERT',
      MAP_COORDINATES_LABEL: 'Koordinater',
       MAP_ADDRESS_DISPLAY: 'Vis adresse på kartet',
      MAP_DRAG_MARKER: 'Dra på kartet for å plassere nålen',
      ERROR: 'FEIL',
      OFFLINE: 'OFFLINE',
      READY: 'FERDIG',
      MAP_ENABLE_ON_COUNTRY: 'Velg land for å aktivere kart',
      SYSTEM: 'System',
      SYSTEMS: 'Systemer',
      WARNING: 'ADVARSEL',
},
    MAINTENANCE_DETAILS: {
      ADD_DOC: '+ Legg til dokument',
      ADD_NOTES: '+ Legg til notater',
      ADD_DOCUMENT_BUTTON: '+ Legg til dokument eller bilde',
      NEW_MAINTENANCE: '+ Nytt vedlikehold',
      CREATE_MAINTAINENCE_BUTTON: 'Tilordne og gi beskjed',
      TECHNICIAN_INPUT_LABEL: 'Tildelt til',
      STATUS_COMPLETED: 'Fullført',
      CUSTOMER_CONTACT: 'Kundekontakter',
      DATE_CREATED: 'Opprettelsesdato',
      DELETE_REQ: 'Slett forespørsel',
      COMMENTS_LABEL: 'Beskrivelse (valgfritt)',
      DOCUMENTATION: 'Dokumentasjon',
      STATUS_DUE: 'Forfaller',
      EMERGENCY: 'Nødsituasjon',
      STATUS_EXPIRED: 'Utløpt',
      HIGH: 'Høy',
      IN_DUE: 'OM {{differenceInDays}} DAGER',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_TYPE: 'Ugyldig filtype. Bare PDF, JPEG og PNG er tillatt.',
      SUPPORT_TYPE_INPUT_LABEL: 'Problemtype',
      LIFECYCLE_MAINTAINANCE: 'Livssyklusvedlikehold',
      LIFECYCLE_MAINTENANCE: 'Livssyklusvedlikehold',
      LOCATION: 'Sted(er)',
      LOW: 'Lav',
      MAINTENANCE_HISTORY: 'Vedlikeholdshistorikk',
      MAINTENANCE_REQUEST: 'Vedlikeholdsforespørsel',
      MEDIUM: 'Medium',
      NO_CUSTOMER_LINKED: 'Ingen kundetilknyttet',
      NO_DOC_ADDED: 'Ingen dokumentasjon lagt til',
      NO_MAINTENACE_FOUND: 'Ingen vedlikehold funnet',
      NO_NOTES_ADDED: 'Ingen notater lagt til',
      NOTES: 'Notater',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_FILE_SIZE: 'Én eller flere filer overskrider størrelsesgrensen på 2 MB.',
      PAST_DUE: 'Forfalt',
      PRIORITY: 'Prioritet',
      STATUS_REJECTED: 'Avvist',
      REOPEN_SERVICE_TICKET: 'Åpne servicebillett på nytt',
      REQUEST_PRIORITY_INPUT_LABEL: 'Be om prioritet',
      REQ_MAINTENANCE: 'Forespurt vedlikehold',
      REQUESTED_MAINTAINANCE: 'Forespurt vedlikehold',
      SCHEDULED: 'Planlagt',
      STATUS_SCHEDULED: 'Planlagt',
      SCH_SERVICE_DATE: 'Planlagt servicedato',
      SEARCH: 'Søk på billettnummer',
      SERVICE_DATE: 'Servicedato',
      SERVICE_TICKET_NO: 'Servicebillettnummer',
      SERVICE_TYPE: 'Tjenestetype',
      SUPPORT_TECHNICIAN: 'Supporttekniker',
      SYS_FAILURE: 'Systemfeil',
      SYSTEM_FAILURE: 'Systemfeil',
      TICKET_CLOSED: 'Billett stengt',
      TICKET_NO: 'Billettnummer',
      STATUS: 'Billettstatus: Alle',
      TODAY: 'I DAG',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_MAX_3_FILES: 'Du kan bare velge opptil 3 filer.',
      EDIT_SERVICE_TICKET: 'Rediger servicebillett',
      MAINTENANCE_OPERATIONS: 'Vedlikeholdsoperasjoner',
      SCHEDULED_MAINTENANCE: 'Planlagt vedlikehold',
      RECENT_MAINTENANCE: 'Nylig vedlikehold',
      CLOSE_SERVICE_TICKET: 'Lukk servicebillett',
      CLOSE_TICKET: 'Lukk billett',
      DESCRIBE_ACTION: 'Beskriv handlinger som er tatt for å løse problemet',
      TICKET_RESOLUTION: 'Billettoppløsning',
      CLOSED_BY: 'Stengt av',
},
    ASSETS_DETAILS: {
      ADD_BUILDINGS: '+ Legg til bygning',
      ADD_SYSTEMS: '+ Legg til system',
      NEW_MAINTAINENCE: '+ Nytt vedlikehold',
      BUILDINGS: 'Bygninger',
      CUSTOMER_MAINTAINENCE_HEADER: 'Kundedetaljer',
      CUSTOMER_INFO_HEADER: 'Kundeinfo',
      DOWNLOAD_AS: 'Last ned som...',
      FIRMWARE: 'Fastvare',
      GATEWAYS: 'Porter',
      LINK_TO_CUSTOMER_BUTTON: 'Link til kunde',
      MAIN_CONTACT: 'Hovedkontakt',
      RIGHT_MAINTAINENCE_HEADER: 'Vedlikeholdsdetaljer',
      MOST_RECENT_STATUS: 'Siste status',
      NOTIFY_USERS_MAINTAINENCE_HEADER: 'Varsle brukere:',
      SUBHEADER_TEXT_MAINTAINENCE: 'Se gjennom informasjonen, tilordne en tekniker og ta med eventuelle nyttige detaljer for å fikse problemet.',
      PREVIOUS_SYSTEM_STATUS: 'Tidligere systemstatus',
      CREATE_MAINTAINENCE_HEADER: 'Planlegg en ny vedlikeholdsoperasjon',
      ADD_BUILDING_ASSET: 'Velg en organisasjon for å opprette en bygning',
      SELECT_ORGANIZATION_LABEL: 'Velg organisasjon',
      SHOW_FAVORITE_BUILDINGS: 'Vis kun stjernemerkede bygninger',
      SHOW_FAVORITE_GATEWAYS: 'Vis kun stjernemerkede gatewayer',
      SHOW_FAVORITE_SYSTEMS: 'Vis kun stjernemerkede systemer',
      SLA_SUBTITLE: 'SLA#',
      LEFT_MAINTAINENCE_HEADER: 'Systemdetaljer',
      SYSTEM_NAME_TYPE_SUBTITLE: 'Systemnavn og type',
      SYSTEMS: 'Systemer',
      HELPER_TEXT_MAINTAINENCE: 'Denne forespørselen vil varsle {{customerName}} primære og sekundære kontakter. Den vil inkludere relevant plassering, enhet, alarm og hendelsesinformasjon som standard.',
},
    COMMON: {
      REQUIRES_FIRMWARE_UPDATE: '1 krever fastvareoppdatering',
      NOTIFICATION_REPORT_MESSAGE_BODY: 'En ny månedlig rapport for: \n {{bodytext}} er tilgjengelig for visning',
      ACCESS: 'Adgang',
      ACTIVE: 'Aktiv',
      ALERT: 'Varsle!',
      DOWNLOAD_PERMISSION: 'Tillat tillatelsene til å lagre filen på enheten din',
      GO_BACK: 'GÅ TILBAKE',
      NOTIFICATION_EVENT_OCCURED: 'En {{logType}} har oppstått med følgende system',
      ASSETS: 'Eiendeler',
      BACK: 'Tilbake',
      BLOCKED: 'BLOKKERT',
      CANCEL: 'Kansellere',
      CANNOT_REFRESH_TOKEN: 'Kan ikke oppdatere token',
      CLOSE: 'Lukke',
      SET_ETHERNET: 'Konfigurer portinnstillinger',
      CONFIRM: 'Bekrefte',
      CONNECT: 'Koble til',
      CONNECTION: 'Forbindelse',
      CSV: 'CSV',
      DASHBOARD: 'Dashbord',
      DESCRIPTION: 'Beskrivelse',
      DISCARD: 'Kast',
      DISCARD_UNSAVED_CHANGE: 'Vil du forkaste ulagrede endringer?',
      DONE: 'Ferdig',
      DOWNLOAD: 'Last ned',
      DOWNLOAD_FAILED: 'Nedlasting mislyktes. Prøv igjen',
      COMPANY: 'Eaton',
      EDIT: 'Redigere',
      APP_NAME: 'Byggsikkerhetssjef',
      EMPTY: 'TØMME',
      EXCEL: 'Excel-fil',
      EXIT: 'Gå',
      EXTEND: 'Forlenge',
      DOWNLOAD_SUCCESS: 'Filen ble lastet ned.',
      ANOMALY: 'I ANOMALI',
      INACTIVE: 'Inaktiv',
      INCOMPLETE: 'Ufullstendig',
      INFO: 'Info',
      INTERVAL: 'Intervall',
      KEEP_EDITING: 'Fortsett å redigere',
      LAST_RETREIVED: 'Sist hentet:',
      LAST_RETRIEVED: 'Sist hentet: -- min siden',
      LINK: 'Link',
      LOCATE: 'Finn',
      LOGBOOK: 'Loggbok',
      LOGGED_IN_SUCCESSFULLY: 'Logget på vellykket',
      NOTIFICATION_NEW_REPORT_AVAILABLE: 'Ny rapport tilgjengelig',
      NEWUSER: 'Ny bruker',
      NEXT: 'Neste',
      NODATA: 'Ingen data',
      OFF: 'av',
      OFFLINE: 'Frakoblet',
      OK: 'Ok',
      ON: 'på',
      PASSWORD: 'Passord',
      PDF: 'PDF',
      SELECT_PREFERRED_LANGUAGE: 'Vennligst velg ditt \nforetrukket språk',
      POWERED_BY_BRIGHTLAYER: 'Drevet av Brightlayer',
      READY: 'FERDIG',
      RECOONECTTOGATWAY: 'Koble til gateway på nytt',
      REFRESH: 'Forfriske',
      REMOVE: 'Fjerne',
      RETURNTODASHBOARD: 'Gå tilbake til dashbordet',
      NAVIGATION_HEADER: 'Sikkerhetsstyringssystem',
      SAVE: 'Spare',
      REFRESH_TOKEN_ERROR: 'Sikkerhetstoken må ikke være null eller tom',
      SESSION_ALERT_TITLE: 'Tidsavbrudd for økten',
      SET: 'Sett',
      SETTINGS: 'Innstillinger',
      VIEW_ALL_SYSTEM: 'Vis alle',
      SKIP: 'Hopp over',
      STOP: 'Stoppe',
      PERMISSION_ERROR: 'Lagringstillatelse ikke gitt',
      SYNC: 'Synkroniser',
      SYNCH_OFFLINE_DATABASE: 'Synkroniser frakoblet database',
      SYSTEM: 'System',
      SESSION_ALERT_SUBTITLE: 'Dette vinduet har vært inaktivt i 15 minutter. Hvis du ikke gjør noe innen {{extendTime}}, vil du bli logget ut.',
      TIME: 'Tid',
      TRYAGAIN: 'Prøv igjen',
      DOWNLOAD_FAIL: 'Kan ikke laste ned, prøv igjen.',
      UNAUTHORIZED_ACCESS: 'Uautorisert tilgang',
      UNLINK: 'Fjern tilknytningen',
      USERS: 'Brukere',
      VIEW: 'Utsikt',
      WELCOME: 'Velkomst',
      YES: 'Ja',
      EMPTY_SYSTEM_TITLE: 'Du har ingen ressurser i denne organisasjonen ennå.',
      EMPTY_SYSTEM_SUBTITLE: 'Du vil se statusinformasjon om nødlysene dine når du begynner å legge til eiendeler (systemer) til denne organisasjonen.',
      ERROR_OCCURED: 'Det oppsto feil i',
      OOPS: 'Oops!',
      THERE_IS_ERROR: 'Det er en feil',
      NEW_VERSION_AVAILABLE: 'Ny versjon av appen tilgjengelig i',
      UNDER_MAINTENANCE: 'Appen er for øyeblikket under vedlikehold.',
      UNDER_MAINTENANCE_TITLE: 'App under vedlikehold',
      UPDATE_AVAILABLE_TITLE: 'Oppdatering tilgjengelig',
      UPDATE_REQUIRED_TITLE: 'Oppdatering kreves',
      UPDATE_NOW: 'Oppdater nå',
      ASK_ME_LATER: 'Spør meg senere',
      EMPTY_TRIGGERS_LINE: 'Ingen valgfrie utløsere er konfigurert.',
      ASSIGN: 'Tildele',
      OKTA_LOGOUT_ALERT: 'Er du sikker på at du vil logge ut fra okta?',
      OKTA_LOGIN_BUTTON: 'Logg på med Okta',
      CANNOT_PROCCED_LOGIN: 'Du er en uautorisert bruker. Vennligst meld deg på.',
      UNAUTHORIZED_ACCESS_OKTA: 'Autorisasjonsfeil',
      SCAN: 'Skann',
      NO: 'Ingen',
      ACKNOWLEDGE: 'Bekrefte',
      DAYS: 'Dager',
      VALID_EMAIL_ERROR: 'Vennligst skriv inn en gyldig e-post',
      TRANSFER_LUMINARIES: 'Overføre',
      TRIGGERS: 'Utløsere',
      SELECTED: 'Valgt',
      NAME: 'Navn',
},
    PASSWORD_REQUIREMENTS: {
      LENGTH: '8-16 tegn',
      LOWER: 'En liten bokstav',
      NUMBERS: 'Ett tall',
      SPECIAL: 'En spesiell karakter',
      UPPER: 'Én stor bokstav',
},
    AUTH_TRANSLATION: {
      FORGOT_PASSWORD: {
        LINK_SENT_ALT: 'En lenke for å tilbakestille passordet ditt er sendt til <1>{{email}}</1>.',
        LINK_SENT: 'En lenke for å tilbakestille passordet ditt er sendt til <b>{{email}}</b>.',
        ERROR: 'Kunne ikke tilbakestille passordet ditt nå.',
        INSTRUCTIONS_ALT: 'Vennligst skriv inn e-postadressen for kontoen som er knyttet til kontoen',
        INSTRUCTIONS: 'Vennligst skriv inn e-postadressen for kontoen som er knyttet til kontoen.\nHvis denne e-posten har en konto hos Eaton, vil du motta et svar innen <b>én virkedag</b>.\nFor presserende kontoproblemer, vennligst ring {{telefon}}.',
        RESET_CODE_ERROR: ' Det oppsto en feil med tilbakestillingskoden.',
},
      MESSAGES: {
        USER_PHONE_NUMBER_INVALID: 'Et telefonnummer er ugyldig',
        CONGRATS: 'Gratulerer!',
        CONTACT: 'Kontakt en Eaton-støtterepresentant',
        EMAIL_SENT: 'E-post sendt',
        ERROR: 'Feil!',
        FAILURE: 'Feil',
        INVALID_VERIFICATION_CODE: 'Bekreftelseskoden er ikke gyldig eller lengden bør være mindre enn 6 tegn',
        LOADING: 'Laster inn...',
        GENERIC_ERROR_MESSAGE: 'Kontakt administratoren din hvis den forespurte operasjonen ikke kan fullføres.',
        EMAIL_ENTRY_ERROR: 'Vennligst skriv inn en gyldig e-post',
        USER_EMAIL_INVALID: 'Vennligst oppgi en gyldig e-postadresse.',
        REQUEST_ERROR: 'Beklager, det oppsto et problem med å sende forespørselen din.',
        SUCCESS: 'Suksess',
        WELCOME: 'Velkomst',
        LOGIN_MESSAGE: 'Du er "logget inn".',
},
      CHANGE_PASSWORD: {
        PROBLEM_OCCURRED: 'Det oppsto et problem:',
        CANCEL: 'Kansellere',
        PASSWORD: 'Endre passord',
        CONFIRM_NEW_PASSWORD: 'Bekreft nytt passord',
        OLD_PASSWORD: 'Gammelt passord',
        PASSWORD_CHANGED: 'Passord endret',
        PASSWORD_INFO: 'Passordet må være minst 8 tegn langt, inneholde minst ett stort tegn, ett lite tegn, ett tall og ett spesialtegn.',
        UPDATE: 'Oppdater',
        EMAIL_CONFIRM_MESSAGE: 'Vi har sendt en bekreftelses-e-post til <b>{{email}}</b>',
        ERROR_MESSAGE: 'Informasjonen din stemte ikke overens med registrene våre. Vennligst skriv inn informasjonen din på nytt for å prøve på nytt.',
        SUCCESS_MESSAGE: 'Passordet ditt ble oppdatert! For å sikre sikkerheten til kontoen din, må du logge på applikasjonen med den oppdaterte legitimasjonen din.',
},
      SELF_REGISTRATION: {
        VERIFY_EMAIL: {
          MESSAGE: 'En bekreftelseskode er sendt til e-postadressen du oppga. Klikk på linken eller skriv inn koden nedenfor for å fortsette. Denne koden er gyldig i 30 minutter.',
          VERIFICATION_CODE_PROMPT: 'Har du ikke mottatt en kode?',
          RESEND: 'Send bekreftelses-e-post på nytt',
          VERIFICATION: 'Verifikasjonskode',
},
        ALREADY_REGISTERED_USER: 'Allerede registrert bruker',
        INSTRUCTIONS: 'For å registrere deg for en Eaton-konto, skriv inn den nødvendige informasjonen nedenfor. Du må angi e-postadressen din for å fortsette.',
},
      REGISTRATION: {
        STEPS: {
          COMPLETE: 'Konto opprettet!',
          ACCOUNT_DETAILS: 'Kontodetaljer',
          COMPANY_ADDRESS: 'Firmaadresse',
          COMPANY_DETAILS: 'Firmadetaljer',
          CREATE_ACCOUNT: 'Opprett en konto',
          PASSWORD: 'Opprett passord',
          LICENSE: 'Lisensavtale',
          VERIFY_EMAIL: 'Bekreft e-post',
},
        EULA: {
          DEUTSCH: 'Deutsch',
          ENGLISH: 'engelsk',
          AGREE_TERMS: 'Jeg har lest og godtar vilkårene og betingelsene',
          LANGUAGE_SUCCESS: 'Språket er oppdatert',
          LOADING: 'Laster inn sluttbrukerlisensavtale...',
},
        INSTRUCTIONS: {
          ACCOUNT_DETAILS: 'Skriv inn opplysningene dine nedenfor for å fullføre kontoopprettelsen.',
          COMPANY_DETAILS: 'Dette hjelper Eaton med å tilby servicestøtte for nødlysløsningen din. Hvis du starter et prosjekt for din klient, vennligst skriv inn informasjonen for ditt eget selskap, ikke din klients.',
          COMPANY_ADDRESS: 'Dette hjelper Eaton med å tilby servicestøtte for nødlysløsningen din. Hvis du starter et prosjekt for din klient, vennligst skriv inn informasjonen for ditt eget selskap, ikke din klients.',
},
        UNKNOWN_EMAIL: 'Ukjent e-post',
        UNKNOWN_ORGANIZATION: '-',
        FAILURE_MESSAGE: 'Vi kunne ikke fullføre registreringen din. Trykk fortsett nedenfor for å fullføre.',
        SUCCESS_MESSAGE_ALT: 'Kontoen din er opprettet med e-postadressen <1>{{email}}</1>.\nKontoen din er allerede lagt til <3>{{organization}}</3>-organisasjonen.\nTrykk fortsett nedenfor for å fullføre.',
        SUCCESS_MESSAGE: 'Kontoen din har blitt {{state}} med e-posten {{email}}.\n\nDu har blitt lagt til {{organisasjon}} .\',',
        SUCCESS_EXISTING: 'Kontoen din er opprettet. Logg på med e-postadressen og passordet for Eaton-kontoen din.',
        SUCCESS_SYNCED_MESSAGE: 'Din EL Digital-konto har synkronisert med Bright Layer Cloud-informasjonen knyttet til e-posten <b>{{email}}</b>.',
        SUCCESS_FINISH: 'Klikk "Fullfør" for å logge på og få tilgang til kontoen din.',
        SUCCESS_DASHBOARD: 'Klikk "Gå til mitt dashbord" for å fortsette kontoen din.',
},
      ACTIONS: {
        BACK: 'Tilbake',
        CANCEL: 'Kansellere',
        CHANGE_LANGUAGE: 'Bytt språk her!',
        CLICK_BUTTON: 'Klikk på knappen',
        UPDATE_REDUX: 'Klikk på knappen for å oppdatere redux-butikkverdien!',
        CONTINUE: 'Fortsette',
        DONE: 'Ferdig',
        FINISH: 'Fullfør',
        GO_HOME: 'Gå til Hjem',
        GO_DASHBOARD: 'Gå til Mitt Dashboard',
        GO_TEST: 'Gå til testsiden',
        LOG_IN: 'Logg inn',
        LOG_OUT: 'Logg ut',
        NEXT: 'Neste',
        OKAY: 'Ok',
        REMEMBER: 'Husk meg',
        RESEND: 'Send på nytt',
        SEND_AGAIN: 'Send på nytt',
        SEND_EMAIL: 'Send e-post',
        CREATE_ACCOUNT: 'Registrer deg',
        UPDATE: 'Oppdater',
},
      FORMS: {
        COMPANY_NAME: 'Firmanavn',
        CONFIRM_PASSWORD: 'Bekreft passord',
        COUNTRY: 'Land',
        CURRENT_PASSWORD_ERROR: 'Gjeldende passord samsvarer ikke',
        FIRST_NAME: 'Fornavn',
        RESET_PASSWORD: 'Glemt passord',
        LAST_NAME: 'Etternavn',
        ORGANAIZATION_ADRESS: 'Organisasjonsadresselinje 1*',
        PASSWORD: 'Passord',
        PASS_MATCH_ERROR: 'Passord stemmer ikke',
        PHONE_NUMBER: 'Telefonnummer',
        TOGGLE_PASSWORD_VISIBILITY: 'Slå passordsynlighet',
},
      LABELS: {
        CURRENT_PASSWORD: 'Gjeldende passord',
        EMAIL: 'E-postadresse',
        FORGOT_PASSWORD: 'Glemt passordet ditt?',
        NEED_ACCOUNT: 'Trenger du en konto?',
        NEW_PASSWORD: 'Nytt passord',
        OPTIONAL: 'Valgfri',
        PASSWORD: 'Passord',
        USERNAME: 'Brukernavn',
},
      LOGIN: {
        INCORRECT_CREDENTIALS: 'Feil e-post eller passord',
        GENERIC_ERROR: 'Forespørselen din kunne ikke behandles på dette tidspunktet.',
        INVALID_CREDENTIALS: 'Ditt brukernavn/passord-kombinasjon gjenkjennes ikke.',
},
      GATEWAY_COMMISSION_STEP: {
        STEP_NUMBER: 'Trinn {{stepNo}} av 4',
},
},
    REGISTRATION: {
      STEPS_MESSAGE: {
        CREATE_ACCOUNT_VERIFY_EMAIL: 'En bekreftelseskode er sendt til e-postadressen du oppga. Klikk på linken eller skriv inn koden nedenfor for å fortsette. Denne koden er gyldig i 30 minutter.',
        CREATE_ACCOUNT_USER_DETAILS: 'Skriv inn opplysningene dine nedenfor for å fullføre kontoopprettelsen.',
        CREATE_ACCOUNT_COMPANY_DETAILS: 'Dette hjelper Eaton med å tilby servicestøtte for nødlysløsningen din. Hvis du starter et prosjekt for din klient, vennligst skriv inn informasjonen for ditt eget selskap, ikke din klients.',
        CREATE_ACCOUNT_ENTER_EMAIL: 'For å registrere deg for en konto for Safety Management System, skriv inn nødvendig informasjon nedenfor. Du må bekrefte e-postadressen din for å fortsette.',
},
      STEPS: {
        COMPLETE_OTHER_ADOPTER: 'Konto bekreftet!',
        COMPLETE: 'Konto opprettet!',
        ACCOUNT_DETAILS: 'Kontodetaljer',
        COMPANY_ADDRESS: 'Firmaadresse',
        COMPANY_DETAILS: 'Firmadetaljer',
        CREATE_ACCOUNT: 'Opprett en konto',
        PASSWORD: 'Opprett passord',
        FORGOT_PASSWORD: 'Glemt passord',
        LICENSE: 'Lisensavtale',
        VERIFY_EMAIL: 'Bekreft e-post',
},
      STEPS_ERROR_MESSAGE: {
        USER_ALREADY_EXIST_MESSAGE: 'Allerede registrert bruker',
        USER_INVALID_ENTRY: 'Inndataparametere kan ikke være null eller tomme.',
        GENERIC_ERROR_MESSAGE: 'Kontakt administratoren din hvis den forespurte operasjonen ikke kan fullføres.',
        USER_EMAIL_INVALID: 'Vennligst oppgi en gyldig e-postadresse.',
        VERIFICATION_CODE_EXPIRED_MESSAGE: 'Koden er utløpt. Klikk på knappen nedenfor for å be om en ny bekreftelses-e-post.',
},
      EULA: {
        LOADING: 'Laster inn sluttbrukerlisensavtale...',
        LANGUAGE: 'Vennligst velg ditt foretrukne språk',
        FRENCH: 'Français',
},
      FAILURE_MESSAGE: 'Vi kunne ikke fullføre registreringen din. Trykk fortsett nedenfor for å fortsette til Eaton ELDigital suite',
      SUCCESS_MESSAGE: 'Kontoen din er opprettet med e-postadressen {{email}}.',
      SUCCESS_MESSAGE_OTHER_ADOPTER: 'Din EL Digital-konto har synkronisert med Bright Layer Cloud-informasjonen knyttet til e-posten <2>{{email}}</2>.',
},
    USER_INVITATION_REGISTRATION: {
      ACCEPT: 'Akseptere',
      DENY: 'Benekte',
      INSTRUCTIONS: ' Hvis denne e-posten har en konto hos Eaton, vil du motta et svar innen <3>én virkedag</3>.<br/><br/>For presserende kontoproblemer, vennligst ring',
      TITLE: 'Sikkerhetsstyringssystem - brukerinvitasjon',
      INVITATION_VALIDATION_ERROR: ' Det oppsto en feil med invitasjonskoden din.',
},
    DASHBORAD: {
      ACCEPT_BUTTON: 'Godta invitasjon',
      ACCEPT_HEADER: 'Godta invitasjonen?',
      ACCEPTED_INVITATION: 'Godtatte invitasjoner',
      ACCEPT_TITLE: 'Hvis du godtar invitasjonen, legges følgende element til profilen din:',
      ADD_NEW_ORGANIZATION: 'Legg til en ny organisasjon...',
      ADD_ANOTHER_ORGANIZATION: 'Legg til en annen organisasjon',
      ALL_BUILDINGS: 'Alle bygninger',
      ALL_CITIES: 'Alle byer',
      ALL_COMPANIES: 'Alle selskaper',
      ALL_COUNTRIES: 'Alle land',
      ALL_CUSTOMER_ID: 'Alle kunde-ID',
      ALL_GATEWAYS: 'Alle gatewayer',
      ALL_ORGANIZATIONS: 'Alle organisasjoner',
      ALL_STATUSES: 'Alle status',
      ALL_STATUS: 'Alle statuser',
      ALL_TYPES: 'Alle typer',
      BLOCKED: 'Blokkert',
      BUILD_DETAILS: 'Bygningsdetaljer',
      BUILDINGS: 'Bygninger',
      CUSTOMERS: 'Kunder',
      DECLINE: 'Avslå',
      DECLINED_INVITATION: 'Avviste invitasjoner',
      DISPLAY_ADDRESS_ON_MAP: 'Vis adresse på kartet',
      MAP_DRAG_TITLE: 'Dra på kartet for å plassere nålen',
      REQUEST_ACCESS_SENT: 'E-postforespørsel om tilgangsinvitasjon sendt til brukeren',
      ERROR: 'Feil',
      EVENT: 'Hendelse',
      EXPIRED_INVITATION: 'Utløpte invitasjoner',
      EXPORT_REPORT: 'Eksporter rapport',
      GATEWAY: 'Porter',
      IN_ANOMALY: ' I Anomali',
      INFORMATION: 'Informasjon',
      INVITATION_HISTORY: 'Invitasjonshistorikk',
      ISSUES: 'problemer',
      JOIN: 'Bli med',
      LIST_VIEW: 'Listevisning',
      MAP_VIEW: 'Kartvisning',
      MONTHLY_REPORT: 'Månedsrapport',
      NO_ISSUES_DURING_THIS_PERIOD: 'Ingen problemer i denne perioden',
      ORG_DETAILS: 'Organisasjonsdetaljer',
      PENDING_INVITATION: 'Ventende invitasjoner',
      CHOOSE_REPORT_YOU_WOULD_LIKE_TO_SAVE_SHARE: 'Velg rapporten du ønsker lagre eller del.',
      PLEASE_MAKE_A_SELECTIONS: 'Vennligst gjør et valg',
      REQUEST_SUBTITLE: 'Vennligst be om tilgang fra personen som sendte invitasjonen for å legge til dette elementet på profilen din.',
      INVITATION_BODY: 'Velg elementer du vil legge til profilen din eller for å avslå en invitasjon.',
      READY: 'Ferdig',
      NO_CONTENT: 'Erstatt denne siden med ditt eget innhold',
      REPORTS: 'Rapporter',
      REQUEST_BUTTON: 'Be om tilgang',
      REQUEST_HEADER: 'Be om tilgang?',
      CHECK_INVITATIONS: ' Skanner etter invitasjoner...',
      SELECT_ALL: 'Velg alle',
      SELECTIONS_CONFIRMED: 'Valg bekreftet',
      SERVICE_MANAGERS: 'Tjenesteledere',
      SYSTEMS: 'Systemer',
      TECHNICIANS: 'Teknikere',
      EMPTY_ACCEPTED_INVITATION: 'Det er ingen aksepterte invitasjoner for øyeblikket',
      EMPTY_DECLINED_INVITATION: 'Det er ingen avslåtte invitasjoner for øyeblikket',
      EMPTY_EXPIRED_INVITATION: 'Det er ingen utløpte invitasjoner for øyeblikket',
      EMPTY_REQUESTED_INVITATION: 'Det er ingen forespurte invitasjoner for øyeblikket',
      REQUEST_TITLE: 'Denne invitasjonen er utløpt og kan ikke lenger legges til profilen din.',
      TOTAL_ACCEPTED_INVITATIONS: 'Totalt antall aksepterte invitasjoner',
      TOTAL_LUMINAIRES: 'Totalt armaturer',
      TOTAL_SYSTEMS: 'Totale systemer',
      UPDATING_PROFILE: 'Oppdaterer profilen din...',
      VIEW_ALL: 'Vis alle',
      VIEW_ALL_ACCESS_RIGHTS: 'Se alle rettigheter',
      VIEW_ALL_BUIDINGS: 'Se alle bygninger',
      VIEW_ALL_SYSTEM: 'Se alle systemer',
      WARNING: 'Advarsel',
      INVITATION_SUB_HEADING: 'Du har blitt invitert til følgende prosjekter:',
      REPORTS_BUILDINGS: 'Bygninger',
      REPORTS_SYSTEMS: 'Systemer',
      EMPTY_ZONE: 'Tømme',
      TEST_ZONE: 'Test',
},
    TRANSFER_BUILDINGS: {
      PASSWORD: 'Kontopassord',
      ERRORMESSAGE: 'Påloggingsgrensene er overskredet. prøv igjen etter en stund',
      HEADER: 'Overfør permanent alle {{buildingCount}} bygninger, inkludert alle X-gatewayene og {{systemCount}} systemene under den, til en annen organisasjon. Du må være organisasjonsadministratorer i begge organisasjonene for å utføre handlingen.',
      ACTION: 'Skriv inn kontopassordet ditt for å bekrefte handlingen.',
      TRANSFER_TO: 'Overfør til...',
},
    MERGE_ASSETS: {
      PASSWORD: 'Kontopassord',
      MERGE_DELETE: 'Slå sammen og slett',
      MERGE_ASSETS_TITLE: 'Slå sammen eiendeler til en annen bygning',
      SUCCESS: 'Sammenslått bygningselementer vellykket',
      ACTION: 'Skriv inn kontopassordet ditt for å bekrefte handlingen.',
      HEADER: 'Overfør alle {{gatewayCount}} gatewayer og {{systemCount}} systemer under den, til en annen bygning og slett den gjeldende permanent.',
      TRANSFER_TO: 'Overfør til...',
},
    DRAWER: {
      ACCOUNTPREFERENCES: 'Kontoinnstillinger',
      RIGHTS_RESERVED: 'Alle rettigheter forbeholdt',
      ASSETS: 'Eiendeler',
      COPYRIGHT: 'Copyright © Eaton',
      DASHBOARD: 'Dashbord',
      OVERVIEW: 'Dashbord',
      DEVICES: 'Enheter',
      HELP: 'Hjelp',
      HELPANDFEEDBACK: 'Hjelp og tilbakemelding',
      LEGAL: 'Lovlig',
      LOCATIONS: 'Steder',
      LOGBOOK: 'Loggbok',
      MAINTENANCE: 'Vedlikehold',
      MANAGELOCATION: 'Administrer steder og nettsteder',
      MANAGEUSER: 'Administrer brukere',
      ORGSETTINGS: 'Mine organisasjoner',
      MYPROFILE: 'Min profil',
      REPORTS: 'Rapporter',
      ELDIGITAL: 'Sikkerhetsstyringssystem',
      SELECT_ACCOUNT: 'Velg Konto',
      SETTINGS: 'Innstillinger',
      TIMELINE: 'Tidslinje',
      USERS: 'Brukere',
},
    SETTINGS: {
      TITLE: 'Kontoinnstillinger',
      SUBTITLE: 'Administratornivå – brukere',
},
    NAVIGATION_DRAWER: {
      ACCOUNT_PREFERENCES: 'Kontoinnstillinger',
      ALL_RIGHTS_RESERVED: 'Alle rettigheter forbeholdt',
      CHANGE_PASSWORD: 'Endre passord',
      COPYRIGHT: 'Opphavsrett',
      HELP_AND_FEEDBACK: 'Hjelp og tilbakemelding',
      LEGAL: 'Lovlig',
      LOGOUT: 'Logg ut',
      PROJECT_SETTINGS: 'Mine organisasjoner',
      REPORTS: 'Rapporter',
      USERS: 'Brukere',
},
    USER_MENU: {
      ACCOUNT_SETTING: 'Kontoinnstillinger',
      CONTACT_US: 'Kontakt oss',
      LOG_OUT: 'Logg ut',
},
    USER_DETAIL: {
      ACTIVE: 'AKTIV',
      COMPANY_ADRESS: 'Firmaadresse',
      COMPANY_DETAIL: 'Firmadetaljer',
      COMPANY_NAME: 'Firmanavn',
      COMPANY_PHONE_NUMBER: 'Selskapets telefonnummer',
      EMAIL_ID: 'E-postadresse',
      INACTIVE: 'INAKTIV',
      PERSONAL_ADRESS: 'stillingstittel',
      LEAVE_ORGANISATION: 'Gå ut av organisasjonen',
      JOB_TITLE: 'Personlig adresse',
      PERSONAL_PHONE_NUMBER: 'Personlig telefonnummer',
      PHONE_NUMBER: 'Telefonnummer',
      REMOVE_USER: 'Fjern bruker',
      USER_NAME: 'Brukernavn',
},
    FILTER: {
      ACTIVE_LOGS_ONLY: 'Bare aktive logger',
      ALL: 'Alle',
      ALL_LOG_TYPES: 'Alle loggtyper',
      CUSTOM: 'Skikk...',
      PAST_TWELVE_MONTHS: 'Siste 12 måneder',
      PAST_SIX_MONTHS: 'Siste 6 måneder',
      SINCE_THE_BEGINNING_OF_YEAR: 'Siden begynnelsen av {{currentyear}}',
},
    LOGBOOK: {
      LOGBOOK_ACTIVELOG: 'Bare aktive logger',
      LOGBOOK_ALL: 'Alle',
      LOGBOOK_ALLLOG: 'Alle loggtyper',
      CUSTOM_LOGBOOK_RANGE: 'Tilpasset loggbokområde',
      CUSTOM: 'Skikk...',
      END_DATE: 'Sluttdato',
      LOGBOOK_GROUPBY: 'Grupper etter:',
      PAST_TWELVE_MONTHS: 'Siste 12 måneder',
      PAST_SIX_MONTHS: 'Siste 6 måneder',
      FILTER_DOWNLOAD_TEXT: 'Bruk et filter for å laste ned loggboken.',
      LOGBOOK_SHOW: 'Vis :',
      SINCE_THE_BEGINNING_OF_YEAR: 'Siden begynnelsen av {{currentyear}}',
      START_DATE: 'Startdato',
      LOGBOOK_TIME_RANGE: 'Tidsområde:',
},
    BUILDING_DETAILS: {
      ADD_BUILDING: 'Legg bygning til',
      ALL_SYSTEMS: 'Alle systemer',
      VIEW_ALL_GATEWAYS: 'Vis alle gatewayer',
},
    ADD_ORGANIZATION: {
      ORG_ADD_DESCRIPTION: 'Legg til valgfrie tilleggskommentarer for å hjelpe serviceteamet ditt.',
      ADDITIONAL_DESC: 'Tilleggsbeskrivelse',
      ORG_ADD_BLDG_BELONGS: 'tilhører.',
      CREATE_ORGANIZATION_TITLE: 'Opprett organisasjon',
      ORG_SUBTITLE: 'Å opprette en organisasjon lar deg gruppere bygninger og koordinere tilsynet med EL Systems.',
      DETAILS_FOR: 'Detaljer for',
      ORG_FOR: 'til',
      INVALID_CHARACTER: 'Ugyldig tegn',
      ORG_NAMELENGTH: ' Kun bokstaver, tall, understrek og bindestreker',
      ORG_ADD_BLDG: ' La oss nå legge til bygningen der',
      ORGANIZATION_CREATED: 'Organisasjon opprettet',
      VALID_EMAIL_ERROR: 'Vennligst skriv inn en gyldig e-post',
      ORG_PRIMARYCONTACT: 'Primær kontakt',
      ORG_PROVIDED_DETAILS: 'Oppgi detaljer i tilfelle xxx er nødvendig.',
      ORG_SECONDARYCONTACT: 'Sekundær kontakt (valgfritt)',
      ORG_SKIPBUTTON: 'Hopp over nå',
      ORG_SKIPMESSAGE: 'Hopp over for å fylle ut kontaktinformasjon individuelt for hver bygning.',
      ORG_SUCCESS: 'Vellykket opprettet organisasjon',
      ALPHABET_INPUT: 'Tar alfabetet som input',
      ALPHANUMERIC_INPUT: 'Tar alfanumerisk som input',
      ALPHANUMERIC_DASH_UNDERSCORE_INPUT: 'Tar alfanumerisk, bindestrek, understrek som input',
      ORG_HELPTEXT: 'Dette hjelper elektrikere fra Eaton og andre utenfor bedriften din til å komme raskt på stedet.',
      ORGANIZATION_DETAILS: 'Hvem skal elektrikere kontakte',
},
    MANAGE_USERS: {
      ADVANCED_INVITE_USER_ORGANIZATION_SELECTION: 'Legg dem til organisasjoner:',
      INVITE_USER_ORGANIZATION_LABEL: 'Legg til i organisasjonen ... *',
      USER_ROLE_ADMIN: 'Admin',
      ADVANCED_INVITE_ADMIN: ' Administrator:',
      ADVANCED_INVITE: 'Avansert invitasjon',
      INVITE_USER_ADVANCE: 'Avansert…',
      INVITE_USER_AS: 'Som',
      ADVANCED_INVITE_USER_SELECTION: 'Velg en ny eller eksisterende bruker:',
      INVITE_USER_EMAIL_NAME: 'E-post *',
      INVITE_USER_EMAIL: 'E-post *',
      INVITE_USER_EMAIL_USER_NAME: 'E-post eller brukernavn *',
      INVITE_USER_SUBTITLE: 'Gi tilgang til nye eller eksisterende brukere',
      ADVANCED_INVITE_SUBTITLE: 'Gi tilgang til spesifikke organisasjoner, bygninger og systemer.',
      ADVANCED_INVITE_ADMIN_DESCRIPTION: 'gi full tilgang til alt innenfor det tildelte nivået.',
      ADVANCED_INVITE_LIMITED_DESCRIPTION: 'gi minimum visningsrettigheter slik at en bruker bare ser grunnleggende informasjon om det som er avgjørende for rollen deres. Dette er nyttig når noen bare trenger å overvåke ett system i en bygning.',
      ADVANCED_INVITE_VIEWER_DESCRIPTION: 'gi visningsrettigheter til alt innenfor et tildelt nivå.',
      INVITATION_FAIL_HEADER: 'Invitasjon utløpt',
      INVITE_USER_AS_COLLEAGUE: 'Inviter som kollega',
      INVITE_USER: 'Inviter bruker',
      INVITE_SUCCESS_MESSAGE_SINGLE: 'Inviterte {{email}} til {{organisasjon}}.',
      INVITE_SUCCESS_MESSAGE_MULTIPLE: 'Inviterte {{email}} til {{organizationCount}} organisasjoner.',
      USER_ROLE_LIMITED: 'Begrenset',
      ADVANCED_INVITE_LIMITED: ' Begrenset:',
      MY_DETAILS_HEADER: 'Mine detaljer',
      OTHER_USER_LIST_HEADER: ' Andre brukere',
      ADVANCED_INVITE_PLEASE_ASSIGN_ROLES: 'Tildel roller for {{email}}-tilgang til organisasjoner, bygninger og systemer.',
      REMOVE_USER: 'Vil du fjerne {{name}} fra "{{title}}"?',
      INVITATION_REQUEST_ACTION: 'Be om en ny invitasjon',
      INVITE_USER_ORGANIZATION_SELECT_ALL: 'Velg alle',
      INVITE_USER_SEND_INVITE: 'Send invitasjon',
      INVITATION_FAIL_BODY: 'Denne e-postinvitasjonslinken er utløpt. Kontakt systemadministratoren din for å få en ny e-postinvitasjon.',
      USERS_IN_HEADER: ' Brukere i',
      USER_ROLE_VIEWER: 'Seer',
      ADVANCED_INVITE_VIEWER: ' Seer:',
},
    ORGANIZATION_DETAILS: {
      ADDRESS: 'Adresse',
      BUILDING_DETAILS: 'Bygningsdetaljer',
      DELETE_FOREVER: 'Slett for alltid',
      EDIT_BUILDING: 'Rediger bygning',
      EDIT_ORGANIZATION: 'Rediger organisasjon',
      EMAIL_ADDRESS: 'E-postadresse',
      MERGE_ASSETS: 'Slå sammen eiendeler til en annen bygning',
      ORGANIZATION: 'Organisasjon',
      ORGANIZATION_DETAILS: 'Organisasjonsdetaljer',
      PHONE_NUMBER: 'Telefonnummer',
      PRIMARY_CONTACT: 'Primær kontakt',
      PRIMARY_CONTACT_EMAIL_ADDRESS: 'E-postadresse for primær kontakt',
      PRIMARY_CONTACT_PHONE_NUMBER: 'Primært kontakttelefonnummer',
      SECONDARY_CONTACT: 'Sekundær kontakt',
      SECONDARY_CONTACT_EMAIL_ADDRESS: 'Sekundær kontakt-e-postadresse',
      SECONDARY_CONTACT_PHONE_NUMBER: 'Sekundært telefonnummer',
      TRANSFER_BUILDINGS: 'Overfør bygninger til en annen organisasjon',
      USERS: 'Brukere',
},
    COMMON_INPUT: {
      COMMON_ADDRESS: 'Adresse',
      COMMON_ADDRESSLINE2: 'Adresselinje 2 (valgfritt)',
      COMMON_BUILDINGNAME: 'Bygningens navn',
      COMMON_CITY: 'By',
      COMMON_COUNTRY: 'Land',
      COMMON_OPTIONALDESC: 'Beskrivelse (valgfritt)',
      COMMON_EMAIL_ADDRESS: 'E-postadresse',
      COMMON_NAME: 'Organisasjonsnavn',
      COMMON_PHONENUMBER: 'Telefonnummer',
      VALID_ADDRESS: 'Vennligst skriv inn en gyldig adresse',
      VALID_PHONE_ERROR: 'Vennligst skriv inn et gyldig telefonnummer',
      VALID_POSTAL_CODE: 'Vennligst skriv inn et gyldig postnummer',
      VALID_CITY_ERROR: 'Vennligst skriv inn gyldig by',
      VALID_COMPANY_ERROR: 'Vennligst skriv inn gyldig selskap',
      VALID_FIRSTNAME_ERROR: 'Vennligst skriv inn gyldig fornavn',
      VALID_LASTNAME_ERROR: 'Vennligst skriv inn gyldig etternavn',
      VALID_VERIFICATION_CODE: 'Vennligst skriv inn gyldig bekreftelseskode',
      COMMON_POSTALCODE: 'Postnummer',
},
    TOAST_MSG: {
      CREATE_CUSTOMER_ERROR_CODE_9069: 'Adressen er ikke gyldig eller lengden må være mindre enn eller lik 250 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9070: 'Adresse2 er ikke gyldig eller lengden skal være mindre enn eller lik 250 tegn',
      INVITE_TECHNICIAN_ERROR_CODE_9130: 'Administratorrettigheter kreves for å invitere bruker',
      INVITE_USER_ERROR_CODE_9130: 'Administratorrettigheter kreves for å invitere bruker.',
      TOAST_ERROR_MERGE_ASSET_9213: 'Administratorrettigheter kreves for å slå sammen eiendeler',
      TOAST_SUCCESS_BUILDING_CREATE: 'Bygningen ble opprettet',
      BUILDING_LIST_API_FAILURE: 'Byggeoppføringen mislyktes',
      BUILDING_TRANSFER_FAILURE: 'Bygningsoverføring oppstod en feil',
      BUILDING_TRANSFER_SUCCESS: 'Bygningsoverføring vellykket',
      TOAST_SUCCESS_BUILDING_UPDATE: 'Bygningen ble oppdatert',
      INVITE_USER_ERROR_CODE_9143: 'Kan ikke forringe brukerrollen.',
      CREATE_CUSTOMER_ERROR_CODE_9072: 'By er ikke gyldig eller lengden må være mindre enn eller lik 50 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9164: 'Firmakommentaren er ikke gyldig eller lengden bør være mindre enn eller lik 255 tegn.',
      CREATE_CUSTOMER_ERROR_CODE_9040: 'Bedriftens landskode er ikke gyldig',
      CREATE_CUSTOMER_ERROR_CODE_9170: 'Firmanavn er allerede tilgjengelig.',
      CREATE_CUSTOMER_ERROR_CODE_9023: 'Firmaets telefonnummer er ikke gyldig eller lengden skal være mellom 8 og 10',
      CREATE_CUSTOMER_ERROR_CODE_9073: 'Landskoden er ikke gyldig eller lengden skal være mindre enn eller lik 4 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9068: 'Landet er ikke gyldig eller lengden må være mindre enn eller lik 50 tegn',
      CREATE_MAINTAINANCE_API_FAILURE: 'Oppretting av vedlikeholds-API mislyktes',
      TOAST_SUCCESS_CUSTOMER_CREATED: 'Kunden ble opprettet',
      CUSTOMER_DETAIL_SUCCESS: 'Kundedetaljene ble hentet',
      TOAST_ERROR_GET_CUSTOMER_INFO: 'Henting av kundeopplysninger mislyktes',
      CREATE_CUSTOMER_ERROR_CODE_9225: 'Kundenummer er allerede tilgjengelig.',
      CREATE_CUSTOMER_ERROR_CODE_9172: 'Kundenummeret er ikke gyldig eller lengden bør være mellom 8 og 16 tegn.',
      CREATE_MAINTAINANCE_ERROR_CODE_9078: 'Beskrivelsen er ikke gyldig eller lengden må være mindre enn eller lik 255 tegn',
      DEVICE_LIST_API_FAILURE: 'Enhetsoppføringen mislyktes',
      ACKNOWLEDGE_LOG_SUCCESS: 'Enhetsloggdetaljer er godkjent',
      CREATE_CUSTOMER_ERROR_CODE_9043: 'E-posten er ikke gyldig eller lengden skal være mindre enn eller lik 75 tegn',
      INVITE_TECHNICIAN_ERROR_CODE_9043: 'E-posten er ikke gyldig eller lengden skal være mindre enn eller lik 75 tegn',
      INVITE_USER_ERROR_CODE_9043: 'E-posten er ikke gyldig eller lengden skal være mindre enn eller lik 75 tegn',
      INVITE_TECHNICIAN_ERROR_CODE_9136: 'Entitet eller rolletype er ikke gyldig inndata eller samsvarer ikke i enhetstype og rolletype',
      INVITE_USER_ERROR_CODE_9136: 'Entitet eller rolletype er ikke gyldig inndata eller samsvarer ikke i enhetstype og rolletype.',
      INVITE_TECHNICIAN_ERROR_CODE_9127: 'EntityId er duplikat eller ugyldig inndata',
      INVITE_USER_ERROR_CODE_9127: 'EntityId er duplikat eller ugyldig inndata',
      TOAST_ERROR_BUILDING_UPDATE: ' Kunne ikke utføre bygningsoppdateringen',
      CREATE_MAINTAINANCE_ERROR_CODE_9219: 'Filnavnet er ikke gyldig eller lengden må være mindre enn eller lik 50 tegn',
      TOAST_ERROR_GET_PASS_DETAILS: 'Hent PAAS-detaljer api mislyktes',
      REMOVE_ACCESS_ERROR_CODE_3057: 'Ugyldig enhets-ID. Oppgi gyldig enhets-ID',
      REMOVE_ACCESS_ERROR_CODE_3059: 'Ugyldig enhetstype. Oppgi gyldig enhetstype',
      TOAST_ERROR_LINK_CUSTOMER_9203: 'Ugyldig SLA TYPE Enum.',
      REMOVE_ACCESS_ERROR_CODE_2007: 'Ugyldig bruker-ID. Oppgi gyldig GUID',
      INVITE_TECHNICIAN_ERROR_CODE_9159: 'Invitasjon og invitert av bruker skal ikke være det samme',
      INVITE_USER_ERROR_CODE_9159: 'Invitasjon og invitert av bruker skal ikke være det samme',
      UPDATE_LOG_COMMENTS_SUCCESS: 'Loggkommentarer er oppdatert',
      ACKNOWLEDGE_LOG_API_FAILURE: 'Loggbekreftelse mislyktes',
      CREATE_MAINTAINANCE_SUCCESS: 'Vedlikeholdsaktivitet opprettet',
      TOAST_ERROR_MERGE_ASSET_9214: 'Ingen eiendeler å slå sammen',
      CREATE_MAINTAINANCE_ERROR_CODE_9221: 'Antall dokument skal være mindre enn eller lik 3',
      TOAST_SUCCESS_ORG_CREATE: 'Organisasjonen ble opprettet',
      TOAST_ERROR_ORG_UPDATE: 'Organisasjonen mislyktes',
      TOAST_SUCCESS_ORG_UPDATE: 'Organisasjonen ble oppdatert',
      CREATE_CUSTOMER_ERROR_CODE_9074: 'Telefonnummeret er ugyldig eller lengden bør være mellom 8 og 10.',
      TOAST_ERROR_MESSAGE: 'Fyll ut alle detaljene riktig før innsending',
      CREATE_MAINTAINANCE_ERROR_CODE_9220: 'Vennligst oppgi gyldig bruker-ID for tildelt til tekniker',
      TOAST_ERROR_MERGE_ASSET_9048: 'Vennligst oppgi gyldig bygnings-ID.',
      CREATE_CUSTOMER_ERROR_CODE_9167: 'Vennligst oppgi gyldig kontakttype.',
      CREATE_MAINTAINANCE_ERROR_CODE_9185: 'Vennligst oppgi gyldig kunde-ID',
      TOAST_ERROR_MERGE_ASSET_9210: 'Oppgi gyldig destinasjonsbygnings-ID.',
      CREATE_MAINTAINANCE_ERROR_CODE_9217: 'Vennligst oppgi gyldig lenke',
      CREATE_CUSTOMER_ERROR_CODE_9163: 'Oppgi gyldig navn eller lengde skal være mindre enn eller lik 24 tegn',
      CREATE_MAINTAINANCE_ERROR_CODE_9215: 'Vennligst oppgi gyldig forespørselstype',
      CREATE_MAINTAINANCE_ERROR_CODE_9228: 'Vennligst oppgi gyldig tjenestedato',
      CREATE_MAINTAINANCE_ERROR_CODE_9216: 'Vennligst oppgi gyldig tjenestetype',
      CREATE_MAINTAINANCE_ERROR_CODE_9050: 'Vennligst oppgi gyldig system-ID',
      CREATE_CUSTOMER_ERROR_CODE_9071: 'Postnummeret er ikke gyldig eller lengden bør være mellom 4 og 10 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9165: 'Primærkontaktkommentaren er ikke gyldig eller lengden bør være mindre enn eller lik 255 tegn.',
      CREATE_CUSTOMER_ERROR_CODE_9175: 'Primær landskode2 er ikke gyldig eller lengden må være mindre enn eller lik 4 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9150: 'Primært fornavn er ikke gyldig eller lengden bør være mellom 1 og 50 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9151: 'Primæretternavnet er ikke gyldig eller lengden bør være mellom 1 og 50 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9173: 'Primærtelefon2 er ugyldig eller lengden bør være mellom 8 og 10.',
      REMOVE_ACCESS_SUCCESS: 'Fjerning av bruker fullført',
      TOAST_ERROR_MERGE_ASSET_9004: 'Forespurte data ble ikke funnet',
      CREATE_CUSTOMER_ERROR_CODE_9166: 'Sekundær kontaktkommentar er ikke gyldig eller lengden bør være mindre enn eller lik 255 tegn.',
      CREATE_CUSTOMER_ERROR_CODE_9076: 'Sekundær landskode er ikke gyldig eller lengden bør være mindre enn eller lik 4 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9176: 'Sekundær landskode2 er ikke gyldig eller lengden må være mindre enn eller lik 4 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9077: 'Sekundær e-post er ikke gyldig eller lengden bør være mindre enn eller lik 75 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9152: 'Sekundært fornavn er ikke gyldig eller lengden bør være mellom 1 og 50 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9153: 'Sekundært etternavn er ikke gyldig eller lengden bør være mellom 1 og 50 tegn',
      CREATE_CUSTOMER_ERROR_CODE_9147: 'Sekundært telefonnummer er ugyldig eller lengden bør være mellom 8 og 10.',
      CREATE_CUSTOMER_ERROR_CODE_9174: 'Sekundært telefonnummer 2 er ugyldig eller lengden bør være mellom 8 og 10.',
      CREATE_MAINTAINANCE_ERROR_CODE_9009: 'Sikkerhetstoken må ikke være null eller tom',
      CREATE_MAINTAINANCE_ERROR_CODE_9222: 'Tjenestelederrettigheter kreves for å opprette vedlikeholdsaktivitet',
      CREATE_MAINTAINANCE_ERROR_CODE_9162: 'SLA-nummeret er ikke gyldig eller lengden bør være mellom 6 og 12 tegn',
      INVITE_TECHNICIAN_ERROR_CODE_9158: 'Noen enheter har begrenset rolle fra inviterte-av-roller',
      INVITE_USER_ERROR_CODE_9158: 'Noen enheter har begrenset rolle fra inviterte-av-roller.',
      INVITE_TECHNICIAN_ERROR_CODE_9160: 'Noen enheter har begrenset rolle i invitasjonsforespørsel',
      INVITE_USER_ERROR_CODE_9160: 'Noen enheter har begrenset rolle i invitasjonsforespørsel.',
      TOAST_ERROR_MERGE_ASSET_9211: 'Kilde- og destinasjonsbygnings-ID er de samme',
      TOAST_ERROR_MERGE_ASSET_9212: 'Kildebygning og Destinasjonsbygning er ikke under samme organisasjon',
      TOAST_ERROR_LINK_CUSTOMER_9204: 'Systemet er allerede koblet til gyldig SLA',
      INVITE_USER_ERROR_CODE_9223: 'Gjeldende bruker kan bare sende invitasjon til normal bruker.',
      INVITE_USER_ERROR_CODE_9224: 'Nåværende bruker kan ikke sende invitasjon til Service manager og PAAS Maanger.',
      CREATE_MAINTAINANCE_ERROR_CODE_9218: 'Dokumentet er større enn 2 MB eller duplikat eller ugyldig Base64-kodet PDF, JPEG eller PNG',
      REMOVE_ACCESS_ERROR_CODE_9001: 'Uautorisert tilgang',
      CREATE_CUSTOMER_ERROR_CODE_9001: 'Uautorisert tilgang',
      CREATE_MAINTAINANCE_ERROR_CODE_9001: 'Uautorisert tilgang',
      CREATE_CUSTOMER_ERROR_CODE_9000: 'Uautorisert tilgang til funksjoner',
      UPDATE_LOG_COMMENTS_API_FAILURE: 'Oppdatering av loggkommentarer mislyktes',
      REMOVE_ACCESS_ERROR_CODE_3060: 'Brukeren kan ikke fjerne egentilgang',
      TOAST_ERROR_UPDATE_USER_DETAILS: 'Oppdatering av brukerdetaljene mislyktes',
      INVITE_USER_ERROR_CODE_9142: 'Bruker er invitert til samme rolle.',
      INVITE_TECHNICIAN_SUCCESS: 'Brukerinvitasjon Send vellykket',
      TOAST_ERROR_MERGE_ASSET_9044: 'Brukerpassordet er ikke gyldig eller lengden bør være mellom 8 og 16 tegn',
      INVITE_TECHNICIAN_ERROR_CODE_9190: 'Brukerrolletypen er ikke gyldig inndata',
      INVITE_USER_ERROR_CODE_9190: 'Brukerrolletypen er ikke gyldig inndata.',
      TOAST_SUCCESS_UPDATE_USER_DETAILS: 'Brukeren er oppdatert',
      UPDATE_MAINTAINANCE_SUCCESS: 'Vedlikeholdsaktiviteten ble oppdatert',
      UPDATE_MAINTAINANCE_ERROR_CODE_9001: 'Uautorisert tilgang',
      UPDATE_MAINTAINANCE_ERROR_CODE_9009: 'Sikkerhetstoken må ikke være null eller tom',
      UPDATE_MAINTAINANCE_ERROR_CODE_9078: 'Beskrivelsen er ikke gyldig eller lengden må være mindre enn eller lik 255 tegn.',
      UPDATE_MAINTAINANCE_ERROR_CODE_9222: 'Rettigheter til serviceleder eller tekniker kreves for å utføre denne operasjonen',
      UPDATE_MAINTAINANCE_ERROR_CODE_9227: 'Vennligst oppgi gyldig vedlikeholds-ID',
      UPDATE_MAINTAINANCE_ERROR_CODE_9245: 'Vedlikeholdsaktivitet har allerede samme gjeldende billettstatus som forespurt for oppdatering',
      UPDATE_MAINTAINANCE_ERROR_CODE_9246: 'Grensen for gjenåpning av vedlikeholdsaktivitet er nådd',
      UPDATE_MAINTAINANCE_API_FAILURE: 'Oppdatering av vedlikeholds-api mislyktes',
      TICKET_CLOSED_SUCCESS: 'Servicebilletten ble lukket',
},
    MY_ORGANIZATION_DETAILS: {
      ADDRESS_Line1: 'Adresselinje 1',
      ADMINS: 'Administratorer',
      DELETE_FOREVER: 'Slett for alltid',
      DESCRIPTION: 'Beskrivelse (valgfritt)',
      EDIT_BUILDING: 'Rediger bygning',
      EDIT_ORGANIZATION: 'Rediger organisasjon',
      NAME_DESCRIPTION: 'Navn og beskrivelse',
      SAVE_ORGANIZATION: 'Lagre organisasjon',
      TRANSFER_BULDING_ANOTHER_ORGANIZATION: 'Overfør bygninger til en annen organisasjon',
      VIEWER: 'Seere',
},
    INVITE_USER: {
      ADMIN: 'Admin',
      ADVANCE_INVITATION: 'Avansert invitasjon',
      ADVANCE_INVITE: 'Avansert...',
      ADVANCE_INVITE_CLOSE: 'Er du sikker på at du vil avslutte avansert invitasjon?',
      AS_ADMIN: 'Som Admin',
      AS_VIEWER: 'Som seer',
      BUILDING_ACCESS: 'Bygningstilgang',
      ENTER_USER_EMAIL: 'E-post eller brukernavn',
      GRANT_ACCESS_HEADER: 'Gi tilgang til nye eller eksisterende brukere.',
      ADVANCE_DES_CONTENT: 'Gi tilgang til brukere for spesifikk tilgang til organisasjoner, bygninger og systemer.',
      GRANT_ADMIN_ACCESS: 'Gi full tilgang til alt innenfor det tildelte nivået.',
      GRANT_VIEW_ACCESS: 'Gi visningsprivilegier til alt innenfor et tildelt nivå.',
      SEND_INVITE_FAILURE: 'Sending av invitasjon mislyktes',
      SEND_INVITE_SUCCESS: 'Invitasjonen ble sendt',
      INVITATION_ACCEPTED: 'Invitasjonen ble godtatt.',
      INVITATION_DENIED: 'Invitasjonen ble avslått.',
      INVITE_AND_ASSIGN: 'Inviter og tildel',
      INVITE_AS_COLLEGUE: 'Inviter som kollega',
      INVITE_USER: 'Inviter bruker',
      LIMITED: 'Begrenset',
      GRANT_LIMITED_ACCESS: 'Minimumsprivilegier, dette er nyttig for en bruker som bare trenger å overvåke ett system i en bygning.',
      NOBUILDING_AVAILABLE: 'Ingen bygninger tilgjengelig',
      NOSYSTEMS_AVAILABLE: 'Ingen systemer tilgjengelig',
      ORGANIZATION_ACCESS: 'Organisasjonstilgang',
      SELECT_ORGANIZATION: 'Velg en organisasjon',
      PRIVILEGES: 'Privilegier',
      RECEIVED: 'Mottatt',
      SEND_INVITE: 'Send invitasjon',
      SENT_BY: 'Sendt av',
      SYSTEM_ACCESS: 'Systemtilgang',
      VIEWER: 'Seer',
      ERROR_MESSAGE: 'Forespørselen din har blitt mislykket',
},
    DISCLAMIER: {
      OVERVIEW: 'Alarmtelling representerer alle aktive alarmer',
      TIMELINE: 'Alarmer som vises representerer alle alarmer i løpet av de siste 90 dagene',
},
    LUMINARY_DETAILS: {
      ALL_ATSD: 'Alle ATSD',
      ALL_CIRCUIT: 'Alle kretser',
      ALL_STATUSES: 'Alle statuser',
      ATSD: 'ATSD #',
      CIRCUIT: 'Krets',
      LUMINAIRE_ADDRESS: 'Armaturadresse',
      MODEL: 'Modell',
      TYPE: 'Type',
      TESTS: 'Tester',
      CIRCUIT_TITLE: 'Krets #',
      DURATION_TEST_DURATION: 'Varighet Test Varighet',
      PREVIOUS_DURATION_TEST_STARTED: 'Forrige varighet Test startet',
      PREVIOUS_FUNCTIONAL_TEST_STARTED: 'Tidligere funksjonstest startet',
},
    SEARCH: {
      ALL_BUILDINGS: 'Alle bygninger',
      ALL_GATEWAYS: 'Alle gatewayer',
      ALL_ORGANIZATIONS: 'Alle organisasjoner',
      ALL_STATUSES: 'Alle statuser',
      ALL_SYSTEMS: 'Alle systemer',
      ALL_TYPES: 'Alle typer',
},
    CUSTOMER_DETAILS: {
      ALL_USERS: 'Alle brukere',
      DELETE_SLA: 'Er du sikker på at du vil slette SLA',
      BACK_UP_PHONE: 'Backup telefon',
      BUYER_HEADER: 'Kjøper',
      BUYER: 'Kjøper',
      CONTACT_TYPE: 'Kontakttype',
      CONTACT_PERSON_ON_SITE: 'Kontaktperson på stedet',
      CUSTOMER_HEADER_SUBTITLE: 'Kunde',
      CUSTOMER_ID: 'Kunde-ID',
      CUSTOMER_NAME: 'Kundens navn',
      CUSTOMER_DETAILS_HEADER: 'Kundens navn og adresse',
      CUSTOMER_NAME_LABEL: 'Kundens navn eller nummer',
      CUSTOMER_NUMBER: 'Kundenummer',
      DELETE_CUSTOMER: 'Slett kunde',
      LUMINARY_INFO: 'Inkluderer denne kontrakten armaturovervåking?',
      EDIT_CUSTOMER_INFO: 'Rediger kundeinformasjon',
      CREATE_CUSTOMER_HEADER: 'Rediger kundeinformasjon',
      EDIT_PLATFORM_INFO: 'Rediger plattforminformasjon',
      EDIT_SLA_DETAILS: '-',
      EXPIRES: 'Utløper',
      IMAGES: 'Bilder',
      INCLUDE_LUM_MONITORING: 'Inkluder armaturovervåking',
      SLA_DETAILS_TEXT: 'Armaturovervåking inkludert',
      CALENDAR_HELPER_TEXT: 'mm/dd/åååå',
      MOBILE_NUMBER: 'Mobilnummer',
      LUMINARY_MONITORING_NO: 'Ingen',
      NO_CUSTOMER_FOUND: 'Ingen kunde funnet',
      NO_SERVICE_MANAGER_FOUND: 'Ingen tjenesteleder funnet',
      NO_TECHNICIAN_FOUND: 'Ingen tekniker funnet',
      CUSTOMER_NUMBER_HELPER_TEXT: 'Kun alfabeter og tall',
      SLA_NUMBER_HELPER_TEXT: 'Kun alfabeter og tall',
      OFFICE_NUMBER: 'Kontornummer',
      IMAGE_REQUIREMENTS: 'PNG, JPG (100x100px), 2 MB Maks.',
      PHONE_NUMBERS_HEADER: 'Primær- og reservetelefonnumre',
      PRIMARY_CONTACT_INFO: 'Primær kontaktinformasjon',
      PROJECT_LEAD: 'Prosjektleder',
      REMOVE_IMAGE: 'Fjern bilde',
      SECONDARY_CONTACT_INFO: 'Sekundær kontaktinformasjon',
      FILE_RESOLUTION_ERROR: 'Den valgte filen samsvarer ikke med ønsket oppløsning',
      FILE_SIZE_ERROR: 'Den valgte filstørrelsen overskrider maksimal tillatt filstørrelse',
      SERVICE_MANAGER: 'Serviceleder',
      SLA_CUSTOMER_NUMBER: 'SLA-kundenummer',
      SLA_DETAILS_HEADER: 'SLA-detaljer',
      SLA_EXPIRATION_DATE: 'SLA utløpsdato',
      TECH_LEAD_HEADER: 'Teknisk leder',
      TECHNICAL_PERSON: 'Teknisk person',
      UPLOAD_AVATAR_LOGO: 'Last opp avatarlogo',
      LUMINARY_MONITORING_YES: 'Ja',
      REQUIRED_FIELD_MESSAGE: 'Felter med en stjerne (*) er obligatoriske',
},
    USER_MANAGEMENT: {
      ALL_USERS: 'Alle brukere',
      INVITE_USER: 'Inviter bruker',
      YOUR_DETAILS: 'Dine detaljer',
},
    USERDETAILS: {
      DELETE_USER_SUBHEADER: 'Alle brukerdataene dine vil gå permanent tapt.',
      RESET_PASSWORD_ERROR: 'Kunne ikke tilbakestille passordet ditt nå.',
      DELETE_USER_BUTTON_TEXT: 'Slett konto for alltid',
      DELETE_USER_FAILURE_MSG: 'Kunne ikke slette. Prøv etter en stund',
      DELETE_USER_POP_UP_HEADER: 'Vil du slette kontoen «{{email}}» permanent?',
      RESET_PASSWORD_SUCCESS: 'Tilbakestill passord e-post sendt.',
      EDIT_SUCCESS: 'Brukeren er oppdatert',
      DELETE_USER_SUCCESS_MSG: 'Kontoen din er slettet',
},
    ATPLUS_LOGBOOK_EVENTNAME: {
      MAXIMUM_LOGIN_ATTEMPTS_EXCEDDED: 'Tillatte påloggingsforsøk er overskredet',
      BATTERY_CHARGE_FAILURE: 'Batteriladingsfeil oppdaget',
      BATTERY_DURATION_FAILURE: 'Batterivarighetsfeil oppdaget',
      TLAT_PLUS_BATTERY_FAILURE: 'Batterifeil',
      TLAT_PLUS_BATTERY_LOW: 'Lavt batteri',
      COMMUNICATION_FAILURE: 'Kommunikasjonsfeil oppdaget',
      DRY_CONTACT_INPUT: 'Tørr kontaktinngang aktivert',
      DRY_CONTACT_OUTPUT: 'Tørr kontaktutgang aktivert',
      MANUAL_DURATION_TEST: 'Varighet Test startet',
      MANUAL_DURATION_TEST_CANCELED: 'Varighet Test stoppet',
      FACTORY_RESET: 'Fabrikkinnstilling',
      FAILURE_THRESHOLD_EXCEEDED: 'Feilterskel overskredet',
      FIRMWARE_UPDATE_FAILURE: 'Fastvareoppdatering mislyktes',
      FIRMWARE_UPDATE_SUCCESS: 'Fastvareoppdatering vellykket',
      MANUAL_FUNCTION_TEST: 'Funksjonstest startet',
      MODBUS_COMMUNICATION_FAILURE: 'Gateway-kommunikasjonsfeil',
      UART_COMMUNICATION_FAILURE: 'Intern svikt',
      LAMP_FAILURE: 'Lampefeil oppdaget',
      LOCAL_MAIN_FAILURE: 'Lokalt strømbrudd',
      PASSWORD_CHANGE: 'Endring av passord',
      PASSWORD_RESET: 'Tilbakestill passord',
      MANUAL_RELIGHT_COMMAND: 'Relight aktivert',
      MANUAL_REST_COMMAND: 'Hvile aktivert',
      SEARCH_ALL_LAMP_COMPLETED: 'Søk i all lampe fullført',
      SEARCH_NEW_LAMP_COMPLETED: 'Søket etter ny lampe fullført',
      MANUAL_SYNCHRONIZE_TEST_TIME_COMMAND: 'Synkroniser testtider',
      ACTIVATION: 'Systemaktivering fullført',
      SYSTEM_POWER_DOWN: 'Slå av systemet',
      SYSTEM_POWER_UP: 'Systemet slås på',
      DATALINE_FAILURE: 'TLAT+ kommunikasjonslinjefeil',
      MANUAL_START_VISIBILITY_PLUS: 'Synlighet + Startet',
      MANUAL_STOP_VISIBILITY_PLUS: 'Sikt + Stoppet',
},
    MY_ORGANIZATION: {
      ALPHABET: 'Alfabet',
      CITY: 'By',
      NUMBER_SYSTEM: 'Antall systemer',
},
    FIRMWARE_UPDATE: {
      FIRMWARE_UPDATE_ALERT_TITILE: 'Er du sikker på at du vil avslutte?',
      CURRENT_VERSION: 'Gjeldende versjon',
      FIRMWARE_ALREADY_UPDATED: 'Firmware Allerede oppdatert',
      FIRMWARE_UPDATE_FAILED_TITLE: 'Fastvareoppdatering mislyktes',
      FIRMWARE_PROGRESS_MSG: 'Fastvareoppdatering pågår...',
      FIRMWARE_UPDATE_ALERT_SUB_TITILE: 'Fastvareoppdatering pågår fortsatt. Vil du gå til Dashboard?',
      FIRMWARE_UPDATE_FAILED: 'Fastvareoppdateringsprosessen har mislyktes. Vennligst prøv igjen.',
      FIRMWARE_VERSION_UPDATED: 'fastvareoppgraderingen er fullført',
      FIRMWARE_ALREADY_UPDATED_TEXT: 'Fastvareversjonen er allerede oppdatert til siste versjon',
      FIRMWARE_NOT_AVAILABLE: 'Fastvareversjonen ble ikke hentet på riktig måte. Logg ut fra mobilappen og logg på for å prøve igjen.',
      LATEST_VERSION: 'Siste versjon',
      LOST_BLUETOOTH_CONNECTION: 'Mistet Bluetooth-tilkobling',
      ENTRY_PASSWORD: 'Vennligst skriv inn systempassordet for',
      RELEASED_ON: 'Utgitt på',
      SELECT_FIRMWARE_VERSION: 'Velg en fastvareversjon',
      SELECT_A_VERSION: 'Velg en versjon',
      UPDATE_TO_LATEST: 'Oppdater til siste',
      UPLOAD_FILE: 'Last opp fil',
      FIRMWARE_UPDATE_TITILE: 'Vi anbefaler at du oppdaterer  fastvaren til den nyeste versjonen.',
      FIRMWARE_UPDATEPOPUP_MSG: 'Du er ikke lenger koblet til',
},
    ASSETS: {
      ASSETS_DETAILS: 'Eiendeler detaljer',
},
    SYSTEM_TYPE: {
      ATPLUS: 'AT+',
      CGLINE: 'CGLine+',
      DGS: 'DG-S',
      LPSMART: 'LPSmart',
      LPSTAR: 'LPStar',
      WIRELESS: 'Trådløs',
      ZBS: 'ZBS',
      ATS_PLUS: 'AT-S+',
      GATEWAY: 'Inngangsport',
},
    DEVICE_TYPE_VALUE: {
      AT: 'AT+',
      ATS: 'AT-S+',
      CGLINE: 'CGLINE',
      DGS: 'DG-S',
      LPSMART: 'LP-SMART',
      LPSTAR: 'LP-STAR',
      WIRELESS: 'TRÅDLØST',
      ZBS: 'ZB-S',
      ATSPLUS: 'AT+',
},
    CONTROLLER_TYPE_VALUE: {
      AT: 'AT+',
      CGLINE_PLUS: 'CGLINE+',
      DGS: 'DG-S',
      LP_SMART: 'LP-SMART',
      LP_STAR: 'LP-STAR',
      WIRELESS: 'TRÅDLØST',
      ZBS: 'ZBS',
},
    ACTIONS: {
      BACK: 'Tilbake',
      CANCEL: 'Kansellere',
      CHANGE_LANGUAGE: 'Bytt språk her!',
      CLICK_BUTTON: 'Klikk på knappen',
      UPDATE_REDUX: 'Klikk på knappen for å oppdatere redux-butikkverdien!',
      CONFIRM: 'Bekrefte',
      CONTINUE: 'Fortsette',
      DELETE: 'Slett',
      RESEND_VERIFICATION_EMAIL_LABEL: 'Har du ikke mottatt e-post?',
      DISABLE: 'Deaktiver',
      DONE: 'Ferdig',
      DOWNLOAD_DATA: 'Last ned data',
      EDIT: 'Redigere',
      ENABLE: 'Aktiver',
      EXTEND: 'Forlenge',
      FINISH: 'Fullfør',
      GO_HOME: 'Gå til Hjem',
      GO_TO_DASHBOARD: 'Gå til Mitt Dashboard',
      GO_TEST: 'Gå til testsiden',
      LOG_IN: 'Logg inn',
      LOG_OUT: 'Logg ut',
      NEXT: 'Neste',
      OKAY: 'Ok',
      QUIT: 'Slutte',
      REMEMBER: 'Husk meg',
      RETRY: 'Prøv på nytt',
      SAVE: 'Spare',
      SAVE_ADD_ANOTHER: 'Lagre og legg til en annen',
      SEND: 'Sende',
      RESEND: 'Send på nytt',
      RESEND_VERIFICATION_EMAIL: 'Send på nytt',
      SUBMIT: 'Send inn',
      SUBMITCHANGES: 'Send inn endringer',
      TRANSFER: 'Overføre',
      UPDATE: 'Oppdater',
},
    NETWORK: {
      BAD_REQUEST_MESSAGE: 'Dårlig forespørsel',
      INTERNAL_SERVER_ERROR_MESSAGE: 'Intern serverfeil',
      NO_DATA_FOUND: 'Ingen data funnet',
      REQUEST_NOT_FOUND_MESSAGE: 'Ikke funnet',
      ERROR_INTERNET_CONNECTION: 'Ser ut til at du er tom for internettforbindelse og prøv igjen.',
      SERVICE_UNAVAILABLE: 'Tjenesten er ikke tilgjengelig',
      ERROR_NO_RESPONSE: 'Noe gikk galt',
      ERROR_MESSAGE_SENDING_REQUEST: 'Beklager, det oppsto et problem med å sende forespørselen din.',
      ERROR_INVALID_REQUEST: 'Beklager, forespørselen din er ugyldig.',
      NETWORK_ALERT_SUBTITILE: 'Dashbordet er utilgjengelig  fordi du ikke lenger er tilkoblet  til internett',
      ERROR_NOT_FOUND: 'Ressursen ble ikke funnet.',
      ERROR_ALERT_TITLTE: 'Kan ikke koble til Dashboard',
      UNAUTHORISED_REQUEST_MESSAGE: 'Uautorisert – Autorisasjon har blitt avvist for denne forespørselen',
      ERROR_RESTRICTED_USER_ACCESS: 'Brukeren har ikke tilgang til ressursen.',
},
    CONNECTION_TYPE_VALUE: {
      BLE: 'BLE',
      BLUETOOTH: 'bluetooth',
      CELLULAR: 'Cellular',
      ETHERNET: 'Ethernet',
      MODBUS: 'Modbus',
      MQTT: 'MQTT',
      RS485: 'RS485',
      WIFI: 'Wifi',
      WIREPAS: 'Wirepas',
},
    STATUS: {
      STATUS_BLOCK: 'Blokkert',
      BLOCKED: 'Blokkert',
      STATUS_EMPTY: 'Tømme',
      STATUS_ERROR: 'Feil',
      ERROR: 'Feil',
      EVENT: 'Hendelse',
      DT: 'I DT',
      STATUS_DT: 'I test',
      INTEST: 'I test',
      STATUS_OFFLINE: 'Frakoblet',
      STATUS_READY: 'Ferdig',
      READY: 'Ferdig',
      TOTAL_LUMINAIRES: 'Totalt armaturer',
      TOTAL_SYSTEM: 'Totale systemer',
      STATUS_WARNING: 'Advarsel',
      WARNING: 'Advarsel',
},
    UNSUPPORTED_BROWSER: {
      NOT_SUPPORTED: 'Nettleser støttes ikke',
      INCOMPATIBLE_BROWSER: 'Dette systemet er ikke knyttet til en kunde',
      RECOMMENDED_BROWSER: 'Vi anbefalte å oppgradere til den nyeste versjonen av Microsoft Edge, Safari, Firefox eller Chrome for å bruke dette verktøyet.',
},
    ENTITY_TYPE: {
      BUILDING: 'Bygning',
      DEVICE: 'Enhet',
      DEVICE_TYPE: 'Enhetstype',
      GATEWAY: 'Inngangsport',
      LUMINARY: 'Lysende',
      MASTER_ROLE: 'Mesterrolle',
      ORGANIZATION: 'Organisasjon',
      ORGANIZATION_STATISTIC_DETAIL: 'Organisasjonsstatistiske detaljer',
      PLATFORM: 'Plattform',
      SYSTEM: 'System',
      USER: 'Bruker',
},
    LOGSOURSE_DEVICE_TYPE: {
      BUILDING: 'Bygning',
      DEVICE: 'Enhet',
      DEVICETYPE: 'DeviceType',
      GATEWAY: 'Inngangsport',
      LUMINARY: 'Lysende',
      MASTERROLE: 'Mesterrolle',
      ORGANIZATION: 'Organisasjon',
      ORGANIZATIONSTATISTICALDETAIL: 'OrganizationStatistical Detail',
      SYSTEM: 'System',
      USER: 'Bruker',
},
    TECHNICIAN_DETAILS: {
      BUILD_ADMIN: 'Bygningsadmin',
      BUILD_VIEWER: 'Building Viewer',
      CUST_VIEWER: 'Kundevisning',
      INDIVIDUAL_DETAILS: 'Individuelle detaljer',
      LIMT_ACCESS: 'Begrenset tilgang',
      ORG_ADMIN: 'Organisasjonsadmin',
      ORG_VIEWER: 'Organisasjonsvisning',
      PASS_SERVICE_MANAGER: 'Pass Service Manager',
      PROJ_OWNER: 'Prosjekteier',
      REMOVE_USER: 'Fjern bruker',
      SERVICE_MANAGER: 'Serviceleder',
      SYSTM_ADMIN: 'Systemadmin',
      SYSTM_VIEWER: 'System Viewer',
      TECHNICIAN: 'Tekniker',
      USER_DETAILS: 'Brukerdetaljer',
      COMPANY_DETAILS: 'Firmadetaljer',
      COMPANY: 'Bedrift',
      STATUS: 'Status',
},
    TRANSFER_BUILDING_TO_ORGANIZATION: {
      TRANSFER_SUCCESS: 'Bygningen er vellykket overført til annen organisasjon',
      CONFIRM_PASSWORD: 'Bekreft passord',
      INSTRUCTIONS: 'Overfør permanent alle {{buildingCount}} bygninger inkludert alle {{systemCount}} gatewayer og {{gatewayCount}} systemer.',
      ORG_SELECT: 'Velg gyldig organisasjon',
      INSTRUCTION_TWO: 'Vennligst skriv inn organisasjonens administratorkontopassord for å bekrefte handlingen',
      TRANSFER: 'Overføre',
      HEADER_TITLE: 'Overfør bygningen til en annen organisasjon \n \n organisasjon',
      DROPDOWN_LABEL: 'Overfør til...',
},
    CHANGE_PASSWORD_SCREEN: {
      CHANGE_PASSWORD: 'Endre passord',
      CONFIRM_PASSWORD: 'Bekreft passord',
      NEW_PASSWORD: 'Nytt passord',
},
    MESSAGES: {
      CONGRATS: 'Gratulerer!',
      CONTACT: 'Kontakt en Eaton-støtterepresentant',
      EMAIL_SENT: 'E-post sendt',
      ERROR: 'Feil!',
      FAILURE: 'Feil',
      LOADING: 'Laster inn...',
      EMAIL_ENTRY_ERROR: 'Vennligst skriv inn en gyldig e-post',
      SUCCESS: 'Suksess',
      WELCOME: 'Velkomst!',
      LOGIN_MESSAGE: 'Du er "logget inn".',
},
    LANDING_SCREEN: {
      CONNECT_NOW: 'Koble til nå',
      CONNECT_TO_SYSTEM: 'Koble til systemer',
      CONTINUE_TO_DASHBOARD: 'Fortsett til Dashboard',
      DASHBOARD_UNAVAILABLE: 'Dashboard utilgjengelig',
      NO_INTERNET_CONNECTION: 'Ingen Internett-tilkobling',
      VIEW_DASHBOARD: 'Vis Dashboard',
      IN_PROGRESS: 'Arbeid pågår...',
},
    USERS: {
      CREATE_NEW_CUSTOMER: 'Opprett ny kunde',
      EDIT_PLATFORM_HEADER: 'Rediger plattform',
      EDIT_PLATFORM_SUCCESS_200: 'Plattform oppdatert',
      LOADER_HELPER_TEXT: 'Vennligst vent',
      MANAGE_PLATFORM_ERROR_CODE_3047: 'Main Service Manager er ikke registrert på BSMS. Kan ikke lage plattform',
},
    LABELS: {
      CSV: 'CSV',
      EMAIL: 'E-postadresse',
      EXCEL: 'Excel-fil',
      FORGOT_PASSWORD: 'Glemt passordet ditt?',
      GROUP_BY: 'Grupper etter:',
      ITEMS_PER_PAGE: 'Elementer per side',
      LOGGING_IN: 'Logger inn',
      NEED_ACCOUNT: 'Trenger du en konto?',
      NEW_PASSWORD: 'Nytt passord',
      PASSWORD: 'Passord',
      PDF: 'PDF',
      SHOW: 'Vise:',
      SIGN_UP: 'Registrer deg',
      TIME_RANGE: 'Tidsområde:',
      TO_BE_IMPLEMENTED: 'Skal implementeres',
      VIEW_ALL_EVENTS: 'Se alle {{count}} hendelser',
      SIGN_IN_WITH_OKTA: 'Logg på med Okta',
},
    AUTO_LOGOUT_DISABLED: {
      AUTO_LOGOUT_DISABLED: 'Funksjonshemmet',
},
    TIMELINE_EXPORT: {
      DOWNLOAD_TITLE: 'Last ned tidslinjedata',
      DOWNLOAD_SUBTITLE_SITE: 'Velg datoperiode for alarmhistorikk du vil eksportere.',
      DOWNLOAD_SUBTITLE_TIMELINE: 'Velg plasseringen og datointervallet for alarmhistorikken du vil eksportere.',
},
    AUTO_LOGOUT_ENABLED: {
      AUTO_LOGOUT_ENABLED: 'Aktivert (anbefalt)',
},
    LEAGAL: {
      END_USER_AGREEMENT: 'Sluttbrukeravtale',
      LICENCE_AGREEMENT: 'Sluttbrukerlisensavtale',
      LEAGAL: 'Lovlig',
      MANUALS: 'HÅNDBOKER',
      OPEN_SOURCE: 'Åpen kildekode-lisenser',
      INSTRUCTION_EATON_BSMS_GATEWAY: 'Bruksanvisning for Eaton BSMS Gateway',
      QUICK_START_GUIDE: 'Hurtigstartguide',
      REMOTE_MONITORING_GUIDE: 'Veiledning for fjernovervåking',
      TERMS_CONDITIONS: 'Vilkår og betingelser',
},
    LEGAL: {
      EULA: 'Sluttbrukerlisensavtale',
      TITLE: 'Lovlig',
      OPENSOURCELICENSES: 'Åpen kildekode-lisenser',
      TERMSANDCONDITIONS: 'Vilkår og betingelser',
      REACT_NATIVE: 'Reager Native',
      EULA_WIRELESS: 'EULA - Eaton Wireless Controller',
      OSS: 'Open source licensing - Eaton Wireless Controller',
      OPEN_SOURCE_BSM: 'Open source licensing - Building Safety Manager',
},
    EVENT_TIMELINE: {
      ERROR_LOADING_MORE_EVENTS: 'Feil ved innlasting av flere hendelser',
      LOAD_MORE_EVENTS: 'Last inn {{count}} flere hendelser',
},
    ASSETS_SCREEN: {
      FAVORITE_LIMIT_REACHED: 'Favorittgrensen er nådd',
      NOBUILDINGFOUND: 'Ingen bygninger funnet',
      NOGATEWAYFOUND: 'Ingen gatewayer funnet',
      NOORGANIZATIONFOUND: 'Ingen organisasjon funnet',
      NOREPORTFOUND: 'Ingen rapporter funnet',
      NOSYSTEMS: 'Ingen systemer funnet',
      OTHERS: 'ANDRE',
      SHOW_ONLY_STARRED_BUILDING: 'Vis kun stjernemerkede bygninger',
      STARRED: 'STJERNEMERKET',
      MARK_AS_FAV_API_SUCCESS: 'Lagt til favoritt',
      REMOVE_MARK_AS_FAV_API_SUCCESS: 'Fjernet fra favoritt',
      MARK_AS_FAV_API_FAILURE_MESSAGE: 'Fjern noen av dine eksisterende favoritter før du legger til nye, da maksimumsgrensen er 10',
},
    ADDLOCATION: {
      ASTERIKSINFO: 'Felt merket med en stjerne(*) er obligatoriske felt {{entity}}.',
      ADDLOCATIONINFORMATION: 'Stedsprofilinformasjon',
},
    HEADER: {
      FORGOT_PASSWORD: 'Glemt passord',
},
    LOGIN: {
      INVALID_CREDENTIALS: 'Ditt brukernavn/passord-kombinasjon gjenkjennes ikke.',
      GENERIC_ERROR: 'Forespørselen din kunne ikke behandles på dette tidspunktet.',
      UNAUTHORIZED_ACCESS: 'Uautorisert tilgang',
      UNAUTHORIZED_ACCESS_MESSAGE: 'Du er ikke autorisert til å få tilgang til denne applikasjonen. Vennligst registrer deg',
},
    TABS: {
      LIST_VIEW: 'Listevisning',
      SUMMARY_VIEW: 'Sammendragsvisning',
},
    NAVIGATION_TABS: {
      LOGBOOK: 'LOGGBOK',
      STATUS: 'STATUS',
},
    HELPANDFEEDBACK: {
      MANUALS: 'Håndbøker',
      TITLE: 'Bruksanvisning for Eaton BSMS Gateway',
},
    OPERATING_SYSTEM_THEME: {
      OPERATING_SYSTEM_THEME: 'Operativsystemtema',
},
    EULA: {
      OTHER_LANGUAGE: 'Andre språk EULA',
},
    LOCATIONS: {
      SITES: 'Nettsteder',
},
    COUNTER: 'Verdien er: {{count}}',
    RESPONSE: {
      USER_REGISTERED: 'Bruker kan registreres',
},
    PASSWORD_RESET: {
      SUCCESS_MESSAGE: 'Passordet ditt ble tilbakestilt.',
      FAILURE_MESSAGE: 'Passordet ditt kunne ikke tilbakestilles. Vennligst prøv igjen senere.',
},
    LICENCE: {
       LICENCE_AGREEMENT: 'Lisensavtale',
      OPEN_SOURCE: 'Åpen kildekode-lisenser',
      REACT_NATIVE_LICENCE: {
        MIT_LICENSE: 'MIT-lisens',
        COPYRIGHT_TEXT: 'Opphavsrett (c) Facebook, Inc. og dets tilknyttede selskaper.',
        MIT_LICENSE_TEXT: 'Tillatelse gis herved, gratis, til enhver person som skaffer seg en kopi av denne programvaren og tilhørende dokumentasjonsfiler ("Programvaren"), til å handle med Programvaren uten begrensning, inkludert uten begrensning rettighetene til å bruke, kopiere, modifisere, slå sammen, publisere, distribuere, underlisensiere og/eller selge kopier av Programvaren, og tillate personer som er underlagt følgende betingelser for Programvaren:',
        MIT_LICENSE_TEXT_ONE: 'Ovennevnte copyright-melding og denne tillatelsesmeldingen skal inkluderes i alle kopier eller vesentlige deler av programvaren.',
        MIT_LICENSE_TEXT_TWO: 'PROGRAMVAREN LEVERES "SOM DEN ER", UTEN GARANTI AV NOEN SLAG, UTTRYKKELIGE ELLER UNDERFORSTÅTTE, INKLUDERT MEN IKKE BEGRENSET TIL GARANTIER FOR SALGBARHET, EGNETHET FOR ET BESTEMT FORMÅL OG IKKE-KRENKELSE. UNDER INGEN OMSTENDIGHET SKAL FORFATTERNE ELLER OPPHAVSRETTESSINNEHAVENE VÆRE ANSVARLIGE FOR NOEN KRAV, SKADER ELLER ANNET ANSVAR, ENTEN I EN KONTRAKTSHANDLING, TORT ELLER ANNET, SOM STÅR AV, UTENFOR ELLER I FORBINDELSE MED DET ANDRE SOFTWAREN.',
},
},
    WIRELESS_GATEWAY: {
      WIRELESS_SEARCHLUMINAIRE_HEADLINE: 'Søk etter alle armaturer vil opprette en ny konfigurasjon ved å gjøre følgende:',
      WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_ONE: 'Søk etter alle installerte og adresserte armaturer',
      WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_TWO: 'Hvis du starter søket, slettes alle aktiverte, defekte armaturer fra konfigurasjonen din',
      WIRELESS_SEARCH_ALL_LUMINARIES_WARNING: 'Hvis du bare trenger å legge til armaturer, vennligst bruk alternativet Søk etter nye armaturer.',
      WIRELESS_SEARCH_ALL_LUMINARIES_ACTION_NON_CANCELLABLE: 'Denne handlingen kan ikke angres.',
      WIRELESS_SEARCH_ALL_LUMINARIES_DIALOG_TEXT: 'Hvis du starter søket, slettes alle aktiverte armaturer med en defekt fra konfigurasjonen din',
      WIRELESS_RETRY_SEARCH: 'Prøv å søke på nytt',
      WIRELESS_CONFIGURE_LUMINARIES: 'Konfigurer armaturer',
      CONFIGURE_LUMINAIRES: 'Konfigurer armaturer',
      ZONE_DESCRIPTION: 'Beskrivelse',
},
    STAGE_GROUP: {
      SELECT_STAGE_GROUP: 'Velg Stage Group',
},
    NOTIFICATION_KEYS: {
      NOTIFICATION_ALARM_BODY: 'En {{logType}} har oppstått med følgende system',
      NOTIFICATION_HEALTH_REPORT_TITLE: 'Ny rapport tilgjengelig – {{org}}',
      NOTIFICATION_HEALTH_REPORT_BODY: 'En ny månedlig rapport for {{bygning}} er tilgjengelig for visning',
},
    DRY_CONTACT: {
      DRY_CONTACT: 'Tørr kontakt',
      DRY_CONTACT_STATUS: 'Tørr kontaktstatus',
      DEFAULT_SETTINGS: 'Standardinnstillinger',
      IOSTATUS: {
        START_FUNCTIONAL_TEST: 'Start funksjonstest',
},
      START_FUNCTIONAL_TEST: 'Start funksjonstest',
      NORMALLY_OPEN: 'Normalt åpen',
      BATTERY_OPERATION: 'Batteridrift',
},
    ACCOUNT_PREFERENCES: {
      CEST: 'Sentraleuropeisk tid (GMT-1:00)',
},
    SLA: {
      TECHNICIAN: 'Tekniker',
      UNASSIGNED: 'Ikke tilordnet',
      STATUS_TODAY: 'I dag',
      STATUS_SCHEDULED: 'Planlagt',
      STATUS_DUE: 'Forfalt',
},
},
};
 export default resources;
